import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null | undefined;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /**
   * Custom scalar for date/time values.
   * ISO 8601 format (e.g., "2026-01-06T18:00:00.000Z")
   */
  DateTime: { input: string; output: string; }
  /**
   * JSON scalar for arbitrary JSON values.
   * Used in JSON Patch operations where values can be of any type.
   * @implements FS-002.8.2 - JSON Patch Protocol
   */
  JSON: { input: any; output: any; }
};

/**
 * Acceptance criterion scope determining which dev agent handles fixes.
 * @implements FS-008.4.3.1 - ACScope enum
 */
export type AcScope =
  /** API/service issues, handled by backend-dev */
  | 'BACKEND'
  /** UI/component issues, handled by frontend-dev */
  | 'FRONTEND';

/**
 * Acceptance criterion test status.
 * @implements FS-008.4.3.1 - ACStatus enum
 */
export type AcStatus =
  /** Cannot test due to external dependency */
  | 'BLOCKED'
  /** Test failed */
  | 'FAIL'
  /** Test passed */
  | 'PASS'
  /** Not yet tested */
  | 'PENDING';

/**
 * Acceptance criterion type determining test methodology.
 * BROWSER requires browser interaction, API_ONLY can be validated via API calls.
 * @implements FS-008.4.3.1 - ACType enum
 * @implements BS-008.4.3.1 - User Story Browser AC Requirement
 */
export type AcType =
  /** Can be validated via API calls only (Technical Stories only) */
  | 'API_ONLY'
  /** Requires browser interaction (mandatory for User Stories) */
  | 'BROWSER';

/**
 * Agent invocation record.
 * @implements FS-002.7.7 - Agent Invocations
 */
export type AgentInvocation = {
  __typename?: 'AgentInvocation';
  /** Type of agent that was invoked */
  agentType: AgentType;
  /** Timestamp when the agent completed (null if still working) */
  completedAt: Maybe<Scalars['DateTime']['output']>;
  /** Timestamp when the agent was launched */
  launchedAt: Scalars['DateTime']['output'];
  /** Current status of the invocation */
  status: AgentInvocationStatus;
};

/**
 * Agent invocation status.
 * @implements FS-002.7.7 - Agent Invocations
 */
export type AgentInvocationStatus =
  /** Agent completed successfully */
  | 'COMPLETED'
  /** Agent invocation failed */
  | 'FAILED'
  /** Agent is currently working */
  | 'IN_PROGRESS'
  /** Agent invocation is pending */
  | 'PENDING';

/**
 * Agent type for agent invocations.
 * @implements FS-002.7.7 - Agent Invocations
 */
export type AgentType =
  /** Agile project planner agent */
  | 'AGILE_PROJECT_PLANNER'
  /** Backend developer validation agent (NestJS, TDD, API design) */
  | 'BACKEND_DEVELOPER'
  /** Frontend developer validation agent (React, MobX, Material-UI) */
  | 'FRONTEND_DEVELOPER'
  /** Specification writer agent */
  | 'SPEC_WRITER';

/**
 * API key information (without the raw key).
 * Used for listing, display, and management operations.
 * @implements US-085 - API Key Management
 */
export type ApiKeyInfo = {
  __typename?: 'ApiKeyInfo';
  /** Whether the key is currently active (not revoked) */
  active: Scalars['Boolean']['output'];
  /** Timestamp when the key was created */
  createdAt: Scalars['DateTime']['output'];
  /** Unique identifier for the API key */
  id: Scalars['ID']['output'];
  /** Optional human-readable label */
  label: Maybe<Scalars['String']['output']>;
  /** Timestamp when the key was last used for authentication */
  lastUsedAt: Maybe<Scalars['DateTime']['output']>;
  /** First 8 characters of the key for identification */
  prefix: Scalars['String']['output'];
  /** Timestamp when the key was revoked (null if active) */
  revokedAt: Maybe<Scalars['DateTime']['output']>;
};

/**
 * Artifact type for referenced artifacts in messages.
 * @implements FS-002.7.7 - Referenced Artifacts
 */
export type ArtifactType =
  /** Reference to an epic */
  | 'EPIC'
  /** Reference to a milestone */
  | 'MILESTONE'
  /** Reference to a specification */
  | 'SPECIFICATION';

/**
 * Session information returned after successful login.
 * Contains user data and session expiration time.
 * @implements FS-001.5 - Session Management
 * @implements FS-003.5.2 - WebSocket Authentication
 */
export type AuthPayload = {
  __typename?: 'AuthPayload';
  /**
   * Session expiration timestamp (14 days from login)
   * @implements FS-001.5.1 - Session Duration
   */
  expiresAt: Scalars['DateTime']['output'];
  /**
   * Session token for WebSocket authentication.
   * Store in localStorage and pass in WebSocket connectionParams.
   * @implements FS-003.5.2 - WebSocket Authentication
   */
  sessionToken: Scalars['String']['output'];
  /** The authenticated user */
  user: User;
};

/**
 * A ticket available for pickup in a kanban column.
 * Used by jared_available to return pickable tickets.
 * @implements US-125 - jared_available Tool
 * @implements FS-008.4.3 AC-4.3.12 - Available tickets query
 */
export type AvailableTicket = {
  __typename?: 'AvailableTicket';
  /** Unique ticket identifier. */
  id: Scalars['ID']['output'];
  /** Parent ticket ID, null for top-level milestones. */
  parentId: Maybe<Scalars['ID']['output']>;
  /** Specification references (e.g., FS-001, BS-002). */
  specReferences: Array<Scalars['String']['output']>;
  /** Ticket title. */
  title: Scalars['String']['output'];
  /** Ticket type: MILESTONE, EPIC, USER_STORY, or TECHNICAL_STORY. */
  type: Scalars['String']['output'];
};

/**
 * Result of an availableTickets query.
 * @implements US-125 - jared_available Tool
 * @implements FS-008.4.3 AC-4.3.12 - Available tickets query
 * @implements BS-006.9 - Consolidation precondition
 */
export type AvailableTicketsResult = {
  __typename?: 'AvailableTicketsResult';
  /** Error classification if success is false. Null on success. */
  errorType: Maybe<ErrorType>;
  /** Rejection reason if success is false. Null on success. */
  rejection: Maybe<Scalars['String']['output']>;
  /** Whether the query succeeded. */
  success: Scalars['Boolean']['output'];
  /** Available tickets if success is true, empty array otherwise. */
  tickets: Array<AvailableTicket>;
};

/**
 * Business rule entity.
 * Stores business rules associated with specifications.
 * @implements FS-004.2.1 - Business Rule Structure
 */
export type BusinessRule = {
  __typename?: 'BusinessRule';
  /** Timestamp when the business rule was created */
  createdAt: Scalars['DateTime']['output'];
  /**
   * Optional examples for the business rule.
   * @implements FS-004.2.1
   */
  examples: Maybe<Scalars['String']['output']>;
  /**
   * Formatted business rule number as BS-XXX.
   * @implements FS-004.2.1
   */
  formattedNumber: Scalars['String']['output'];
  /**
   * Full identifier with specification prefix (BS-XXX.X).
   * @implements FS-004.2.1
   */
  fullIdentifier: Scalars['String']['output'];
  /** Unique identifier for the business rule */
  id: Scalars['ID']['output'];
  /**
   * Rationale for the business rule.
   * @implements FS-004.2.1
   */
  rationale: Scalars['String']['output'];
  /**
   * Business rule number (sequential within specification).
   * @implements FS-004.2.1
   */
  ruleNumber: Scalars['Int']['output'];
  /** ID of the specification this business rule belongs to */
  specificationId: Scalars['ID']['output'];
  /**
   * The business rule statement.
   * @implements FS-004.2.1
   */
  statement: Scalars['String']['output'];
  /** Timestamp when the business rule was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

/**
 * Diff for business rule ID changes.
 * @implements FS-004.3.1 - Edit Specification
 */
export type BusinessRuleIdsDiff = {
  __typename?: 'BusinessRuleIdsDiff';
  /** IDs of newly added business rules */
  added: Array<Scalars['ID']['output']>;
  /** IDs of removed business rules */
  removed: Array<Scalars['ID']['output']>;
};

/**
 * Input for changing an existing password.
 * Requires verification of current password.
 * @implements FS-001.2.2 - Password Authentication (Backup)
 */
export type ChangePasswordInput = {
  /** The user's current password for verification */
  currentPassword: Scalars['String']['input'];
  /**
   * The new password to set. Must meet complexity requirements:
   * - At least 8 characters
   * - At least one uppercase letter
   * - At least one lowercase letter
   * - At least one digit
   */
  newPassword: Scalars['String']['input'];
};

/**
 * Child reference for Technical Stories.
 * @implements FS-005.6.1 - User Story Template (Children)
 */
export type Child = {
  __typename?: 'Child';
  /** Reference to child ticket ID, or null if not yet created. */
  id: Maybe<Scalars['ID']['output']>;
  /** Display text for the child. */
  text: Scalars['String']['output'];
};

/**
 * Input for child references when creating/updating user stories.
 * @implements FS-005.6.1 - User Story Template (Children)
 */
export type ChildInput = {
  /** Reference to child ticket ID, or null if not yet created. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Display text for the child. */
  text: Scalars['String']['input'];
};

/**
 * A child reference within a ticket (e.g., an epic's user story or milestone's epic).
 * @implements TS-056.1 - ChildRef SDL type
 */
export type ChildRef = {
  __typename?: 'ChildRef';
  /** ID of the child ticket, null if not yet created. */
  id: Maybe<Scalars['ID']['output']>;
  /** Display text for the child reference. */
  text: Scalars['String']['output'];
};

/**
 * Groups tickets by their kanban column.
 * @implements TS-056.1 - ColumnTickets SDL type
 */
export type ColumnTickets = {
  __typename?: 'ColumnTickets';
  /** The kanban column. */
  column: KanbanColumn;
  /** All tickets in this column. */
  tickets: Array<KanbanTicket>;
};

/**
 * Conversation between Product Owner and AI PM.
 * @implements FS-002.7.4 - Conversation History Persistence
 * @implements BS-002.11 - AI PM Conversation is Project-Scoped
 */
export type Conversation = {
  __typename?: 'Conversation';
  /** Timestamp when the conversation was created */
  createdAt: Scalars['DateTime']['output'];
  /** Unique identifier for the conversation */
  id: Scalars['ID']['output'];
  /** Timestamp when the conversation last had activity */
  lastActivityAt: Scalars['DateTime']['output'];
  /**
   * Messages in this conversation.
   * Returns the most recent messages first, supporting pagination.
   * @implements FS-002.7.10 - Conversation Message Pagination
   */
  messages: Array<ConversationMessage>;
  /** ID of the project this conversation belongs to */
  projectId: Scalars['ID']['output'];
  /** Conversation status (active, archived) */
  status: ConversationStatus;
};


/**
 * Conversation between Product Owner and AI PM.
 * @implements FS-002.7.4 - Conversation History Persistence
 * @implements BS-002.11 - AI PM Conversation is Project-Scoped
 */
export type ConversationMessagesArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Message in a conversation.
 * @implements FS-002.7.7 - Conversation Message Structure
 */
export type ConversationMessage = {
  __typename?: 'ConversationMessage';
  /**
   * Agent invocations associated with this message.
   * Only present for AI_PM messages.
   * @implements FS-002.7.7 - Agent Invocations
   */
  agentInvocations: Maybe<Array<AgentInvocation>>;
  /** Message content (text, supports multiline) */
  content: Scalars['String']['output'];
  /** ID of the conversation this message belongs to */
  conversationId: Scalars['ID']['output'];
  /** Timestamp when the message was created */
  createdAt: Scalars['DateTime']['output'];
  /** Unique identifier for the message */
  id: Scalars['ID']['output'];
  /**
   * Referenced artifacts in this message.
   * @implements FS-002.7.7 - Referenced Artifacts
   */
  referencedArtifacts: Maybe<Array<ReferencedArtifact>>;
  /** Sender type: PRODUCT_OWNER or AI_PM */
  senderType: MessageSenderType;
};

/**
 * Conversation status enum.
 * @implements FS-002.7.4 - Conversation History Persistence
 */
export type ConversationStatus =
  /** Conversation is active and can receive new messages */
  | 'ACTIVE'
  /** Conversation is archived (read-only) */
  | 'ARCHIVED';

/**
 * Result of creating a new API key.
 * Contains both the key info and the raw key (shown only once).
 * @implements US-085 - API Key Management
 */
export type CreateApiKeyResult = {
  __typename?: 'CreateApiKeyResult';
  /** API key metadata */
  apiKey: ApiKeyInfo;
  /** Raw API key string. Only returned once at creation time. */
  rawKey: Scalars['String']['output'];
};

/**
 * Input for creating a new business rule.
 * @implements FS-004.2.1 - Business Rule Structure
 */
export type CreateBusinessRuleInput = {
  /** Optional examples */
  examples?: InputMaybe<Scalars['String']['input']>;
  /** Rationale for the business rule */
  rationale: Scalars['String']['input'];
  /** The business rule statement */
  statement: Scalars['String']['input'];
};

/**
 * Input for creating a new epic.
 * @implements FS-005.5.2 - Create Epic
 * @implements BS-005.6 - Epics Must Have Parent Milestone
 * @implements BS-005.10 - Epic Title Format
 */
export type CreateEpicInput = {
  /** Optional acceptance criteria. */
  acceptanceCriteria?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Optional context describing motivation. */
  context?: InputMaybe<Scalars['String']['input']>;
  /** Optional description. */
  description?: InputMaybe<Scalars['String']['input']>;
  /**
   * ID of the parent milestone.
   * @implements BS-005.6 - Epics Must Have Parent Milestone
   */
  milestoneId: Scalars['ID']['input'];
  /** Spec references as array of FS-XXX identifiers. At least one required. */
  specReferences: Array<Scalars['String']['input']>;
  /**
   * Epic title. Must follow "EPIC - {description}" format.
   * @implements BS-005.10 - Epic Title Format
   */
  title: Scalars['String']['input'];
};

/**
 * Input for creating a ticket that is linked to parent ACs (fix ticket).
 * @implements US-133 - TS-247 Add parentId and linkedACs to CreateTicketInput
 * @implements FS-008.4.3.4b - jared_create_ticket Extension
 * @implements AC-4.3.4b.1 - Sets parent.enhancedACs[i].fixTicketId for each linked index
 * @implements AC-4.3.4b.2 - Sets parent.enhancedACs[i].awaitingFix = false for each linked index
 */
export type CreateFixTicketInput = {
  /** Acceptance tests for the fix ticket. */
  acceptanceTests?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Context describing the fix. */
  context?: InputMaybe<Scalars['String']['input']>;
  /** Impact of the fix. */
  impact?: InputMaybe<Array<Scalars['String']['input']>>;
  /** AC indices to link. Sets fixTicketId and clears awaitingFix on parent's enhancedACs. */
  linkedACs: Array<Scalars['Int']['input']>;
  /** Parent ticket ID. Required when linkedACs is provided. */
  parentId: Scalars['ID']['input'];
  /** Parent type for technical stories (USER_STORY or EPIC). */
  parentType?: InputMaybe<TechnicalStoryParentType>;
  /** Title for the fix ticket. */
  title: Scalars['String']['input'];
  /** Ticket type for the fix ticket. Must be TECHNICAL_STORY. */
  type: TicketType;
};

/**
 * Result of createFixTicket mutation.
 * Includes dispatch for next scope per FS-008.4.3.4b.
 * @implements US-133 - jared_create_ticket Fix Ticket Linking
 * @implements FS-008.4.3.4b - Tool Definition -- jared_create_ticket Extension
 * @implements AC-4.3.4b.3 - Response includes parentId for cross-ticket interleaving
 * @implements AC-4.3.4b.4 - Response includes nextScope indicating remaining scopes
 * @implements AC-4.3.4b.5 - When nextScope non-null, dispatch contains next scope dispatch
 * @implements AC-4.3.4b.6 - When all scopes handled, nextScope is null and dispatch is empty
 */
export type CreateFixTicketResult = {
  __typename?: 'CreateFixTicketResult';
  /** Agent spawn instructions for next scope. Empty when nextScope is null. */
  dispatch: Array<DispatchInstruction>;
  /** Error classification for client recovery. Null on success. */
  errorType: Maybe<ErrorType>;
  /** Next scope needing fix ticket. Null if all scopes done. */
  nextScope: Maybe<Scalars['String']['output']>;
  /** Echo back parent ID for cross-ticket interleaving. */
  parentId: Scalars['ID']['output'];
  /** Rejection reason if creation failed. Null on success. */
  rejection: Maybe<RejectionReason>;
  /** Whether the fix ticket creation was successful. */
  success: Scalars['Boolean']['output'];
  /** Newly created fix ticket ID. Null on failure. */
  ticketId: Maybe<Scalars['ID']['output']>;
};

/**
 * Result of creating an interview.
 * @implements US-026 - Interview File Creation
 */
export type CreateInterviewResult = {
  __typename?: 'CreateInterviewResult';
  /** The created interview content */
  interviewContent: InterviewContent;
  /** ID of the specification that holds the interview */
  specificationId: Scalars['ID']['output'];
};

/**
 * Input for creating a new milestone.
 * @implements FS-005.4.2 - Create Milestone
 * @implements BS-005.5 - Milestones Must Reference Specifications
 * @implements BS-005.9 - Milestone Title Format
 */
export type CreateMilestoneInput = {
  /** Optional acceptance criteria. */
  acceptanceCriteria?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Optional description in business/marketing language. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** ID of the project this milestone belongs to. */
  projectId: Scalars['ID']['input'];
  /**
   * Spec references as array of FS-XXX identifiers. At least one required.
   * @implements BS-005.5 - Milestones Must Reference Specifications
   */
  specReferences: Array<Scalars['String']['input']>;
  /**
   * Milestone title. Must follow "MILESTONE - {description}" format.
   * @implements BS-005.9 - Milestone Title Format
   */
  title: Scalars['String']['input'];
};

/**
 * Input for creating a new project.
 * @implements FS-002.1.1 - Create New Project
 */
export type CreateProjectInput = {
  /**
   * Optional project description. Limited to 256 characters.
   * @implements FS-002.1.3
   * @implements BS-002.4
   */
  description?: InputMaybe<Scalars['String']['input']>;
  /**
   * Optional project subscription tier. Defaults to ENTERPRISE.
   * @implements FS-008.2 - Tier Model (Pro and Enterprise)
   * @implements BS-005.21 - Subscription Tier Enforcement
   */
  tier?: InputMaybe<ProjectTier>;
  /**
   * Project title. Required and must be unique within tenant.
   * @implements FS-002.1.3
   * @implements BS-002.3
   */
  title: Scalars['String']['input'];
};

/**
 * Input for creating a new specification.
 * @implements FS-004.1.1 - Create Specification via PM + spec-writer
 */
export type CreateSpecificationInput = {
  /** Specification content */
  content: SpecificationContentInput;
  /** Optional interview content */
  interviewContent?: InputMaybe<InterviewContentInput>;
  /** Optional originating conversation ID */
  originatingConversationId?: InputMaybe<Scalars['ID']['input']>;
  /** Specification title (max 256 characters) */
  title: Scalars['String']['input'];
};

/**
 * Input for creating a new technical story.
 * @implements FS-005.7.2 - Create Technical Story
 * @implements BS-005.10c - Technical Story Title Format
 */
export type CreateTechnicalStoryInput = {
  /**
   * Acceptance tests array (min 1 required).
   * @implements FS-005.7.1 - Technical Story Template (Acceptance Tests)
   */
  acceptanceTests: Array<Scalars['String']['input']>;
  /** Optional context describing motivation. */
  context?: InputMaybe<Scalars['String']['input']>;
  /**
   * ID of the parent epic. Required when parentType is EPIC.
   * @implements FS-005.7.1 - dual parent support (orphans)
   */
  epicId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Impact array (min 1 required).
   * @implements FS-005.7.1 - Technical Story Template (Impact)
   */
  impact: Array<Scalars['String']['input']>;
  /**
   * Parent type: USER_STORY or EPIC.
   * @implements FS-005.7.1 - Technical Story dual parent support
   */
  parentType: TechnicalStoryParentType;
  /**
   * Regressions array. Required when parentType is EPIC.
   * @implements FS-005.7.1 - Regressions required for orphans
   */
  regressions?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * Technical Story title. Must follow "{action}({scope}): BS-{XXX} {description}" format.
   * @implements BS-005.10c - Technical Story Title Format
   */
  title: Scalars['String']['input'];
  /**
   * ID of the parent user story. Required when parentType is USER_STORY.
   * @implements FS-005.7.1 - dual parent support
   */
  userStoryId?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * Input for creating a new user story.
 * @implements FS-005.6.2 - Create User Story
 * @implements BS-005.10b - User Story Title Format
 */
export type CreateUserStoryInput = {
  /** Optional acceptance criteria. */
  acceptanceCriteria?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Optional business rules array. */
  businessRules?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Optional children references. */
  children?: InputMaybe<Array<ChildInput>>;
  /** Optional context describing motivation. */
  context?: InputMaybe<Scalars['String']['input']>;
  /** Optional description. */
  description?: InputMaybe<Scalars['String']['input']>;
  /**
   * ID of the parent epic.
   * @implements FS-005.6 - User Stories belong to parent Epic
   */
  epicId: Scalars['ID']['input'];
  /** Optional impact array. */
  impact?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Optional regressions text. */
  regressions?: InputMaybe<Scalars['String']['input']>;
  /** Spec references as array of FS-XXX and BS-XXX identifiers. */
  specReferences: Array<Scalars['String']['input']>;
  /**
   * User Story title. Must follow "{Epic name}-{scope} - {description}" format.
   * @implements BS-005.10b - User Story Title Format
   */
  title: Scalars['String']['input'];
};

/**
 * A ticket summary for dashboard display.
 * @implements US-098 - DashboardItem type
 */
export type DashboardItem = {
  __typename?: 'DashboardItem';
  /** Current kanban column. */
  column: KanbanColumn;
  /** Specification references (e.g., FS-001, BS-002). */
  specReferences: Array<Scalars['String']['output']>;
  /** Unique ticket identifier. */
  ticketId: Scalars['ID']['output'];
  /** Ticket title. */
  ticketName: Scalars['String']['output'];
  /** Ticket type: MILESTONE or EPIC. */
  ticketType: Scalars['String']['output'];
  /** Summary of validation feedback status. */
  validationFeedbackSummary: ValidationFeedbackSummary;
};

/**
 * Rich result from deleting a specification.
 * Follows FS-003.2.2 rich mutation response rule.
 * @implements FS-004.4.1 - Delete Specification
 * @implements FS-003.2.2 - Rich Mutation Response
 */
export type DeleteSpecificationResult = {
  __typename?: 'DeleteSpecificationResult';
  /** The formatted specification number that was deleted (e.g., "FS-001") */
  specificationNumber: Scalars['String']['output'];
  /** Whether the deletion was successful */
  success: Scalars['Boolean']['output'];
};

/**
 * Response payload for technical story delete mutation.
 * @implements FS-005.7.4 - Delete Technical Story
 */
export type DeleteTechnicalStoryPayload = {
  __typename?: 'DeleteTechnicalStoryPayload';
  /**
   * Warning about impact on parent's children list, if any.
   * @implements FS-005.7.4 - Delete warns about impact on parent's children list
   */
  parentImpactWarning: Maybe<Scalars['String']['output']>;
  /** Whether the deletion was successful. */
  success: Scalars['Boolean']['output'];
};

/**
 * Response payload for user story delete mutation.
 * @implements FS-005.6.4 - Delete User Story
 */
export type DeleteUserStoryPayload = {
  __typename?: 'DeleteUserStoryPayload';
  /** Warning about orphaned Technical Stories, if any. */
  orphanedChildrenWarning: Maybe<Scalars['String']['output']>;
  /** Whether the deletion was successful. */
  success: Scalars['Boolean']['output'];
};

/**
 * Result of checking the deletion impact of a specification.
 * Reports which roadmap items reference the specification.
 * @implements FS-004.4.1 - Delete Specification
 * @implements FS-004.7.1 - Spec-Roadmap Consistency
 */
export type DeletionImpact = {
  __typename?: 'DeletionImpact';
  /** Whether any roadmap items reference this specification */
  hasImpact: Scalars['Boolean']['output'];
  /** Epics that reference this specification */
  impactedEpics: Array<ImpactedItem>;
  /** Milestones that reference this specification */
  impactedMilestones: Array<ImpactedItem>;
  /** The ID of the specification being checked */
  specificationId: Scalars['ID']['output'];
  /** The formatted specification number (e.g., "FS-001") */
  specificationNumber: Scalars['String']['output'];
};

/**
 * Change type for diff operations.
 * @implements FS-004.3.1 - Edit Specification
 */
export type DiffChangeType =
  /** Content was added */
  | 'ADDED'
  /** Content was modified */
  | 'MODIFIED'
  /** Content was removed */
  | 'REMOVED'
  /** Content is unchanged */
  | 'UNCHANGED';

/**
 * Instruction for PM to spawn an agent.
 * @implements US-120 - DispatchInstruction type
 * @implements FS-006.11.1 - Dispatch object fields
 */
export type DispatchInstruction = {
  __typename?: 'DispatchInstruction';
  /** Agent role to spawn (e.g., backend-dev, frontend-dev, qa-engineer, pm). */
  agent: Scalars['String']['output'];
  /** Git branch name for review/merge tasks (e.g., pr/TS-100). */
  branch: Maybe<Scalars['String']['output']>;
  /** Additional context for fix tasks (contains reviewer, reason). */
  context: Maybe<Scalars['JSON']['output']>;
  /** What the agent should do (e.g., validate, code_review, synthesize_consensus). */
  task: Scalars['String']['output'];
  /** Ticket the agent should work on. Null for full_regression task. */
  ticketId: Maybe<Scalars['ID']['output']>;
  /** Array of ticket IDs for full_regression task. */
  tickets: Maybe<Array<Scalars['ID']['output']>>;
};

/**
 * Enhanced acceptance criterion with test planning data and execution results.
 * @implements FS-008.4.3.1 - EnhancedAC schema
 * @implements AC-4.3.1.3 - index corresponds to acceptanceCriteria position
 * @implements AC-4.3.1.5 - failReason required when status is FAIL
 */
export type EnhancedAc = {
  __typename?: 'EnhancedAC';
  /** True while waiting for fix ticket creation (only present when status is FAIL) */
  awaitingFix: Maybe<Scalars['Boolean']['output']>;
  /** Explanation when status is FAIL (only present when status is FAIL) */
  failReason: Maybe<Scalars['String']['output']>;
  /** Links to fix ticket addressing this AC (only present when status is FAIL) */
  fixTicketId: Maybe<Scalars['ID']['output']>;
  /** 0-based position in the AC list (matches acceptanceCriteria[] index) */
  index: Scalars['Int']['output'];
  /** Determines which dev handles fixes: FRONTEND or BACKEND */
  scope: AcScope;
  /** Current test status */
  status: AcStatus;
  /** Ordered steps to verify this AC */
  testSteps: Array<TestStep>;
  /** When the status was last updated (ISO 8601 timestamp) */
  testedAt: Maybe<Scalars['DateTime']['output']>;
  /** Original acceptance criterion text */
  text: Scalars['String']['output'];
  /** Test type: BROWSER or API_ONLY */
  type: AcType;
};

/**
 * Input for an enhanced acceptance criterion with test planning data.
 * Used when updating a ticket with test steps during QA consolidation.
 * @implements FS-008.4.3.4 - jared_update_ticket Extension
 * @implements US-132 - TS-242 Add enhancedACs to UpdateTicketInput
 * @implements AC-4.3.4.1 - enhancedACs replaces entire array
 * @implements AC-4.3.4.3 - Validates each enhancedAC.index matches array position
 */
export type EnhancedAcInput = {
  /** True while waiting for fix ticket creation (only when FAIL) */
  awaitingFix?: InputMaybe<Scalars['Boolean']['input']>;
  /** Explanation when status is FAIL (required when status is FAIL) */
  failReason?: InputMaybe<Scalars['String']['input']>;
  /** Links to fix ticket addressing this AC (only when FAIL) */
  fixTicketId?: InputMaybe<Scalars['ID']['input']>;
  /** 0-based position in the AC list (must match array position) */
  index: Scalars['Int']['input'];
  /** Determines which dev handles fixes: FRONTEND or BACKEND */
  scope: AcScope;
  /** Current test status (defaults to PENDING for new entries) */
  status: AcStatus;
  /** Ordered steps to verify this AC */
  testSteps: Array<TestStepInput>;
  /** When the status was last updated (ISO 8601 timestamp) */
  testedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Original acceptance criterion text */
  text: Scalars['String']['input'];
  /** Test type: BROWSER or API_ONLY */
  type: AcType;
};

/**
 * Epic representing a large feature grouping that belongs to a parent Milestone.
 * Epics track their kanban position via a direct column field with workflow data hoisted to top-level.
 * @implements FS-005.5 - Epic Management
 * @implements FS-005.5.1 - Epic Template
 * @implements FS-005.10.3 - Direct column field (no wrapper)
 */
export type Epic = {
  __typename?: 'Epic';
  /**
   * Acceptance criteria as array of strings.
   * User flow descriptions that validate the epic as a whole.
   * @implements FS-005.5.1 - Epic Template
   */
  acceptanceCriteria: Array<Scalars['String']['output']>;
  /** Reason for cancellation. Only set when lifecycle is canceled. */
  cancellationReason: Maybe<Scalars['String']['output']>;
  /**
   * Checklist of child User Story UUIDs.
   * Empty for MVP (User Stories not yet implemented).
   * @implements FS-005.5.1 - Epic Template
   */
  checklist: Array<Scalars['String']['output']>;
  /**
   * Current kanban column. Direct field per FS-005.10.3.
   * @implements FS-005.10.3 - Direct column field (no wrapper)
   */
  column: KanbanColumn;
  /**
   * Context describing the parent milestone link and motivation.
   * Format: "Child of MILESTONE - {parent title}. {user-provided context}"
   * @implements FS-005.5.1 - Epic Template
   */
  context: Maybe<Scalars['String']['output']>;
  /** Timestamp when the epic was created. */
  createdAt: Scalars['DateTime']['output'];
  /**
   * Description of what this epic delivers and how it adds value.
   * @implements FS-005.5.1 - Epic Template
   */
  description: Maybe<Scalars['String']['output']>;
  /**
   * Derived boolean: true if validationErrors is non-empty.
   * @implements BS-005.24 - hasValidationErrors derived attribute
   */
  hasValidationErrors: Scalars['Boolean']['output'];
  /** Unique identifier for the epic. */
  id: Scalars['ID']['output'];
  /**
   * Alias for column field for backward compatibility.
   * @implements FS-005.5 - Epic Management
   */
  kanbanColumn: KanbanColumn;
  /**
   * Ticket lifecycle state (active, canceled, archived).
   * @implements FS-005 Data Requirements - Ticket Lifecycle States
   */
  lifecycleState: LifecycleState;
  /**
   * Parent milestone reference.
   * Loaded via field resolver.
   * @implements BS-005.6 - Epics Must Have Parent Milestone
   */
  milestone: Maybe<Milestone>;
  /**
   * ID of the parent milestone.
   * @implements BS-005.6 - Epics Must Have Parent Milestone
   */
  milestoneId: Scalars['ID']['output'];
  /**
   * Orphan technical stories attached directly to this epic.
   * Returns technical stories with parentType = EPIC in position order (ASC).
   * @implements FS-005.7 - Technical Story Management (orphans)
   */
  orphanTechnicalStories: Array<TechnicalStory>;
  /**
   * Position for ordering within the parent milestone.
   * @implements FS-005.5 - Epic Management
   */
  position: Scalars['Int']['output'];
  /**
   * ID of the project this epic belongs to.
   * @implements FS-005.5 - Epic Management
   */
  projectId: Scalars['ID']['output'];
  /**
   * Review comments during review column.
   * @implements FS-005.10.3 - Workflow data hoisted to top-level fields
   */
  reviewComments: Array<ReviewComment>;
  /**
   * Review labels during review column.
   * @implements FS-005.10.3 - Workflow data hoisted to top-level fields
   */
  reviewLabels: Array<ReviewLabel>;
  /**
   * Spec references as array of FS-XXX identifiers.
   * Every epic must reference at least one specification.
   * @implements FS-005.5.1 - Epic Template
   */
  specReferences: Array<Scalars['String']['output']>;
  /**
   * Test results during QA column.
   * @implements FS-005.10.3 - Workflow data hoisted to top-level fields
   */
  testResults: Array<TestResult>;
  /**
   * Epic title. Must follow "EPIC - {description}" format.
   * Unique within the project.
   * @implements BS-005.10 - Epic Title Format
   */
  title: Scalars['String']['output'];
  /** Timestamp when the epic was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /**
   * Child user stories for this epic.
   * Returns user stories in position order (ASC).
   * @implements FS-005.6 - User Story Management
   */
  userStories: Array<UserStory>;
  /**
   * Validation errors from template validation.
   * Empty array when ticket passes all validation rules.
   * @implements BS-005.24 - Template Validation via JSON Schema
   */
  validationErrors: Array<TemplateValidationError>;
  /**
   * Validation feedback from agents during consolidation.
   * @implements FS-005.10.3 - Workflow data hoisted to top-level fields
   */
  validationFeedback: Array<ValidationFeedback>;
  /**
   * Derived validation status from validationFeedback[].
   * Only relevant during consolidation. NEVER stored directly.
   * @implements FS-005.8.3 - Representation (Derived Values)
   */
  validationStatus: Maybe<ValidationStatus>;
};

/**
 * Input for filtering epics in a project.
 * @implements FS-005.5 - Epic Management
 */
export type EpicFilterInput = {
  /** Include archived epics. Default: false. */
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by kanban column. */
  kanbanColumn?: InputMaybe<KanbanColumn>;
  /**
   * Filter by lifecycle state.
   * Default behavior excludes archived epics.
   */
  lifecycleState?: InputMaybe<LifecycleState>;
  /** Filter by parent milestone ID. */
  milestoneId?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * Error type classification for mutation responses.
 * Categorizes errors to help clients determine appropriate recovery actions.
 * @implements BS-005.22 - Error Semantics
 * @implements FS-005.8.11 - Mutation Response Format
 * @implements FS-008.4.3.5 - Deprecated Tool error type
 * @implements FS-008.4.3.4 - INVALID_INPUT and INVALID_STATE error types
 */
export type ErrorType =
  /** Feature deprecated: client should use alternative tool/approach. */
  | 'DEPRECATED'
  /** Lost connection to ScrumMaster process: client should reconnect. */
  | 'DISCONNECTION'
  /** Persistence or network failure: client should retry. */
  | 'INFRASTRUCTURE'
  /** Input validation failed: client provided invalid data. */
  | 'INVALID_INPUT'
  /** State conflict: operation not allowed in current ticket state. */
  | 'INVALID_STATE'
  /** Guard violation: client can fix the input and retry. */
  | 'REJECTION'
  /** No-op: the mutation had no effect. */
  | 'UNCHANGED';

/**
 * Functional requirement structure.
 * Format: FS-XXX.X with title, description, and acceptance criteria.
 * @implements FS-004.2.1 - Specification Structure
 */
export type FunctionalRequirement = {
  __typename?: 'FunctionalRequirement';
  /** List of acceptance criteria */
  acceptanceCriteria: Array<Scalars['String']['output']>;
  /** Detailed description of the requirement */
  description: Scalars['String']['output'];
  /** Requirement ID in FS-XXX.X format (relative to specification) */
  id: Scalars['String']['output'];
  /** Short title for the requirement */
  title: Scalars['String']['output'];
};

/**
 * A diff for a single functional requirement.
 * @implements FS-004.3.1 - Edit Specification
 */
export type FunctionalRequirementDiff = {
  __typename?: 'FunctionalRequirementDiff';
  /** The type of change */
  changeType: DiffChangeType;
  /** Current requirement (null if removed) */
  current: Maybe<FunctionalRequirement>;
  /** The requirement ID (FS-XXX.X) */
  id: Scalars['String']['output'];
  /** Previous requirement (null if added) */
  previous: Maybe<FunctionalRequirement>;
};

/**
 * Input for functional requirement in create/update operations.
 * @implements FS-004.2.1 - Specification Structure
 */
export type FunctionalRequirementInput = {
  /** List of acceptance criteria */
  acceptanceCriteria: Array<Scalars['String']['input']>;
  /** Detailed description of the requirement */
  description: Scalars['String']['input'];
  /** Requirement ID in FS-XXX.X format */
  id: Scalars['String']['input'];
  /** Short title for the requirement */
  title: Scalars['String']['input'];
};

/**
 * Result of generating a draft specification from a completed interview.
 * @implements US-028 - Draft Specification Generation
 */
export type GenerateDraftResult = {
  __typename?: 'GenerateDraftResult';
  /** The generated specification content */
  content: SpecificationContent;
  /** ID of the updated specification */
  specificationId: Scalars['ID']['output'];
  /** The specification number for FS-XXX formatting */
  specificationNumber: Scalars['Int']['output'];
  /** Summary of what was generated */
  summary: GenerateDraftSummary;
};

/**
 * Summary of generated draft specification.
 * @implements US-028 - Draft Specification Generation
 */
export type GenerateDraftSummary = {
  __typename?: 'GenerateDraftSummary';
  /** Whether all sections were populated */
  allSectionsPopulated: Scalars['Boolean']['output'];
  /** Number of business rules created */
  businessRulesCount: Scalars['Int']['output'];
  /** Number of functional requirements generated */
  functionalRequirementsCount: Scalars['Int']['output'];
};

/**
 * Health check response type
 * Provides information about the GraphQL server status
 */
export type HealthCheck = {
  __typename?: 'HealthCheck';
  /** Current server status (e.g., 'ok', 'degraded') */
  status: Scalars['String']['output'];
  /** ISO 8601 timestamp of when the health check was performed */
  timestamp: Scalars['String']['output'];
  /** Server version string */
  version: Scalars['String']['output'];
};

/**
 * A roadmap item impacted by specification deletion.
 * @implements FS-004.4.1 - Delete Specification
 */
export type ImpactedItem = {
  __typename?: 'ImpactedItem';
  /** The ID of the impacted item */
  id: Scalars['ID']['output'];
  /** The name/title of the impacted item */
  name: Scalars['String']['output'];
};

/**
 * Interview content structure stored as JSONB.
 * Contains the interview progress and responses.
 * This wraps InterviewFile with overall status tracking.
 * @implements FS-004.1.2 - Interview File Process
 * @implements US-026 - Interview File Creation
 */
export type InterviewContent = {
  __typename?: 'InterviewContent';
  /** Date when interview was completed (ISO-8601, null if in progress) */
  completedAt: Maybe<Scalars['String']['output']>;
  /** Feature name being interviewed */
  featureName: Scalars['String']['output'];
  /** Interview file with sections and questions */
  interview: InterviewFile;
  /** Date when interview was started (ISO-8601) */
  startedAt: Scalars['String']['output'];
  /** Overall interview status */
  status: InterviewStatus;
  /**
   * Interview type discriminator.
   * 'creation' for new specifications, 'edit' for modifications.
   * NULL for legacy interviews (treated as creation).
   * @implements FS-004.3.1 - Edit Specification
   */
  type: Maybe<InterviewTypeEnum>;
};

/**
 * Input for interview content in create/update operations.
 * @implements FS-004.1.2 - Interview File Process
 * @implements US-026 - Interview File Creation
 */
export type InterviewContentInput = {
  /** Date when interview was completed (ISO-8601, null if in progress) */
  completedAt?: InputMaybe<Scalars['String']['input']>;
  /** Feature name being interviewed */
  featureName: Scalars['String']['input'];
  /** Interview file with sections and questions */
  interview: InterviewFileInput;
  /** Date when interview was started (ISO-8601) */
  startedAt: Scalars['String']['input'];
  /** Overall interview status */
  status: InterviewStatus;
  /**
   * Interview type discriminator.
   * 'creation' for new specifications, 'edit' for modifications.
   * @implements FS-004.3.1 - Edit Specification
   */
  type?: InputMaybe<InterviewTypeEnum>;
};

/**
 * Interview file structure stored as JSONB.
 * This is the main interview document that tracks the entire interview process.
 * @implements FS-004.1.2 - Interview File Process
 * @implements US-026 - Interview File Creation
 */
export type InterviewFile = {
  __typename?: 'InterviewFile';
  /** ISO-8601 timestamp when interview was created */
  createdAt: Scalars['String']['output'];
  /** Name of the feature being specified */
  featureName: Scalars['String']['output'];
  /** ISO-8601 timestamp when interview was last updated */
  lastUpdatedAt: Scalars['String']['output'];
  /** Interview sections with questions and answers */
  sections: Array<InterviewSection>;
  /** ID of the linked specification (set when spec is created from interview) */
  specificationId: Maybe<Scalars['ID']['output']>;
};

/**
 * Input for interview file in create/update operations.
 * @implements FS-004.1.2 - Interview File Process
 * @implements US-026 - Interview File Creation
 */
export type InterviewFileInput = {
  /** ISO-8601 timestamp when interview was created */
  createdAt: Scalars['String']['input'];
  /** Name of the feature being specified */
  featureName: Scalars['String']['input'];
  /** ISO-8601 timestamp when interview was last updated */
  lastUpdatedAt: Scalars['String']['input'];
  /** Interview sections with questions and answers */
  sections: Array<InterviewSectionInput>;
  /** ID of the linked specification */
  specificationId?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * Enhanced interview progress with detailed section breakdown.
 * Extends InterviewProgressSummary with section-by-section details
 * and next question recommendations.
 * @implements US-027 - Interview Progress Tracking
 * @implements FS-004.1.2 - Interview File Process
 * @implements FS-004.3.2 - Resume In-Progress Work
 */
export type InterviewProgressDetail = {
  __typename?: 'InterviewProgressDetail';
  /** Total answered questions across all sections */
  answeredQuestions: Scalars['Int']['output'];
  /** Number of completed sections */
  completedSections: Scalars['Int']['output'];
  /** Overall completion percentage (0-100) */
  completionPercentage: Scalars['Float']['output'];
  /** Current section being worked on (if any) */
  currentSection: Maybe<Scalars['String']['output']>;
  /** Current section ID (if any) */
  currentSectionId: Maybe<Scalars['String']['output']>;
  /** Feature name being interviewed */
  featureName: Scalars['String']['output'];
  /** Number of in-progress sections */
  inProgressSections: Scalars['Int']['output'];
  /** Whether the interview is complete */
  isComplete: Scalars['Boolean']['output'];
  /** Date when interview was last updated (ISO-8601) */
  lastUpdatedAt: Scalars['String']['output'];
  /** Next recommended question to ask (null if complete) */
  nextQuestion: Maybe<NextQuestionInfo>;
  /** Number of not-started sections */
  notStartedSections: Scalars['Int']['output'];
  /** Detailed progress for each section */
  sectionDetails: Array<SectionProgressDetail>;
  /** Specification ID */
  specificationId: Scalars['ID']['output'];
  /** Date when interview was started (ISO-8601) */
  startedAt: Scalars['String']['output'];
  /** Overall interview status */
  status: InterviewStatus;
  /** Total questions across all sections */
  totalQuestions: Scalars['Int']['output'];
  /** Total number of sections (8 standard sections) */
  totalSections: Scalars['Int']['output'];
};

/**
 * Interview progress summary.
 * Provides a high-level view of interview completion status.
 * @implements US-026 - Interview File Creation
 */
export type InterviewProgressSummary = {
  __typename?: 'InterviewProgressSummary';
  /** Number of completed sections */
  completedSections: Scalars['Int']['output'];
  /** Overall completion percentage (0-100) */
  completionPercentage: Scalars['Float']['output'];
  /** Current section being worked on (if any) */
  currentSection: Maybe<Scalars['String']['output']>;
  /** Number of in-progress sections */
  inProgressSections: Scalars['Int']['output'];
  /** Whether the interview is complete */
  isComplete: Scalars['Boolean']['output'];
  /** Number of not-started sections */
  notStartedSections: Scalars['Int']['output'];
  /** Total number of sections (8 standard sections) */
  totalSections: Scalars['Int']['output'];
};

/**
 * Interview question structure with answer tracking.
 * @implements FS-004.1.2 - Interview File Process
 * @implements US-026 - Interview File Creation
 */
export type InterviewQuestion = {
  __typename?: 'InterviewQuestion';
  /** The PO's answer to the question (null if not answered) */
  answer: Maybe<Scalars['String']['output']>;
  /** Optional follow-up questions generated based on the answer */
  followUpQuestions: Maybe<Array<Scalars['String']['output']>>;
  /** Unique identifier for the question within the section */
  id: Scalars['String']['output'];
  /** The question text */
  question: Scalars['String']['output'];
};

/**
 * Input for interview question in create/update operations.
 * @implements FS-004.1.2 - Interview File Process
 * @implements US-026 - Interview File Creation
 */
export type InterviewQuestionInput = {
  /** The PO's answer to the question */
  answer?: InputMaybe<Scalars['String']['input']>;
  /** Optional follow-up questions */
  followUpQuestions?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Unique identifier for the question within the section */
  id: Scalars['String']['input'];
  /** The question text */
  question: Scalars['String']['input'];
};

/**
 * Interview section structure for progress tracking.
 * Contains questions and tracks completion status.
 * @implements FS-004.1.2 - Interview File Process
 * @implements US-026 - Interview File Creation
 */
export type InterviewSection = {
  __typename?: 'InterviewSection';
  /** Unique identifier for the section (e.g., 'big_picture', 'core_functionality') */
  id: Scalars['String']['output'];
  /** Section display name (e.g., "Big Picture & Context") */
  name: Scalars['String']['output'];
  /** Questions in this section with answers */
  questions: Array<InterviewQuestion>;
  /** Section completion status */
  status: InterviewSectionStatus;
};

/**
 * Input for interview section in create/update operations.
 * @implements FS-004.1.2 - Interview File Process
 * @implements US-026 - Interview File Creation
 */
export type InterviewSectionInput = {
  /** Unique identifier for the section */
  id: Scalars['String']['input'];
  /** Section display name */
  name: Scalars['String']['input'];
  /** Questions in this section with answers */
  questions: Array<InterviewQuestionInput>;
  /** Section status */
  status: InterviewSectionStatus;
};

/**
 * Interview section status for progress tracking.
 * @implements FS-004.1.2 - Interview File Process
 */
export type InterviewSectionStatus =
  /** Section complete */
  | 'COMPLETE'
  /** Section in progress */
  | 'IN_PROGRESS'
  /** Section not started */
  | 'NOT_STARTED';

/**
 * Overall interview status.
 * @implements FS-004.1.2 - Interview File Process
 */
export type InterviewStatus =
  /** Interview complete, ready for draft generation */
  | 'COMPLETE'
  /** Interview in progress */
  | 'IN_PROGRESS';

/**
 * Interview type discriminator.
 * Distinguishes between creation interviews and edit interviews.
 * @implements FS-004.3.1 - Edit Specification
 */
export type InterviewTypeEnum =
  /** Initial creation interview */
  | 'creation'
  /** Edit interview for modifying existing specification */
  | 'edit';

/**
 * A single JSON Patch operation following RFC 6902.
 * @implements FS-002.8.2 - JSON Patch Protocol
 */
export type JsonPatchOperation = {
  __typename?: 'JSONPatchOperation';
  /** The operation to perform: "add", "remove", "replace", "move", "copy", "test" */
  op: Scalars['String']['output'];
  /**
   * A JSON Pointer (RFC 6901) path specifying the location of the target value.
   * Example: "/pmValidated"
   */
  path: Scalars['String']['output'];
  /**
   * The value to use for the operation.
   * Required for "add", "replace", and "test" operations.
   * Uses JSON scalar to support any value type.
   */
  value: Maybe<Scalars['JSON']['output']>;
};

/**
 * Kanban board columns representing the workflow stages of roadmap items.
 * Columns are ordered from backlog (0) to done (6).
 * Values match the string values stored in the database and used by resolvers.
 * @implements FS-005.2.1 - Kanban Column Structure
 * @implements BS-005.16 - Column Transitions
 */
export type KanbanColumn =
  /** All identified work not yet refined */
  | 'backlog'
  /** Work being refined, scoped, and validated for development */
  | 'consolidation'
  /** All tests passed, including parent integration tests */
  | 'done'
  /** Currently being developed */
  | 'inProgress'
  /** Awaiting integration testing (unit, integration, business, e2e) */
  | 'qa'
  /** Completed and awaiting code review */
  | 'review'
  /** Ready-to-implement tickets with clear acceptance criteria */
  | 'todo';

/**
 * Full kanban board representation pushed via subscription.
 * Self-contained snapshot (not a delta) per FS-005.8.8.
 * @implements TS-056.1 - KanbanRepresentation SDL type
 * @implements FS-005.8.8 - GraphQL Subscription Protocol
 */
export type KanbanRepresentation = {
  __typename?: 'KanbanRepresentation';
  /** Derived parent columns (milestone ID -> column). */
  parentColumns: Array<ParentColumnEntry>;
  /** All tickets in the kanban board. */
  tickets: Array<KanbanTicket>;
  /** Tickets grouped by kanban column. */
  ticketsByColumn: Array<ColumnTickets>;
  /** Derived validation statuses (ticket ID -> status). */
  validationStatuses: Array<ValidationStatusEntry>;
};

/**
 * A ticket in the kanban board subscription payload.
 * Represents the flattened, client-readable form of TicketData.
 * @implements TS-056.1 - KanbanTicket SDL type
 * @implements FS-005.8.8 - Standard typed GraphQL data
 * @implements FS-005.2.1 - qaReady flag for parent tickets
 * @implements FS-008.4.3.1 - Enhanced Acceptance Criteria Schema (enhancedACs field)
 */
export type KanbanTicket = {
  __typename?: 'KanbanTicket';
  /** Acceptance criteria list. */
  acceptanceCriteria: Array<Scalars['String']['output']>;
  /** Child references (epics for milestones, user stories for epics). */
  children: Array<ChildRef>;
  /** Current kanban column. */
  column: KanbanColumn;
  /** Optional context text. */
  context: Maybe<Scalars['String']['output']>;
  /** Optional description text. */
  description: Maybe<Scalars['String']['output']>;
  /**
   * Enhanced acceptance criteria with test planning data and execution results.
   * Null until test planning is performed during QA consolidation.
   * When present, length matches acceptanceCriteria array length.
   * @implements FS-008.4.3.1 - Enhanced Acceptance Criteria Schema
   * @implements AC-4.3.1.1 - enhancedACs field nullable on tickets
   * @implements AC-4.3.1.4 - enhancedACs length matches acceptanceCriteria length
   */
  enhancedACs: Maybe<Array<EnhancedAc>>;
  /** Unique ticket identifier. */
  id: Scalars['ID']['output'];
  /** Ticket lifecycle state. */
  lifecycleState: LifecycleState;
  /** Parent ticket ID, null for top-level milestones. */
  parentId: Maybe<Scalars['ID']['output']>;
  /**
   * True when this parent ticket (milestone) is ready for QA integration testing.
   * Always false for non-parent tickets (epics). True when the parent's derived
   * column is QA, meaning all children have reached the QA column.
   * @implements FS-005.2.1 - QA-ready visual indicator
   * @implements TS-211 - QA Column Trigger NAP
   */
  qaReady: Scalars['Boolean']['output'];
  /** Specification references (e.g., FS-001, BS-002). */
  specReferences: Array<Scalars['String']['output']>;
  /** Ticket title. */
  title: Scalars['String']['output'];
  /** Ticket type: MILESTONE or EPIC. */
  type: Scalars['String']['output'];
  /** Validation feedback entries (empty array if not in consolidation). */
  validationFeedback: Array<ValidationFeedbackEntry>;
};

/**
 * Ticket lifecycle states independent of kanban column position.
 * Values match the string values stored in the database and used by resolvers.
 * @implements FS-005 Data Requirements - Ticket Lifecycle States
 * @implements BS-005.15 - Lifecycle State Restricts Column Changes
 */
export type LifecycleState =
  /** Normal working state - ticket can move through kanban */
  | 'active'
  /** Ticket moved to archive (completed or obsolete) */
  | 'archived'
  /** Ticket canceled due to blocker during draft */
  | 'canceled';

/**
 * Input for password-based login.
 * Used when authenticating with email and password backup.
 * @implements FS-001.2.2 - Password Authentication (Backup)
 */
export type LoginInput = {
  /** User's email address */
  email: Scalars['String']['input'];
  /** User's password */
  password: Scalars['String']['input'];
};

/**
 * Result of completeMerge mutation.
 * Confirms that a PR has been merged and moves the ticket to release.
 * Includes dispatch fields for PM routing per FS-006.11.1.
 * @implements US-127 - jared_merge_complete Tool
 * @implements FS-006.11.1 - Dispatch Response Format
 */
export type MergeCompleteResult = {
  __typename?: 'MergeCompleteResult';
  /** Agent spawn instructions for PM. Empty array if no agents to spawn. */
  dispatch: Array<DispatchInstruction>;
  /** Error classification for client recovery. Null on success. */
  errorType: Maybe<ErrorType>;
  /** Event identifier for special workflow events (e.g., iteration_ready_for_release). */
  event: Maybe<Scalars['String']['output']>;
  /** Parent ticket's derived column change. Null if no parent derivation occurred. */
  parentTransition: Maybe<ParentTransition>;
  /** Rejection reason if the submission was rejected. Null on success. */
  rejection: Maybe<RejectionReason>;
  /** Full post-NAP kanban state. Null on rejection (state unchanged). */
  state: Maybe<KanbanRepresentation>;
  /** Whether the merge completion was accepted. */
  success: Scalars['Boolean']['output'];
  /** The ticket's column transition. Null if no transition occurred. */
  transition: Maybe<Transition>;
};

/**
 * Message sender type enum.
 * @implements FS-002.7.7 - Conversation Message Structure
 */
export type MessageSenderType =
  /** Message sent by the AI Project Manager */
  | 'AI_PM'
  /** Message sent by the Product Owner */
  | 'PRODUCT_OWNER';

/**
 * Milestone representing a key value delivery unit in a project roadmap.
 * Milestones contain Epics as children and have NO stored kanban column -
 * the column is ALWAYS derived from min(children.column) per BS-005.17.
 * @implements FS-005.4 - Milestone Management
 * @implements FS-005.4.1 - Milestone Template
 */
export type Milestone = {
  __typename?: 'Milestone';
  /**
   * Acceptance criteria as array of strings.
   * End-to-end user journeys spanning Epics.
   * @implements FS-005.4.1 - Milestone Template
   */
  acceptanceCriteria: Array<Scalars['String']['output']>;
  /** Reason for cancellation. Only set when lifecycle is canceled. */
  cancellationReason: Maybe<Scalars['String']['output']>;
  /**
   * Checklist of child Epic UUIDs.
   * @implements FS-005.4.1 - Milestone Template
   */
  checklist: Array<Scalars['String']['output']>;
  /** Timestamp when the milestone was created. */
  createdAt: Scalars['DateTime']['output'];
  /**
   * Derived kanban column computed from min(children.column).
   * Defaults to BACKLOG when no children exist.
   * This value is NEVER stored - always computed at query time.
   * @implements BS-005.17 - Parent Column Is Always Derived
   */
  derivedColumn: KanbanColumn;
  /**
   * Milestone description in business/marketing language.
   * @implements FS-005.4.1 - Milestone Template
   */
  description: Maybe<Scalars['String']['output']>;
  /**
   * Child epics belonging to this milestone.
   * Loaded via field resolver.
   * @implements BS-005.6 - Epics Must Have Parent Milestone
   */
  epics: Array<Epic>;
  /** Number of child epics belonging to this milestone. */
  epicsCount: Scalars['Int']['output'];
  /**
   * Derived boolean: true if validationErrors is non-empty.
   * @implements BS-005.24 - hasValidationErrors derived attribute
   */
  hasValidationErrors: Scalars['Boolean']['output'];
  /** Unique identifier for the milestone. */
  id: Scalars['ID']['output'];
  /**
   * Ticket lifecycle state (active, canceled, archived).
   * @implements FS-005 Data Requirements - Ticket Lifecycle States
   */
  lifecycleState: LifecycleState;
  /**
   * Position for ordering within the project. Lower values appear first.
   * @implements BS-005.8 - Milestone Order Represents Sequence
   */
  position: Scalars['Int']['output'];
  /**
   * ID of the project this milestone belongs to.
   * @implements FS-005.4 - Milestone Management
   */
  projectId: Scalars['ID']['output'];
  /**
   * Spec references as array of FS-XXX identifiers.
   * Every milestone must reference at least one specification.
   * @implements BS-005.5 - Milestones Must Reference Specifications
   */
  specReferences: Array<Scalars['String']['output']>;
  /**
   * Milestone title. Must follow "MILESTONE - {description}" format.
   * Unique within the project.
   * @implements BS-005.9 - Milestone Title Format
   */
  title: Scalars['String']['output'];
  /** Timestamp when the milestone was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /**
   * Validation errors from template validation.
   * Empty array when ticket passes all validation rules.
   * @implements BS-005.24 - Template Validation via JSON Schema
   */
  validationErrors: Array<TemplateValidationError>;
};

/**
 * Input for filtering milestones in a project.
 * @implements FS-005.4 - Milestone Management
 */
export type MilestoneFilterInput = {
  /** Include archived milestones. Default: false. */
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Filter by derived kanban column.
   * @implements BS-005.17 - Parent Column Is Always Derived
   */
  kanbanColumn?: InputMaybe<KanbanColumn>;
  /**
   * Filter by lifecycle state.
   * Default behavior excludes archived milestones.
   */
  lifecycleState?: InputMaybe<LifecycleState>;
};

/** A manifest entry describing a mirrored file. */
export type MirrorManifestEntry = {
  __typename?: 'MirrorManifestEntry';
  /** Content type: 'spec' or 'ast'. */
  contentType: Scalars['String']['output'];
  /** Content hash for change detection. */
  hash: Scalars['String']['output'];
  /** File path relative to project root. */
  path: Scalars['String']['output'];
};

/**
 * Input for moving a technical story to a different parent.
 * Supports changing between User Story parent and Epic parent (orphan).
 * @implements FS-005.7.5 - Move Technical Story to Different Parent
 */
export type MoveTechnicalStoryInput = {
  /**
   * Regressions array. Required when moving to EPIC (becoming orphan).
   * @implements FS-005.7.1 - Regressions required for orphans
   */
  regressions?: InputMaybe<Array<Scalars['String']['input']>>;
  /** ID of the target epic. Required when targetParentType is EPIC. */
  targetEpicId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Target parent type: USER_STORY or EPIC.
   * @implements FS-005.7.5 - Orphan can be attached to a User Story and vice versa
   */
  targetParentType: TechnicalStoryParentType;
  /** ID of the target user story. Required when targetParentType is USER_STORY. */
  targetUserStoryId?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * Result of a moveTicket mutation.
 * Includes post-NAP kanban state for rich mutation responses (FS-003.2.2).
 * @implements TS-055.8 - Move Ticket Mutation
 * @implements FS-003.2.2 - Rich Mutation Responses (Mandatory)
 * @implements US-120 - Dispatch fields added
 * @implements FS-006.11.1 - Dispatch Response Format
 */
export type MoveTicketResult = {
  __typename?: 'MoveTicketResult';
  /** Agent spawn instructions for PM. Empty array if no agents to spawn. @implements FS-006.11.1 */
  dispatch: Array<DispatchInstruction>;
  /** Error classification for client recovery. Null on success. @implements BS-005.22 */
  errorType: Maybe<ErrorType>;
  /** Event identifier for special workflow events. @implements FS-006.11.1 */
  event: Maybe<Scalars['String']['output']>;
  /** Parent ticket's derived column change. Null if no parent derivation occurred. @implements BS-005.17 */
  parentTransition: Maybe<ParentTransition>;
  /** Rejection reason if the move was rejected. Null on success. */
  rejection: Maybe<RejectionReason>;
  /** Full post-NAP kanban state. Null on rejection (state unchanged). */
  state: Maybe<KanbanRepresentation>;
  /** Whether the move was accepted by the container. */
  success: Scalars['Boolean']['output'];
  /** The ticket's column transition. Null if no transition occurred. @implements FS-006.11.1 */
  transition: Maybe<Transition>;
};

/**
 * Root Mutation type for all write operations
 * @implements FS-003.2.1 - Data Modification
 */
export type Mutation = {
  __typename?: 'Mutation';
  /**
   * Placeholder mutation - will be replaced with actual mutations
   * Required to have at least one field for valid schema
   */
  _placeholder: Maybe<Scalars['Boolean']['output']>;
  /**
   * Add follow-up questions to an interview question.
   * spec-writer can add follow-up questions based on PO responses.
   * Requires authentication.
   * Fails if the project is archived.
   * @implements US-027 - Interview Progress Tracking
   */
  addFollowUpQuestions: InterviewContent;
  /**
   * Archive a project. Transitions lifecycle state from ACTIVE to ARCHIVED.
   * Requires authentication and product_owner role.
   * Project must be in NORMAL control state (BS-002.9).
   * Archived projects are read-only (BS-002.5).
   * @implements FS-002.4.1 - Archive Project
   * @implements BS-002.9 - Archival Requires Normal State
   * @implements BS-002.5 - Archival Preserves State (read-only)
   * @implements FS-002.8.2 - JSON Patch Protocol
   */
  archiveProject: ProjectPatchPayload;
  /**
   * Change the authenticated user's password.
   * Requires verification of current password.
   * Use setPassword if user has no password set yet.
   * @implements FS-001.2.2 - Password Authentication (Backup)
   */
  changePassword: Scalars['Boolean']['output'];
  /**
   * Confirm a PR has been merged, moving the ticket from review to release (qa).
   * Validates that all required review labels are OK before accepting.
   * When the last iteration ticket merges, returns iteration_ready_for_release event
   * with full_regression dispatch to qa-engineer.
   * @implements US-127 - jared_merge_complete Tool
   * @implements FS-006.12.3 - Full Regression trigger condition
   * @implements FS-008.4.3 AC-4.3.17 - Review label precondition
   * @implements FS-008.4.3 AC-4.3.18 - iteration_ready_for_release event
   */
  completeMerge: MergeCompleteResult;
  /**
   * Complete a release by moving all specified tickets from release to done.
   * All tickets must be in the release column.
   * @implements US-128 - jared_release_complete Tool
   * @implements FS-008.4.3 AC-4.3.19 - release_complete moves all tickets to done
   * @implements FS-006.12.3 AC-12.3.7 - QA submits release_complete with all iteration tickets
   */
  completeRelease: ReleaseCompleteResult;
  /**
   * Create a new API key for a project.
   * Requires session authentication (not API key auth).
   * @implements US-085 - API Key Management
   */
  createApiKey: CreateApiKeyResult;
  /**
   * Create a new business rule for a specification.
   * Automatically assigns the next sequential rule number within the specification.
   * Requires authentication.
   * Fails if the project is archived.
   * @implements FS-004.2.1 - Business Rule Structure
   */
  createBusinessRule: BusinessRule;
  /**
   * Create a new epic in a milestone.
   * Validates title format, spec references (min 1), milestone exists, title uniqueness.
   * Auto-assigns next position within parent milestone.
   * Default column: 'backlog'.
   * @implements FS-005.5.2 - Create Epic
   * @implements BS-005.6 - Epics Must Have Parent Milestone
   * @implements BS-005.10 - Epic Title Format
   */
  createEpic: Epic;
  /**
   * Create a fix ticket linked to parent acceptance criteria.
   * Updates parent's enhancedACs to set fixTicketId and clear awaitingFix.
   * Returns dispatch for next scope needing fix ticket.
   * @implements US-133 - jared_create_ticket Fix Ticket Linking
   * @implements FS-008.4.3.4b - Tool Definition -- jared_create_ticket Extension
   * @implements AC-4.3.4b.1 - Sets parent.enhancedACs[i].fixTicketId
   * @implements AC-4.3.4b.2 - Clears parent.enhancedACs[i].awaitingFix
   * @implements BS-008.4.3.8 - Sequential Fix Ticket Creation Per Scope
   * @implements BS-008.4.3.9 - Per-Ticket State Isolation
   */
  createFixTicket: CreateFixTicketResult;
  /**
   * Create a new interview for a feature.
   * Creates a specification with interview content and 8 standard sections.
   * Requires authentication.
   * Fails if the project is archived.
   * @implements US-026 - Interview File Creation
   */
  createInterview: CreateInterviewResult;
  /**
   * Create a new milestone in a project.
   * Validates title format, spec references (min 1), and title uniqueness.
   * Auto-assigns next position value.
   * @implements FS-005.4.2 - Create Milestone
   * @implements BS-005.5 - Milestones Must Reference Specifications
   * @implements BS-005.9 - Milestone Title Format
   */
  createMilestone: Milestone;
  /**
   * Create a new project for the authenticated user's tenant.
   * Automatically creates a conversation with an initial AI PM welcome message.
   * Requires authentication and product_owner role.
   * @implements FS-002.1.1 - Create New Project
   * @implements FS-002.7.1 - Automatic Conversation Initiation
   * @implements US-021 - Automatic Conversation Initiation
   * @implements BS-002.2 - Mandatory Project for Platform Access
   */
  createProject: Project;
  /**
   * Create a new specification for a project.
   * Automatically assigns the next sequential specification number.
   * Requires authentication.
   * Fails if the project is archived.
   * @implements FS-004.1.1 - Create Specification via PM + spec-writer
   * @implements FS-004.6.1 - Sequential Numbering
   */
  createSpecification: Specification;
  /**
   * Create a new technical story.
   * Validates title format, impact (min 1), acceptance tests (min 1).
   * Validates regressions required for orphans (parentType = EPIC).
   * Auto-assigns next position within parent.
   * Default column: 'backlog'.
   * @implements FS-005.7.2 - Create Technical Story
   * @implements BS-005.10c - Technical Story Title Format
   * @implements FS-005.7.1 - Regressions required for orphans
   */
  createTechnicalStory: TechnicalStory;
  /**
   * Create a new user story in an epic.
   * Validates title format, spec references, epic exists, title uniqueness.
   * Auto-assigns next position within parent epic.
   * Default column: 'backlog'.
   * @implements FS-005.6.2 - Create User Story
   * @implements BS-005.10b - User Story Title Format
   */
  createUserStory: UserStory;
  /**
   * Delete a business rule.
   * Requires authentication.
   * Fails if the project is archived.
   * @implements FS-004.2.1 - Business Rule Structure
   */
  deleteBusinessRule: Scalars['Boolean']['output'];
  /**
   * Delete an epic.
   * Returns true on success.
   * @implements FS-005.5.4 - Delete Epic
   */
  deleteEpic: Scalars['Boolean']['output'];
  /**
   * Delete a milestone and all its child epics (CASCADE).
   * Returns true on success.
   * @implements FS-005.4.4 - Delete Milestone
   */
  deleteMilestone: Scalars['Boolean']['output'];
  /**
   * Delete a project. Transitions lifecycle state to PENDING_DELETION.
   * Requires re-authentication (verifyPassword mutation) before calling.
   * Requires authentication and product_owner role.
   * Project must be in NORMAL control state (BS-002.10).
   * Project will be permanently destroyed after 30-day cooling-off period (BS-002.7).
   * @implements FS-002.5.1 - Two-Phase Project Deletion
   * @implements BS-002.7 - 30-day Cooling-Off Period
   * @implements BS-002.10 - Deletion Requires Normal State
   * @implements FS-002.8.2 - JSON Patch Protocol
   */
  deleteProject: ProjectPatchPayload;
  /**
   * Delete a specification.
   * Requires authentication.
   * Fails if the project is archived.
   * Note: Specification numbers are never reused after deletion.
   * Returns rich result with success status and specification number.
   * @implements FS-004.4.1 - Delete Specification via PM
   * @implements BS-004.2 - Specification Numbers Are Immutable
   * @implements FS-003.2.2 - Rich Mutation Response
   */
  deleteSpecification: DeleteSpecificationResult;
  /**
   * Delete a technical story.
   * Returns payload with success and optional warning about parent impact.
   * @implements FS-005.7.4 - Delete Technical Story
   */
  deleteTechnicalStory: DeleteTechnicalStoryPayload;
  /**
   * Delete a user story.
   * Returns payload with success and optional warning about orphaned children.
   * @implements FS-005.6.4 - Delete User Story
   */
  deleteUserStory: DeleteUserStoryPayload;
  /**
   * Discard draft changes and return to normal state. Transitions from DRAFT to NORMAL state.
   * Sets both pmValidated and poValidated to true.
   * Requires authentication.
   * @implements FS-002.6.4 - Discard Draft Changes
   * @implements FS-002.8.2 - JSON Patch Protocol
   */
  discardDraftChanges: ProjectPatchPayload;
  /**
   * Enter draft mode for a project. Transitions from NORMAL to DRAFT state.
   * Sets both pmValidated and poValidated to false.
   * Requires authentication.
   * @implements FS-002.6 - Project Control States
   * @implements FS-002.6.1 - Control State Definitions (Normal -> Draft)
   * @implements FS-002.8.2 - JSON Patch Protocol
   */
  enterDraftMode: ProjectPatchPayload;
  /**
   * Report a release failure by moving the failing ticket back to inProgress.
   * The ticket must be in the release column. Other tickets remain in release.
   * Generates fix_regression dispatch with reason context.
   * @implements US-128 - jared_release_failed Tool
   * @implements FS-008.4.3 AC-4.3.20 - release_failed moves only specified ticket to inProgress
   * @implements FS-006.12.3 AC-12.3.8-10 - Failed ticket isolation
   */
  failRelease: ReleaseFailedResult;
  /**
   * Generate a draft specification from a completed interview.
   * Transforms interview answers into structured specification content.
   * Assigns FS-XXX.X numbers to functional requirements.
   * Creates BusinessRule entities with BS-XXX numbers.
   * Requires authentication.
   * Fails if the project is archived.
   * Fails if the interview is not complete (all 8 sections must be done).
   * @implements US-028 - Draft Specification Generation
   */
  generateDraftSpecification: GenerateDraftResult;
  /**
   * Declare consensus on a ticket, moving it from consolidation to todo.
   * This is a shortcut for when all validators have approved a ticket.
   * @implements TS-082 - Backend Schema Additions for MCP Kanban Tools
   * @implements FS-008.5.3 - MCP Tool Interface (jared_consensus)
   * @implements BS-005.20 - Rich Mutation Responses
   */
  jared_consensus: MoveTicketResult;
  /**
   * MCP alias for moveTicket.
   * Moves a ticket to a new kanban column, identical to moveTicket.
   * @implements FS-008.5.3 - MCP Tool Interface (jared_move)
   * @implements FS-008.7.2 - Rich Mutation Responses (MCP compatibility)
   * @implements BS-005.20 - Rich Mutation Responses
   */
  jared_move: MoveTicketResult;
  /**
   * MCP alias for submitQaResult.
   * Submit a QA test result for a single acceptance criterion.
   * @implements US-130 - jared_qa_result MCP tool
   * @implements FS-008.4.3.2 - Tool Definition -- jared_qa_result
   */
  jared_qa_result: QaResultResponse;
  /**
   * MCP alias for completeRelease.
   * Complete a release by moving all specified tickets from release to done.
   * @implements US-128 - jared_release_complete MCP tool
   * @implements FS-008.4.3 AC-4.3.19 - release_complete moves all tickets to done
   */
  jared_release_complete: ReleaseCompleteResult;
  /**
   * MCP alias for failRelease.
   * Report a release failure by moving the failing ticket back to inProgress.
   * @implements US-128 - jared_release_failed MCP tool
   * @implements FS-008.4.3 AC-4.3.20 - release_failed moves only specified ticket to inProgress
   */
  jared_release_failed: ReleaseFailedResult;
  /**
   * Login with email and password.
   * Note: OAuth login is handled via REST endpoints due to redirect requirements.
   * Session token is set as HTTP-only cookie, not returned in GraphQL response.
   * @implements FS-001.2.2 - Password Authentication (Backup)
   */
  login: AuthPayload;
  /**
   * Logout and invalidate current session.
   * Clears the session cookie and invalidates the session in the database.
   * @implements FS-001.5 - Session Management
   */
  logout: Scalars['Boolean']['output'];
  /**
   * Mark an interview section as complete.
   * spec-writer validates responses and marks complete when adequate.
   * Requires authentication.
   * Fails if the project is archived.
   * @implements US-027 - Interview Progress Tracking
   */
  markSectionComplete: InterviewContent;
  /**
   * Move an epic to a different milestone within the SAME project.
   * Updates milestoneId and auto-updates context field.
   * Error if target milestone is in a different project.
   * @implements FS-005.5.5 - Move Epic to Different Milestone
   */
  moveEpic: Epic;
  /**
   * Move an epic to a different kanban column.
   * Validates column transition rules (BS-005.16) and lifecycle state (BS-005.15).
   * Initializes column-specific data for consolidation, review, and qa columns.
   * @implements US-045 - Scrum Master SAM Container Skeleton
   * @implements BS-005.16 - Column Transitions
   * @implements BS-005.15 - Lifecycle State Restricts Column Changes
   * @deprecated Use moveTicket instead
   */
  moveEpicColumn: Epic;
  /**
   * Move a technical story to a different parent.
   * Supports moving from User Story to Epic (becoming orphan) and vice versa.
   * Updates parentType and parent reference.
   * Auto-updates context field.
   * Error if target parent is in a different project.
   * @implements FS-005.7.5 - Move Technical Story to Different Parent
   */
  moveTechnicalStory: TechnicalStory;
  /**
   * Move a ticket to a new kanban column.
   * Enforces all business rule guards (lifecycle, transition validity, validation status, children completeness).
   * @implements TS-055.8 - Move Ticket Mutation
   * @implements FS-005.8.2 - Acceptor Guards
   */
  moveTicket: MoveTicketResult;
  /**
   * Move a user story to a different epic within the SAME project.
   * Updates epicId and auto-updates context field.
   * Updates labels on both source and target epics.
   * Error if target epic is in a different project.
   * @implements FS-005.6.5 - Move User Story to Different Epic
   */
  moveUserStory: UserStory;
  /**
   * Register as a Product Owner.
   * Requires valid invitation code during alpha/beta phase.
   * Must be called after OAuth authentication (oauth_pending cookie present).
   * @implements FS-001.1.1 - Product Owner Registration
   * @implements BS-001.1 - Invitation Code Management
   */
  registerProductOwner: PoRegistrationPayload;
  /**
   * Reject changes and return to draft mode. Transitions from PENDING to DRAFT state.
   * Sets pmValidated to false.
   * Requires authentication.
   * @implements FS-002.6 - Project Control States
   * @implements FS-002.6.1 - Control State Definitions (Pending -> Draft)
   * @implements FS-002.8.2 - JSON Patch Protocol
   */
  rejectChanges: ProjectPatchPayload;
  /**
   * Reorder milestones within a project.
   * milestoneIds array defines new order (index 0 = position 0).
   * All milestones in the project must be included.
   * Updates positions atomically in a transaction.
   * @implements FS-005.4.5 - Reorder Milestones
   * @implements BS-005.8 - Milestone Order Represents Sequence
   */
  reorderMilestones: Array<Milestone>;
  /**
   * Revoke an existing API key.
   * Requires session authentication (not API key auth).
   * @implements US-085 - API Key Management
   */
  revokeApiKey: ApiKeyInfo;
  /**
   * Rotate an API key: revokes the old key and creates a new one.
   * Requires session authentication (not API key auth).
   * @implements US-085 - API Key Management
   */
  rotateApiKey: RotateApiKeyResult;
  /**
   * Send a message to a conversation.
   * Creates a new message from the Product Owner.
   * Requires authentication.
   * Fails if the project is archived (EC-002.9).
   * @implements FS-002.7.9 - Conversation Input Behavior
   * @implements EC-002.9 - AI PM Conversation in Archived Project
   */
  sendMessage: ConversationMessage;
  /**
   * Set a backup password for the authenticated user.
   * Can be used to set password for the first time or overwrite existing password.
   * Requires authentication.
   * @implements FS-001.2.2 - Password Authentication (Backup)
   */
  setPassword: Scalars['Boolean']['output'];
  /**
   * Submit a QA test result for a single acceptance criterion.
   * Updates the enhancedAC status, testedAt, and optionally failReason.
   * Returns aggregation data for verdict derivation and dispatch when all tested with failures.
   * @implements US-130 - jared_qa_result Tool
   * @implements FS-008.4.3.2 - Tool Definition -- jared_qa_result
   * @implements AC-4.3.2.1 - Updates enhancedACs[acIndex].status
   * @implements AC-4.3.2.2 - Updates enhancedACs[acIndex].testedAt
   * @implements AC-4.3.2.3 - Stores reason in failReason when FAIL
   * @implements AC-4.3.2.4 - Rejects if FAIL without reason
   * @implements AC-4.3.2.7 - Rejects if acIndex out of bounds
   * @implements AC-4.3.2.8 - Rejects if no enhancedACs
   * @implements AC-4.3.2.9 - Results may be submitted in any order
   * @implements AC-4.3.2.10 - Overwrites previous result
   */
  submitQaResult: QaResultResponse;
  /**
   * Submit a review label for a ticket in the review column.
   * Tracks which reviews have been submitted and their results.
   * If result is KO, auto-moves ticket to inProgress with fix_review dispatch.
   * For integration_qa with KO, parses FAILING_CHILD:{ticketId} from comment.
   * @implements US-126 - jared_review_label Tool
   * @implements FS-006.12.1 - Review Labels
   * @implements FS-008.4.3 AC-4.3.13 - KO result auto-moves ticket
   * @implements FS-008.4.3 AC-4.3.14 - fix_review dispatch on auto-move
   * @implements FS-008.4.3 AC-4.3.15 - integration_qa parses FAILING_CHILD
   * @implements FS-008.4.3 AC-4.3.16 - FAILING_CHILD moves child ticket
   */
  submitReviewLabel: ReviewLabelResult;
  /**
   * Submit validation feedback for a ticket in consolidation.
   * May trigger auto-move to todo if all feedback is APPROVED.
   * @implements TS-055.9 - Submit Validation Feedback Mutation
   * @implements FS-005.2.2 - Consolidation Validation Phase
   */
  submitValidationFeedback: SubmitFeedbackResult;
  /**
   * Sync project data (specs and ASTs) from MCP client to backend mirror storage.
   * Upserts files and deletes removed files in a single transaction.
   * @implements TS-088 - Backend Sync Endpoint
   */
  syncProjectData: SyncResult;
  /**
   * Unarchive a project. Transitions lifecycle state from ARCHIVED to ACTIVE.
   * Requires authentication and product_owner role.
   * @implements FS-002.4.2 - Unarchive Project
   * @implements FS-002.8.2 - JSON Patch Protocol
   */
  unarchiveProject: ProjectPatchPayload;
  /**
   * Update an existing business rule.
   * Requires authentication.
   * Fails if the project is archived.
   * @implements FS-004.2.1 - Business Rule Structure
   */
  updateBusinessRule: BusinessRule;
  /**
   * Update an existing epic.
   * Validates title format and spec references if changed.
   * Preserves unchanged fields.
   * @implements FS-005.5.3 - Edit Epic
   */
  updateEpic: Epic;
  /**
   * Update an interview with answers to questions.
   * Updates answers in a specific section.
   * Requires authentication.
   * Fails if the project is archived.
   * @implements US-026 - Interview File Creation
   */
  updateInterview: InterviewContent;
  /**
   * Update an existing milestone.
   * Validates title format and spec references if changed.
   * Preserves unchanged fields.
   * @implements FS-005.4.3 - Edit Milestone
   */
  updateMilestone: Milestone;
  /**
   * Update an existing project.
   * Only owner's tenant projects can be edited.
   * Archived projects cannot be edited.
   * @implements FS-002.2.1
   */
  updateProject: Project;
  /**
   * Update an existing specification.
   * Requires authentication.
   * Fails if the project is archived.
   * @implements FS-004.3.1 - Edit Specification via PM + spec-writer
   */
  updateSpecification: Specification;
  /**
   * Update an existing technical story.
   * Validates title format if changed.
   * Validates regressions required for orphans if parentType is EPIC.
   * Preserves unchanged fields.
   * @implements FS-005.7.3 - Edit Technical Story
   */
  updateTechnicalStory: TechnicalStory;
  /**
   * Update a ticket with enhanced acceptance criteria.
   * Validates enhancedACs array structure and business rules.
   * @implements US-132 - jared_update_ticket Enhanced AC Extension
   * @implements FS-008.4.3.4 - Tool Definition -- jared_update_ticket Extension
   * @implements AC-4.3.4.1 - enhancedACs replaces entire array
   * @implements AC-4.3.4.2 - Validates enhancedACs length matches acceptanceCriteria length
   * @implements AC-4.3.4.3 - Validates each enhancedAC.index matches array position
   * @implements AC-4.3.4.4 - User Stories require at least one BROWSER AC
   * @implements AC-4.3.4.5 - Validation failures return INVALID_INPUT
   */
  updateTicketEnhancedACs: UpdateTicketResult;
  /**
   * Update an existing user story.
   * Validates title format and spec references if changed.
   * Preserves unchanged fields.
   * @implements FS-005.6.3 - Edit User Story
   */
  updateUserStory: UserStory;
  /**
   * Validate the project as PM. Transitions from DRAFT to PENDING state.
   * Sets pmValidated to true.
   * Requires authentication.
   * @implements FS-002.6 - Project Control States
   * @implements FS-002.6.1 - Control State Definitions (Draft -> Pending)
   * @implements FS-002.8.2 - JSON Patch Protocol
   */
  validateAsPm: ProjectPatchPayload;
  /**
   * Validate the project as PO. Transitions from PENDING to NORMAL state.
   * Sets poValidated to true.
   * Requires authentication.
   * @implements FS-002.6 - Project Control States
   * @implements FS-002.6.1 - Control State Definitions (Pending -> Normal)
   * @implements FS-002.8.2 - JSON Patch Protocol
   */
  validateAsPo: ProjectPatchPayload;
  /**
   * Verify the user's password for re-authentication.
   * Used before sensitive operations like project deletion.
   * Returns true if password matches, throws error if invalid.
   * Implements rate limiting (5 attempts, then 15-minute lockout).
   * @implements FS-001.6.1 - Re-authentication for Sensitive Actions
   */
  verifyPassword: Scalars['Boolean']['output'];
};


/**
 * Root Mutation type for all write operations
 * @implements FS-003.2.1 - Data Modification
 */
export type MutationAddFollowUpQuestionsArgs = {
  followUpQuestions: Array<Scalars['String']['input']>;
  questionId: Scalars['String']['input'];
  sectionId: Scalars['String']['input'];
  specificationId: Scalars['ID']['input'];
};


/**
 * Root Mutation type for all write operations
 * @implements FS-003.2.1 - Data Modification
 */
export type MutationArchiveProjectArgs = {
  projectId: Scalars['ID']['input'];
};


/**
 * Root Mutation type for all write operations
 * @implements FS-003.2.1 - Data Modification
 */
export type MutationChangePasswordArgs = {
  input: ChangePasswordInput;
};


/**
 * Root Mutation type for all write operations
 * @implements FS-003.2.1 - Data Modification
 */
export type MutationCompleteMergeArgs = {
  projectId: Scalars['ID']['input'];
  ticketId: Scalars['ID']['input'];
};


/**
 * Root Mutation type for all write operations
 * @implements FS-003.2.1 - Data Modification
 */
export type MutationCompleteReleaseArgs = {
  projectId: Scalars['ID']['input'];
  ticketIds: Array<Scalars['ID']['input']>;
};


/**
 * Root Mutation type for all write operations
 * @implements FS-003.2.1 - Data Modification
 */
export type MutationCreateApiKeyArgs = {
  label?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['ID']['input'];
};


/**
 * Root Mutation type for all write operations
 * @implements FS-003.2.1 - Data Modification
 */
export type MutationCreateBusinessRuleArgs = {
  input: CreateBusinessRuleInput;
  specificationId: Scalars['ID']['input'];
};


/**
 * Root Mutation type for all write operations
 * @implements FS-003.2.1 - Data Modification
 */
export type MutationCreateEpicArgs = {
  input: CreateEpicInput;
};


/**
 * Root Mutation type for all write operations
 * @implements FS-003.2.1 - Data Modification
 */
export type MutationCreateFixTicketArgs = {
  input: CreateFixTicketInput;
  projectId: Scalars['ID']['input'];
};


/**
 * Root Mutation type for all write operations
 * @implements FS-003.2.1 - Data Modification
 */
export type MutationCreateInterviewArgs = {
  featureName: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
};


/**
 * Root Mutation type for all write operations
 * @implements FS-003.2.1 - Data Modification
 */
export type MutationCreateMilestoneArgs = {
  input: CreateMilestoneInput;
};


/**
 * Root Mutation type for all write operations
 * @implements FS-003.2.1 - Data Modification
 */
export type MutationCreateProjectArgs = {
  input: CreateProjectInput;
};


/**
 * Root Mutation type for all write operations
 * @implements FS-003.2.1 - Data Modification
 */
export type MutationCreateSpecificationArgs = {
  input: CreateSpecificationInput;
  projectId: Scalars['ID']['input'];
};


/**
 * Root Mutation type for all write operations
 * @implements FS-003.2.1 - Data Modification
 */
export type MutationCreateTechnicalStoryArgs = {
  input: CreateTechnicalStoryInput;
};


/**
 * Root Mutation type for all write operations
 * @implements FS-003.2.1 - Data Modification
 */
export type MutationCreateUserStoryArgs = {
  input: CreateUserStoryInput;
};


/**
 * Root Mutation type for all write operations
 * @implements FS-003.2.1 - Data Modification
 */
export type MutationDeleteBusinessRuleArgs = {
  id: Scalars['ID']['input'];
};


/**
 * Root Mutation type for all write operations
 * @implements FS-003.2.1 - Data Modification
 */
export type MutationDeleteEpicArgs = {
  id: Scalars['ID']['input'];
};


/**
 * Root Mutation type for all write operations
 * @implements FS-003.2.1 - Data Modification
 */
export type MutationDeleteMilestoneArgs = {
  id: Scalars['ID']['input'];
};


/**
 * Root Mutation type for all write operations
 * @implements FS-003.2.1 - Data Modification
 */
export type MutationDeleteProjectArgs = {
  projectId: Scalars['ID']['input'];
};


/**
 * Root Mutation type for all write operations
 * @implements FS-003.2.1 - Data Modification
 */
export type MutationDeleteSpecificationArgs = {
  id: Scalars['ID']['input'];
};


/**
 * Root Mutation type for all write operations
 * @implements FS-003.2.1 - Data Modification
 */
export type MutationDeleteTechnicalStoryArgs = {
  id: Scalars['ID']['input'];
};


/**
 * Root Mutation type for all write operations
 * @implements FS-003.2.1 - Data Modification
 */
export type MutationDeleteUserStoryArgs = {
  id: Scalars['ID']['input'];
};


/**
 * Root Mutation type for all write operations
 * @implements FS-003.2.1 - Data Modification
 */
export type MutationDiscardDraftChangesArgs = {
  projectId: Scalars['ID']['input'];
};


/**
 * Root Mutation type for all write operations
 * @implements FS-003.2.1 - Data Modification
 */
export type MutationEnterDraftModeArgs = {
  projectId: Scalars['ID']['input'];
};


/**
 * Root Mutation type for all write operations
 * @implements FS-003.2.1 - Data Modification
 */
export type MutationFailReleaseArgs = {
  projectId: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
  ticketId: Scalars['ID']['input'];
};


/**
 * Root Mutation type for all write operations
 * @implements FS-003.2.1 - Data Modification
 */
export type MutationGenerateDraftSpecificationArgs = {
  specificationId: Scalars['ID']['input'];
};


/**
 * Root Mutation type for all write operations
 * @implements FS-003.2.1 - Data Modification
 */
export type MutationJared_ConsensusArgs = {
  projectId: Scalars['ID']['input'];
  ticketId: Scalars['ID']['input'];
};


/**
 * Root Mutation type for all write operations
 * @implements FS-003.2.1 - Data Modification
 */
export type MutationJared_MoveArgs = {
  column: KanbanColumn;
  projectId: Scalars['ID']['input'];
  ticketId: Scalars['ID']['input'];
};


/**
 * Root Mutation type for all write operations
 * @implements FS-003.2.1 - Data Modification
 */
export type MutationJared_Qa_ResultArgs = {
  input: QaResultInput;
  projectId: Scalars['ID']['input'];
  ticketId: Scalars['ID']['input'];
};


/**
 * Root Mutation type for all write operations
 * @implements FS-003.2.1 - Data Modification
 */
export type MutationJared_Release_CompleteArgs = {
  projectId: Scalars['ID']['input'];
  ticketIds: Array<Scalars['ID']['input']>;
};


/**
 * Root Mutation type for all write operations
 * @implements FS-003.2.1 - Data Modification
 */
export type MutationJared_Release_FailedArgs = {
  projectId: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
  ticketId: Scalars['ID']['input'];
};


/**
 * Root Mutation type for all write operations
 * @implements FS-003.2.1 - Data Modification
 */
export type MutationLoginArgs = {
  input: LoginInput;
};


/**
 * Root Mutation type for all write operations
 * @implements FS-003.2.1 - Data Modification
 */
export type MutationMarkSectionCompleteArgs = {
  sectionId: Scalars['String']['input'];
  specificationId: Scalars['ID']['input'];
};


/**
 * Root Mutation type for all write operations
 * @implements FS-003.2.1 - Data Modification
 */
export type MutationMoveEpicArgs = {
  id: Scalars['ID']['input'];
  targetMilestoneId: Scalars['ID']['input'];
};


/**
 * Root Mutation type for all write operations
 * @implements FS-003.2.1 - Data Modification
 */
export type MutationMoveEpicColumnArgs = {
  epicId: Scalars['ID']['input'];
  toColumn: KanbanColumn;
};


/**
 * Root Mutation type for all write operations
 * @implements FS-003.2.1 - Data Modification
 */
export type MutationMoveTechnicalStoryArgs = {
  id: Scalars['ID']['input'];
  input: MoveTechnicalStoryInput;
};


/**
 * Root Mutation type for all write operations
 * @implements FS-003.2.1 - Data Modification
 */
export type MutationMoveTicketArgs = {
  projectId: Scalars['String']['input'];
  ticketId: Scalars['String']['input'];
  toColumn: KanbanColumn;
};


/**
 * Root Mutation type for all write operations
 * @implements FS-003.2.1 - Data Modification
 */
export type MutationMoveUserStoryArgs = {
  id: Scalars['ID']['input'];
  targetEpicId: Scalars['ID']['input'];
};


/**
 * Root Mutation type for all write operations
 * @implements FS-003.2.1 - Data Modification
 */
export type MutationRegisterProductOwnerArgs = {
  input: RegisterPoInput;
};


/**
 * Root Mutation type for all write operations
 * @implements FS-003.2.1 - Data Modification
 */
export type MutationRejectChangesArgs = {
  projectId: Scalars['ID']['input'];
};


/**
 * Root Mutation type for all write operations
 * @implements FS-003.2.1 - Data Modification
 */
export type MutationReorderMilestonesArgs = {
  milestoneIds: Array<Scalars['ID']['input']>;
  projectId: Scalars['ID']['input'];
};


/**
 * Root Mutation type for all write operations
 * @implements FS-003.2.1 - Data Modification
 */
export type MutationRevokeApiKeyArgs = {
  keyId: Scalars['ID']['input'];
};


/**
 * Root Mutation type for all write operations
 * @implements FS-003.2.1 - Data Modification
 */
export type MutationRotateApiKeyArgs = {
  keyId: Scalars['ID']['input'];
};


/**
 * Root Mutation type for all write operations
 * @implements FS-003.2.1 - Data Modification
 */
export type MutationSendMessageArgs = {
  conversationId: Scalars['ID']['input'];
  input: SendMessageInput;
};


/**
 * Root Mutation type for all write operations
 * @implements FS-003.2.1 - Data Modification
 */
export type MutationSetPasswordArgs = {
  input: SetPasswordInput;
};


/**
 * Root Mutation type for all write operations
 * @implements FS-003.2.1 - Data Modification
 */
export type MutationSubmitQaResultArgs = {
  input: QaResultInput;
  projectId: Scalars['ID']['input'];
  ticketId: Scalars['ID']['input'];
};


/**
 * Root Mutation type for all write operations
 * @implements FS-003.2.1 - Data Modification
 */
export type MutationSubmitReviewLabelArgs = {
  comment?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['ID']['input'];
  result: ReviewResult;
  reviewType: ReviewType;
  ticketId: Scalars['ID']['input'];
};


/**
 * Root Mutation type for all write operations
 * @implements FS-003.2.1 - Data Modification
 */
export type MutationSubmitValidationFeedbackArgs = {
  feedback: ValidationFeedbackInput;
  projectId: Scalars['String']['input'];
  ticketId: Scalars['String']['input'];
};


/**
 * Root Mutation type for all write operations
 * @implements FS-003.2.1 - Data Modification
 */
export type MutationSyncProjectDataArgs = {
  changes: SyncChangesInput;
  projectId: Scalars['ID']['input'];
};


/**
 * Root Mutation type for all write operations
 * @implements FS-003.2.1 - Data Modification
 */
export type MutationUnarchiveProjectArgs = {
  projectId: Scalars['ID']['input'];
};


/**
 * Root Mutation type for all write operations
 * @implements FS-003.2.1 - Data Modification
 */
export type MutationUpdateBusinessRuleArgs = {
  id: Scalars['ID']['input'];
  input: UpdateBusinessRuleInput;
};


/**
 * Root Mutation type for all write operations
 * @implements FS-003.2.1 - Data Modification
 */
export type MutationUpdateEpicArgs = {
  id: Scalars['ID']['input'];
  input: UpdateEpicInput;
};


/**
 * Root Mutation type for all write operations
 * @implements FS-003.2.1 - Data Modification
 */
export type MutationUpdateInterviewArgs = {
  input: UpdateInterviewInput;
  specificationId: Scalars['ID']['input'];
};


/**
 * Root Mutation type for all write operations
 * @implements FS-003.2.1 - Data Modification
 */
export type MutationUpdateMilestoneArgs = {
  id: Scalars['ID']['input'];
  input: UpdateMilestoneInput;
};


/**
 * Root Mutation type for all write operations
 * @implements FS-003.2.1 - Data Modification
 */
export type MutationUpdateProjectArgs = {
  id: Scalars['ID']['input'];
  input: UpdateProjectInput;
};


/**
 * Root Mutation type for all write operations
 * @implements FS-003.2.1 - Data Modification
 */
export type MutationUpdateSpecificationArgs = {
  id: Scalars['ID']['input'];
  input: UpdateSpecificationInput;
};


/**
 * Root Mutation type for all write operations
 * @implements FS-003.2.1 - Data Modification
 */
export type MutationUpdateTechnicalStoryArgs = {
  id: Scalars['ID']['input'];
  input: UpdateTechnicalStoryInput;
};


/**
 * Root Mutation type for all write operations
 * @implements FS-003.2.1 - Data Modification
 */
export type MutationUpdateTicketEnhancedACsArgs = {
  input: UpdateTicketEnhancedACsInput;
  projectId: Scalars['ID']['input'];
  ticketId: Scalars['ID']['input'];
};


/**
 * Root Mutation type for all write operations
 * @implements FS-003.2.1 - Data Modification
 */
export type MutationUpdateUserStoryArgs = {
  id: Scalars['ID']['input'];
  input: UpdateUserStoryInput;
};


/**
 * Root Mutation type for all write operations
 * @implements FS-003.2.1 - Data Modification
 */
export type MutationValidateAsPmArgs = {
  projectId: Scalars['ID']['input'];
};


/**
 * Root Mutation type for all write operations
 * @implements FS-003.2.1 - Data Modification
 */
export type MutationValidateAsPoArgs = {
  projectId: Scalars['ID']['input'];
};


/**
 * Root Mutation type for all write operations
 * @implements FS-003.2.1 - Data Modification
 */
export type MutationVerifyPasswordArgs = {
  input: VerifyPasswordInput;
};

/**
 * Information about the next recommended question to ask.
 * Used by spec-writer to continue the interview.
 * @implements US-027 - Interview Progress Tracking
 * @implements FS-004.3.2 - Resume In-Progress Work
 */
export type NextQuestionInfo = {
  __typename?: 'NextQuestionInfo';
  /** Question ID */
  questionId: Scalars['String']['output'];
  /** Question order within section */
  questionOrder: Scalars['Int']['output'];
  /** The question text */
  questionText: Scalars['String']['output'];
  /** Section ID containing the next question */
  sectionId: Scalars['String']['output'];
  /** Section display name */
  sectionName: Scalars['String']['output'];
  /** Section order/index (1-8) */
  sectionOrder: Scalars['Int']['output'];
};

/**
 * Registration result for Product Owner.
 * Returned after successful PO registration with invitation code.
 * @implements FS-001.1.1 - Product Owner Registration
 * @implements BS-001.2 - One Tenant Per Product Owner
 * @implements FS-003.5.2 - WebSocket Authentication
 */
export type PoRegistrationPayload = {
  __typename?: 'PORegistrationPayload';
  /**
   * Redirect URL for mandatory project creation
   * @implements BS-001.4 - Mandatory First Project
   */
  redirectTo: Scalars['String']['output'];
  /**
   * Session token for WebSocket authentication.
   * Store in localStorage and pass in WebSocket connectionParams.
   * @implements FS-003.5.2 - WebSocket Authentication
   */
  sessionToken: Scalars['String']['output'];
  /**
   * The tenant automatically created for the Product Owner
   * @implements BS-001.2 - One Tenant Per Product Owner
   */
  tenant: Tenant;
  /** The newly registered Product Owner user */
  user: User;
};

/**
 * Maps a parent ticket ID to its derived kanban column.
 * @implements TS-056.1 - ParentColumnEntry SDL type
 * @implements BS-005.17 - Parent Column Derivation
 */
export type ParentColumnEntry = {
  __typename?: 'ParentColumnEntry';
  /** The derived kanban column for this parent. */
  column: KanbanColumn;
  /** The parent ticket ID (milestone). */
  ticketId: Scalars['ID']['output'];
};

/**
 * Records a parent ticket's derived column change.
 * @implements US-120 - ParentTransition type
 * @implements BS-005.17 - Parent Column Derivation
 * @implements FS-006.11.1 - parentTransition field in dispatch response
 */
export type ParentTransition = {
  __typename?: 'ParentTransition';
  /** The derived column (always present since derivation always produces a column). */
  derivedColumn: KanbanColumn;
  /** The parent ticket whose column was derived. */
  ticketId: Scalars['ID']['output'];
};

/**
 * PM typing indicator payload.
 * @implements US-025c - Typing indicator support
 */
export type PmTypingIndicator = {
  __typename?: 'PmTypingIndicator';
  /** The conversation ID */
  conversationId: Scalars['ID']['output'];
  /** Current typing status */
  status: PmTypingStatus;
};

/**
 * PM typing status enum.
 * @implements US-025c - Typing indicator support
 * @implements FS-002.7.11 - AI PM Response Delivery
 */
export type PmTypingStatus =
  /** PM has finished typing */
  | 'IDLE'
  /** PM is generating a response */
  | 'TYPING';

/**
 * Project belonging to a tenant.
 * Represents a work-in-progress product managed by a Product Owner.
 * @implements FS-002.1.3 - Project Fields
 */
export type Project = {
  __typename?: 'Project';
  /**
   * Project control state (normal, draft, pending).
   * @implements FS-002.1.3
   * @implements FS-002.6.1
   */
  controlState: Scalars['String']['output'];
  /**
   * ID of the active conversation for this project.
   * Created automatically when the project is created.
   * @implements FS-002.7.1 - Automatic Conversation Initiation
   * @implements US-021 - Automatic Conversation Initiation
   */
  conversationId: Maybe<Scalars['ID']['output']>;
  /** Timestamp when the project was created */
  createdAt: Scalars['DateTime']['output'];
  /**
   * Timestamp when deletion was requested.
   * Set when project enters PENDING_DELETION state.
   * @implements FS-002.5.1 - Two-Phase Project Deletion
   */
  deletionRequestedAt: Maybe<Scalars['DateTime']['output']>;
  /**
   * Optional project description. Limited to 256 characters.
   * @implements FS-002.1.3
   * @implements BS-002.4
   */
  description: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the project */
  id: Scalars['ID']['output'];
  /**
   * Project lifecycle state (active, archived, pending_deletion).
   * @implements FS-002.1.3
   */
  lifecycleState: Scalars['String']['output'];
  /**
   * PM validation flag. Combined with poValidated, determines control state.
   * NORMAL: pmValidated && poValidated
   * DRAFT: !pmValidated
   * PENDING: pmValidated && !poValidated
   * @implements FS-002.6.1 - Control State Definitions
   */
  pmValidated: Scalars['Boolean']['output'];
  /**
   * PO validation flag. Combined with pmValidated, determines control state.
   * @implements FS-002.6.1 - Control State Definitions
   */
  poValidated: Scalars['Boolean']['output'];
  /**
   * Date when project will be permanently destroyed.
   * Set to 30 days from deletion request.
   * @implements BS-002.7 - 30-day Cooling-Off Period
   */
  scheduledDestructionDate: Maybe<Scalars['DateTime']['output']>;
  /**
   * Project subscription tier (PRO or ENTERPRISE).
   * @implements FS-008.2 - Tier Model (Pro and Enterprise)
   * @implements BS-005.21 - Subscription Tier Enforcement
   */
  tier: ProjectTier;
  /**
   * Project title. Required and unique within tenant.
   * @implements FS-002.1.3
   * @implements BS-002.3
   */
  title: Scalars['String']['output'];
  /** Timestamp when the project was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

/**
 * Payload returned by control state mutations.
 * Contains both the updated project and the JSON Patch describing changes.
 * @implements FS-002.6 - Project Control States
 * @implements FS-002.8.2 - JSON Patch Protocol
 */
export type ProjectPatchPayload = {
  __typename?: 'ProjectPatchPayload';
  /**
   * Array of JSON Patch operations describing the changes made.
   * Clients can apply this patch to update their local state.
   */
  patch: Array<JsonPatchOperation>;
  /** The updated project after the control state change. */
  project: Project;
};

/**
 * Project subscription tier.
 * @implements FS-008.2 - Tier Model (Pro and Enterprise)
 * @implements BS-005.21 - Subscription Tier Enforcement
 */
export type ProjectTier =
  | 'ENTERPRISE'
  | 'PRO';

/**
 * Input for submitQaResult mutation.
 * @implements US-130 - jared_qa_result Tool
 * @implements FS-008.4.3.2 - Tool Definition -- jared_qa_result
 * @implements AC-4.3.2.4 - reason required when status is FAIL
 */
export type QaResultInput = {
  /** 0-based index of the acceptance criterion being reported. */
  acIndex: Scalars['Int']['input'];
  /** Explanation for failure. Required when status is FAIL. */
  reason?: InputMaybe<Scalars['String']['input']>;
  /** Test result: PASS, FAIL, or BLOCKED. */
  status: AcStatus;
};

/**
 * Result of submitQaResult mutation.
 * Contains aggregation data for verdict derivation and dispatch for failure case.
 * @implements US-130 - jared_qa_result Tool
 * @implements FS-008.4.3.2 - Tool Definition -- jared_qa_result
 * @implements AC-4.3.2.5 - allTested computed when no AC has PENDING status
 * @implements AC-4.3.2.6 - allPassed computed when all ACs are PASS
 * @implements AC-4.3.2.11 - Response includes ticketId
 * @implements AC-4.3.2.12 - Includes dispatch when allTested with hasFailures
 * @implements BS-008.4.3.4 - Derived Verdict from Per-AC Results
 */
export type QaResultResponse = {
  __typename?: 'QaResultResponse';
  /** True when all ACs are PASS. Only present when allTested is true. */
  allPassed: Maybe<Scalars['Boolean']['output']>;
  /** True when all ACs have non-PENDING and non-BLOCKED status (testing complete). */
  allTested: Scalars['Boolean']['output'];
  /** Agent spawn instructions. Present when allTested is true and hasFailures is true. */
  dispatch: Maybe<Array<DispatchInstruction>>;
  /** Error classification for client recovery. Null on success. */
  errorType: Maybe<ErrorType>;
  /** True when any AC has FAIL status. */
  hasFailures: Scalars['Boolean']['output'];
  /** Rejection reason if validation failed. Null on success. */
  rejection: Maybe<RejectionReason>;
  /** Whether the submission was successful. */
  success: Scalars['Boolean']['output'];
  /** Echo back ticket ID for cross-ticket interleaving. */
  ticketId: Scalars['ID']['output'];
};

/**
 * Root Query type for all read operations
 * @implements FS-003.1.1 - Data Retrieval
 */
export type Query = {
  __typename?: 'Query';
  /**
   * List all API keys for a project.
   * Requires session authentication (not API key auth).
   * @implements US-085 - API Key Management
   */
  apiKeys: Array<ApiKeyInfo>;
  /**
   * Returns tickets available for pickup in the specified column.
   * A ticket is available if its dependencies are satisfied (parent in same or later column).
   * Rejects with CONSOLIDATION_NOT_EMPTY if any ticket is in the consolidation column (BS-006.9).
   * @implements US-125 - jared_available Tool
   * @implements FS-008.4.3 AC-4.3.12 - Available tickets query
   * @implements BS-006.9 - Consolidation must be empty before implementation
   */
  availableTickets: AvailableTicketsResult;
  /**
   * Get all business rules for a specification.
   * Returns business rules ordered by rule number ascending.
   * @implements FS-004.2.1 - Business Rule Structure
   */
  businessRules: Array<BusinessRule>;
  /**
   * Check the impact of deleting a specification on roadmap items.
   * Returns a report of milestones and epics that reference the specification.
   * @implements FS-004.4.1 - Delete Specification
   * @implements FS-004.7.1 - Spec-Roadmap Consistency
   */
  checkSpecificationDeletionImpact: DeletionImpact;
  /**
   * Get a single conversation by ID.
   * Only returns conversation if owned by authenticated user's tenant.
   * Returns null if conversation not found or not owned by user's tenant.
   * @implements FS-002.7.4 - Conversation History Persistence
   * @implements BS-002.11 - AI PM Conversation is Project-Scoped
   */
  conversation: Maybe<Conversation>;
  /**
   * Get all conversations for a project.
   * Only returns conversations if project is owned by authenticated user's tenant.
   * @implements FS-002.7.4 - Conversation History Persistence
   * @implements BS-002.11 - AI PM Conversation is Project-Scoped
   */
  conversations: Array<Conversation>;
  /**
   * Get in-progress edit interviews for a project.
   * Used for resume detection by the PM agent.
   * Returns specifications that have in-progress edit interviews.
   * @implements FS-004.3.2 - Resume In-Progress Work
   */
  editInterviews: Array<Specification>;
  /**
   * Get a single epic by ID.
   * Returns null if not found.
   * @implements FS-005.5 - Epic Management
   */
  getEpic: Maybe<Epic>;
  /**
   * Get all epics for a project with optional filtering.
   * Returns epics in position order (ASC) within their parent milestone.
   * Default behavior excludes archived epics.
   * @implements FS-005.5 - Epic Management
   */
  getEpics: Array<Epic>;
  /**
   * Get all epics for a specific milestone.
   * Convenience query equivalent to getEpics with milestoneId filter.
   * Returns epics in position order (ASC).
   * @implements FS-005.5 - Epic Management
   */
  getEpicsByMilestone: Array<Epic>;
  /**
   * Get a single milestone by ID.
   * Returns null if not found.
   * @implements FS-005.4 - Milestone Management
   */
  getMilestone: Maybe<Milestone>;
  /**
   * Get all milestones for a project.
   * Returns milestones in position order (ASC).
   * Default behavior excludes archived milestones.
   * @implements FS-005.4 - Milestone Management
   */
  getMilestones: Array<Milestone>;
  /**
   * Get all orphan technical stories for a specific epic.
   * Returns technical stories with parentType = EPIC in position order (ASC).
   * @implements FS-005.7 - Technical Story Management
   */
  getOrphanTechnicalStoriesByEpic: Array<TechnicalStory>;
  /**
   * Get all technical stories for a project with optional filtering.
   * Returns technical stories in position order (ASC) within their parent.
   * Default behavior excludes archived technical stories.
   * @implements FS-005.7 - Technical Story Management
   */
  getTechnicalStories: Array<TechnicalStory>;
  /**
   * Get all technical stories for a specific user story.
   * Convenience query for fetching child technical stories.
   * Returns technical stories in position order (ASC).
   * @implements FS-005.7 - Technical Story Management
   */
  getTechnicalStoriesByUserStory: Array<TechnicalStory>;
  /**
   * Get a single technical story by ID.
   * Returns null if not found.
   * @implements FS-005.7 - Technical Story Management
   */
  getTechnicalStory: Maybe<TechnicalStory>;
  /**
   * Get all user stories for a project with optional filtering.
   * Returns user stories in position order (ASC) within their parent epic.
   * Default behavior excludes archived user stories.
   * @implements FS-005.6 - User Story Management
   */
  getUserStories: Array<UserStory>;
  /**
   * Get all user stories for a specific epic.
   * Convenience query equivalent to getUserStories with epicId filter.
   * Returns user stories in position order (ASC).
   * @implements FS-005.6 - User Story Management
   */
  getUserStoriesByEpic: Array<UserStory>;
  /**
   * Get a single user story by ID.
   * Returns null if not found.
   * @implements FS-005.6 - User Story Management
   */
  getUserStory: Maybe<UserStory>;
  /**
   * Health check query to verify GraphQL server is operational
   * Returns server status, timestamp, and version information
   */
  health: HealthCheck;
  /**
   * Get an interview by specification ID.
   * Returns the interview content or null if no interview exists.
   * @implements US-026 - Interview File Creation
   */
  interview: Maybe<InterviewContent>;
  /**
   * Get the progress summary for an interview.
   * Returns the progress summary or null if no interview exists.
   * @implements US-026 - Interview File Creation
   */
  interviewProgress: Maybe<InterviewProgressSummary>;
  /**
   * Get detailed progress information for an interview.
   * Includes section-by-section breakdown and next question recommendations.
   * Returns null if no interview exists.
   * @implements US-027 - Interview Progress Tracking
   * @implements FS-004.3.2 - Resume In-Progress Work
   */
  interviewProgressDetail: Maybe<InterviewProgressDetail>;
  /**
   * MCP alias for availableTickets.
   * Returns tickets available for pickup in the specified column.
   * @implements US-125 - jared_available Tool
   * @implements FS-008.4.3 AC-4.3.12 - jared_available MCP tool
   */
  jared_available: AvailableTicketsResult;
  /**
   * MCP alias for kanbanState.
   * Returns the current kanban board state, identical to kanbanState.
   * @implements FS-008.5.3 - MCP Tool Interface (jared_board)
   * @implements FS-008.7.2 - Rich Mutation Responses (MCP compatibility)
   */
  jared_board: Maybe<KanbanRepresentation>;
  /**
   * Get a single ticket from the kanban board by ID.
   * Returns null if the ticket is not found or no ScrumMaster process exists.
   * Optionally includes enhanced AC data when include.enhancedACs is true.
   * @implements TS-082 - Backend Schema Additions for MCP Kanban Tools
   * @implements FS-008.5.3 - MCP Tool Interface (jared_ticket)
   * @implements FS-008.4.3.3 - jared_ticket Extension with include parameter
   * @implements TS-238 - Update ticket query to accept include parameter
   */
  jared_ticket: Maybe<KanbanTicket>;
  /**
   * Get the current kanban board state for a project.
   * Used for initial load and reconnection recovery.
   * Returns null if no ScrumMaster process exists for the project.
   * @implements TS-056.3 - kanbanState query
   * @implements FS-005.8.8 - GraphQL Subscription Protocol
   */
  kanbanState: Maybe<KanbanRepresentation>;
  /**
   * Get current authenticated user.
   * Returns null if not authenticated.
   * This is the primary way frontend determines auth state.
   * @implements FS-001.4.1 - Role-Based Routing
   */
  me: Maybe<User>;
  /**
   * Get all projects for the authenticated user's tenant.
   * Returns projects in all lifecycle states (Active, Archived, PendingDeletion).
   * Ordered by creation date, newest first.
   * @implements FS-002.3.1 - View All Projects
   * @implements BS-002.1 - Project Ownership
   */
  myProjects: Array<Project>;
  /**
   * Returns tickets in consolidation where all validators have submitted
   * feedback but consensus has not yet been declared.
   * @implements US-098 - pendingConsensus query
   */
  pendingConsensus: Array<DashboardItem>;
  /**
   * Returns tickets awaiting PO validation (tickets in the review column).
   * @implements US-098 - pendingPoApproval query
   * @implements FS-006.9 - PO validation gates
   */
  pendingPoApproval: Array<DashboardItem>;
  /**
   * Returns tickets in consolidation that have NOT yet received all expected
   * validator feedback (< 3 feedbacks from BACKEND_DEV, FRONTEND_DEV, QA).
   * @implements US-098 - pendingValidations query
   * @implements FS-006.4 - Expected validators
   */
  pendingValidations: Array<DashboardItem>;
  /**
   * Get a single project by ID.
   * Only returns project if owned by authenticated user's tenant.
   * Returns null if project not found or not owned by user's tenant.
   * @implements FS-002.3.2 - Project Navigation
   * @implements BS-002.1 - Project Ownership
   */
  project: Maybe<Project>;
  /**
   * Get the manifest of all mirrored files for a project.
   * Used by MCP client to determine which files need syncing.
   * @implements TS-088 - Mirror Manifest Query
   */
  projectMirrorManifest: Array<MirrorManifestEntry>;
  /**
   * Get a single specification by ID.
   * Only returns specification if project is owned by authenticated user's tenant.
   * Returns null if specification not found or not owned by user's tenant.
   * @implements FS-004.5.2 - View Specification Details
   */
  specification: Maybe<Specification>;
  /**
   * Get a specification by its FS-XXX number within a project.
   * @implements FS-004.5.2 - View Specification Details
   */
  specificationByNumber: Maybe<Specification>;
  /**
   * Get the diff between previousContent and content for a specification.
   * Returns a structured diff with per-section changes.
   * Throws NO_PREVIOUS_CONTENT if the specification has never been edited.
   * @implements FS-004.3.1 - Edit Specification
   */
  specificationDiff: SpecificationDiff;
  /**
   * Get all specifications for a project.
   * Returns specifications ordered by specification number ascending.
   * @implements FS-004.5.1 - View Specification List
   */
  specifications: Array<Specification>;
};


/**
 * Root Query type for all read operations
 * @implements FS-003.1.1 - Data Retrieval
 */
export type QueryApiKeysArgs = {
  projectId: Scalars['ID']['input'];
};


/**
 * Root Query type for all read operations
 * @implements FS-003.1.1 - Data Retrieval
 */
export type QueryAvailableTicketsArgs = {
  column: KanbanColumn;
  projectId: Scalars['ID']['input'];
};


/**
 * Root Query type for all read operations
 * @implements FS-003.1.1 - Data Retrieval
 */
export type QueryBusinessRulesArgs = {
  specificationId: Scalars['ID']['input'];
};


/**
 * Root Query type for all read operations
 * @implements FS-003.1.1 - Data Retrieval
 */
export type QueryCheckSpecificationDeletionImpactArgs = {
  id: Scalars['ID']['input'];
};


/**
 * Root Query type for all read operations
 * @implements FS-003.1.1 - Data Retrieval
 */
export type QueryConversationArgs = {
  id: Scalars['ID']['input'];
};


/**
 * Root Query type for all read operations
 * @implements FS-003.1.1 - Data Retrieval
 */
export type QueryConversationsArgs = {
  projectId: Scalars['ID']['input'];
};


/**
 * Root Query type for all read operations
 * @implements FS-003.1.1 - Data Retrieval
 */
export type QueryEditInterviewsArgs = {
  projectId: Scalars['ID']['input'];
};


/**
 * Root Query type for all read operations
 * @implements FS-003.1.1 - Data Retrieval
 */
export type QueryGetEpicArgs = {
  id: Scalars['ID']['input'];
};


/**
 * Root Query type for all read operations
 * @implements FS-003.1.1 - Data Retrieval
 */
export type QueryGetEpicsArgs = {
  filter?: InputMaybe<EpicFilterInput>;
  projectId: Scalars['ID']['input'];
};


/**
 * Root Query type for all read operations
 * @implements FS-003.1.1 - Data Retrieval
 */
export type QueryGetEpicsByMilestoneArgs = {
  milestoneId: Scalars['ID']['input'];
};


/**
 * Root Query type for all read operations
 * @implements FS-003.1.1 - Data Retrieval
 */
export type QueryGetMilestoneArgs = {
  id: Scalars['ID']['input'];
};


/**
 * Root Query type for all read operations
 * @implements FS-003.1.1 - Data Retrieval
 */
export type QueryGetMilestonesArgs = {
  filter?: InputMaybe<MilestoneFilterInput>;
  projectId: Scalars['ID']['input'];
};


/**
 * Root Query type for all read operations
 * @implements FS-003.1.1 - Data Retrieval
 */
export type QueryGetOrphanTechnicalStoriesByEpicArgs = {
  epicId: Scalars['ID']['input'];
};


/**
 * Root Query type for all read operations
 * @implements FS-003.1.1 - Data Retrieval
 */
export type QueryGetTechnicalStoriesArgs = {
  filter?: InputMaybe<TechnicalStoryFilterInput>;
  projectId: Scalars['ID']['input'];
};


/**
 * Root Query type for all read operations
 * @implements FS-003.1.1 - Data Retrieval
 */
export type QueryGetTechnicalStoriesByUserStoryArgs = {
  userStoryId: Scalars['ID']['input'];
};


/**
 * Root Query type for all read operations
 * @implements FS-003.1.1 - Data Retrieval
 */
export type QueryGetTechnicalStoryArgs = {
  id: Scalars['ID']['input'];
};


/**
 * Root Query type for all read operations
 * @implements FS-003.1.1 - Data Retrieval
 */
export type QueryGetUserStoriesArgs = {
  filter?: InputMaybe<UserStoryFilterInput>;
  projectId: Scalars['ID']['input'];
};


/**
 * Root Query type for all read operations
 * @implements FS-003.1.1 - Data Retrieval
 */
export type QueryGetUserStoriesByEpicArgs = {
  epicId: Scalars['ID']['input'];
};


/**
 * Root Query type for all read operations
 * @implements FS-003.1.1 - Data Retrieval
 */
export type QueryGetUserStoryArgs = {
  id: Scalars['ID']['input'];
};


/**
 * Root Query type for all read operations
 * @implements FS-003.1.1 - Data Retrieval
 */
export type QueryInterviewArgs = {
  specificationId: Scalars['ID']['input'];
};


/**
 * Root Query type for all read operations
 * @implements FS-003.1.1 - Data Retrieval
 */
export type QueryInterviewProgressArgs = {
  specificationId: Scalars['ID']['input'];
};


/**
 * Root Query type for all read operations
 * @implements FS-003.1.1 - Data Retrieval
 */
export type QueryInterviewProgressDetailArgs = {
  specificationId: Scalars['ID']['input'];
};


/**
 * Root Query type for all read operations
 * @implements FS-003.1.1 - Data Retrieval
 */
export type QueryJared_AvailableArgs = {
  column: KanbanColumn;
  projectId: Scalars['ID']['input'];
};


/**
 * Root Query type for all read operations
 * @implements FS-003.1.1 - Data Retrieval
 */
export type QueryJared_BoardArgs = {
  projectId: Scalars['ID']['input'];
};


/**
 * Root Query type for all read operations
 * @implements FS-003.1.1 - Data Retrieval
 */
export type QueryJared_TicketArgs = {
  include?: InputMaybe<TicketIncludeInput>;
  projectId: Scalars['ID']['input'];
  ticketId: Scalars['ID']['input'];
};


/**
 * Root Query type for all read operations
 * @implements FS-003.1.1 - Data Retrieval
 */
export type QueryKanbanStateArgs = {
  projectId: Scalars['ID']['input'];
};


/**
 * Root Query type for all read operations
 * @implements FS-003.1.1 - Data Retrieval
 */
export type QueryPendingConsensusArgs = {
  projectId: Scalars['ID']['input'];
};


/**
 * Root Query type for all read operations
 * @implements FS-003.1.1 - Data Retrieval
 */
export type QueryPendingPoApprovalArgs = {
  projectId: Scalars['ID']['input'];
};


/**
 * Root Query type for all read operations
 * @implements FS-003.1.1 - Data Retrieval
 */
export type QueryPendingValidationsArgs = {
  projectId: Scalars['ID']['input'];
};


/**
 * Root Query type for all read operations
 * @implements FS-003.1.1 - Data Retrieval
 */
export type QueryProjectArgs = {
  id: Scalars['ID']['input'];
};


/**
 * Root Query type for all read operations
 * @implements FS-003.1.1 - Data Retrieval
 */
export type QueryProjectMirrorManifestArgs = {
  projectId: Scalars['ID']['input'];
};


/**
 * Root Query type for all read operations
 * @implements FS-003.1.1 - Data Retrieval
 */
export type QuerySpecificationArgs = {
  id: Scalars['ID']['input'];
};


/**
 * Root Query type for all read operations
 * @implements FS-003.1.1 - Data Retrieval
 */
export type QuerySpecificationByNumberArgs = {
  projectId: Scalars['ID']['input'];
  specificationNumber: Scalars['Int']['input'];
};


/**
 * Root Query type for all read operations
 * @implements FS-003.1.1 - Data Retrieval
 */
export type QuerySpecificationDiffArgs = {
  id: Scalars['ID']['input'];
};


/**
 * Root Query type for all read operations
 * @implements FS-003.1.1 - Data Retrieval
 */
export type QuerySpecificationsArgs = {
  projectId: Scalars['ID']['input'];
};

/**
 * Referenced artifact in a message.
 * @implements FS-002.7.7 - Referenced Artifacts
 */
export type ReferencedArtifact = {
  __typename?: 'ReferencedArtifact';
  /** ID of the referenced artifact */
  id: Scalars['ID']['output'];
  /** Type of the referenced artifact */
  type: ArtifactType;
};

/**
 * Input for Product Owner registration.
 * Requires valid invitation code during alpha/beta phase.
 * @implements FS-001.1.1 - Product Owner Registration
 * @implements BS-001.1 - Invitation Code Management
 */
export type RegisterPoInput = {
  /** Optional display name (defaults to OAuth profile name if not provided) */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /**
   * Single-use invitation code required for PO registration
   * @implements BS-001.1 - Invitation Code Management
   */
  invitationCode: Scalars['String']['input'];
};

/**
 * Reason a mutation was rejected by the ScrumMaster container acceptor guards.
 * @implements FS-005.8.2 - Acceptor Guards (Business Rule Enforcement)
 */
export type RejectionReason = {
  __typename?: 'RejectionReason';
  /** Additional details about the rejection as JSON. */
  details: Maybe<Scalars['JSON']['output']>;
  /** Machine-readable rejection reason code (e.g., PARENT_COLUMN_IS_DERIVED, INVALID_COLUMN_TRANSITION). */
  reason: Scalars['String']['output'];
};

/**
 * Result of completeRelease mutation.
 * Confirms that all regression tests passed and moves all specified tickets to done.
 * Includes dispatch fields for PM routing per FS-006.11.1.
 * @implements US-128 - jared_release_complete Tool
 * @implements FS-008.4.3 AC-4.3.19 - release_complete moves all tickets to done
 * @implements FS-006.11.1 - Dispatch Response Format
 */
export type ReleaseCompleteResult = {
  __typename?: 'ReleaseCompleteResult';
  /** Agent spawn instructions for PM. Empty array if no agents to spawn. */
  dispatch: Array<DispatchInstruction>;
  /** Error classification for client recovery. Null on success. */
  errorType: Maybe<ErrorType>;
  /** Event identifier for special workflow events. */
  event: Maybe<Scalars['String']['output']>;
  /** Parent ticket's derived column change. Null if no parent derivation occurred. */
  parentTransition: Maybe<ParentTransition>;
  /** Rejection reason if the submission was rejected. Null on success. */
  rejection: Maybe<RejectionReason>;
  /** Full post-NAP kanban state. Null on rejection (state unchanged). */
  state: Maybe<KanbanRepresentation>;
  /** Whether the release completion was accepted. */
  success: Scalars['Boolean']['output'];
  /** Transitions for each moved ticket (release -> done). Empty on rejection. */
  transitions: Array<Transition>;
};

/**
 * Result of failRelease mutation.
 * Reports a regression test failure and moves the failing ticket back to inProgress.
 * Includes dispatch fields for PM routing per FS-006.11.1.
 * @implements US-128 - jared_release_failed Tool
 * @implements FS-008.4.3 AC-4.3.20 - release_failed moves only specified ticket to inProgress
 * @implements FS-006.11.1 - Dispatch Response Format
 * @implements FS-006.12.3 AC-12.3.8-10 - Failed ticket isolation
 */
export type ReleaseFailedResult = {
  __typename?: 'ReleaseFailedResult';
  /** Agent spawn instructions for PM. Contains fix_regression dispatch. */
  dispatch: Array<DispatchInstruction>;
  /** Error classification for client recovery. Null on success. */
  errorType: Maybe<ErrorType>;
  /** Event identifier for special workflow events. */
  event: Maybe<Scalars['String']['output']>;
  /** Parent ticket's derived column change. Null if no parent derivation occurred. */
  parentTransition: Maybe<ParentTransition>;
  /** Rejection reason if the submission was rejected. Null on success. */
  rejection: Maybe<RejectionReason>;
  /** Full post-NAP kanban state. Null on rejection (state unchanged). */
  state: Maybe<KanbanRepresentation>;
  /** Whether the release failure report was accepted. */
  success: Scalars['Boolean']['output'];
  /** The failing ticket's column transition (release -> inProgress). Null on rejection. */
  transition: Maybe<Transition>;
};

/**
 * Review comment from code review process during review column.
 * @implements FS-005.2.1 - Kanban Column Structure (review column)
 * @implements FS-005.10.3 - Workflow data hoisted to top-level fields
 */
export type ReviewComment = {
  __typename?: 'ReviewComment';
  /** Optional comment text */
  comment: Maybe<Scalars['String']['output']>;
  /** The reviewer identifier */
  reviewer: Scalars['String']['output'];
  /** Whether the review approved or requested changes */
  status: ReviewCommentStatus;
  /** ISO 8601 timestamp of when the review was submitted */
  timestamp: Scalars['DateTime']['output'];
};

/**
 * Review comment status.
 * @implements FS-005.2.1 - review column
 */
export type ReviewCommentStatus =
  /** Review approved */
  | 'APPROVED'
  /** Changes requested */
  | 'CHANGES_REQUESTED';

/**
 * A review label submitted during the review column.
 * @implements FS-006.12.1 - Review Labels
 * @implements FS-005.10.3 - Workflow data hoisted to top-level fields
 */
export type ReviewLabel = {
  __typename?: 'ReviewLabel';
  /** Optional comment explaining the result */
  comment: Maybe<Scalars['String']['output']>;
  /** The result of the review (OK or KO) */
  result: ReviewResult;
  /** The type of review */
  reviewType: ReviewType;
  /** ISO 8601 timestamp of when the review was submitted */
  timestamp: Scalars['DateTime']['output'];
};

/**
 * Result of submitReviewLabel mutation.
 * Includes dispatch fields for PM routing per FS-006.11.1.
 * @implements US-126 - jared_review_label Tool
 * @implements FS-006.11.1 - Dispatch Response Format
 */
export type ReviewLabelResult = {
  __typename?: 'ReviewLabelResult';
  /** Agent spawn instructions for PM. Empty array if no agents to spawn. */
  dispatch: Array<DispatchInstruction>;
  /** Error classification for client recovery. Null on success. */
  errorType: Maybe<ErrorType>;
  /** Event identifier for special workflow events. */
  event: Maybe<Scalars['String']['output']>;
  /** Parent ticket's derived column change. Null if no parent derivation occurred. */
  parentTransition: Maybe<ParentTransition>;
  /** Rejection reason if the submission was rejected. Null on success. */
  rejection: Maybe<RejectionReason>;
  /** Full post-NAP kanban state. Null on rejection (state unchanged). */
  state: Maybe<KanbanRepresentation>;
  /** Whether the review label submission was accepted. */
  success: Scalars['Boolean']['output'];
  /** The ticket's column transition. Null if no transition occurred. */
  transition: Maybe<Transition>;
};

/**
 * Review result enum (OK or KO).
 * @implements FS-008.4.3 AC-4.3.13 - KO result auto-moves ticket
 */
export type ReviewResult =
  /** Review failed */
  | 'KO'
  /** Review passed */
  | 'OK';

/**
 * Review type enum for review labels.
 * Each type represents a different kind of review that must be completed.
 * @implements FS-006.12.1 - Review Labels
 * @implements FS-008.4.3 - jared_review_label reviewType parameter
 */
export type ReviewType =
  /** Code review by dev agent */
  | 'CODE_REVIEW'
  /** Integration QA by qa-engineer (parent tickets) */
  | 'INTEGRATION_QA'
  /** PR QA by qa-engineer (leaf tickets) */
  | 'PR_QA'
  /** Security audit by jared-security agent */
  | 'SECURITY';

/**
 * Result of rotating an API key.
 * Contains the new key info/raw key and the old (now revoked) key info.
 * @implements US-085 - API Key Management
 */
export type RotateApiKeyResult = {
  __typename?: 'RotateApiKeyResult';
  /** New API key metadata */
  newApiKey: ApiKeyInfo;
  /** New raw API key string. Only returned once at rotation time. */
  newRawKey: Scalars['String']['output'];
  /** Old API key metadata (now revoked) */
  oldApiKey: ApiKeyInfo;
};

/**
 * Detailed progress information for a single section.
 * Provides question-level breakdown of completion.
 * @implements US-027 - Interview Progress Tracking
 * @implements FS-004.1.2 - Interview File Process
 */
export type SectionProgressDetail = {
  __typename?: 'SectionProgressDetail';
  /** Number of answered questions */
  answeredQuestions: Scalars['Int']['output'];
  /** Section completion percentage (0-100) */
  completionPercentage: Scalars['Float']['output'];
  /** Section order/index (1-8) */
  order: Scalars['Int']['output'];
  /** Section ID */
  sectionId: Scalars['String']['output'];
  /** Section display name */
  sectionName: Scalars['String']['output'];
  /** Section completion status */
  status: InterviewSectionStatus;
  /** Total number of questions in section */
  totalQuestions: Scalars['Int']['output'];
};

/**
 * Input for sending a message to a conversation.
 * @implements FS-002.7.9 - Conversation Input Behavior
 */
export type SendMessageInput = {
  /** The content of the message */
  content: Scalars['String']['input'];
};

/**
 * Input for setting a password for the first time or overwriting existing password.
 * User must be authenticated to use this mutation.
 * @implements FS-001.2.2 - Password Authentication (Backup)
 */
export type SetPasswordInput = {
  /**
   * The new password to set. Must meet complexity requirements:
   * - At least 8 characters
   * - At least one uppercase letter
   * - At least one lowercase letter
   * - At least one digit
   */
  password: Scalars['String']['input'];
};

/**
 * Specification entity.
 * Stores formal specifications for features and requirements within a project.
 * @implements FS-004.2.1 - Specification Structure
 * @implements FS-004.6.1 - Sequential Numbering
 */
export type Specification = {
  __typename?: 'Specification';
  /**
   * Business rules associated with this specification.
   * @implements FS-004.2.1
   */
  businessRules: Array<BusinessRule>;
  /**
   * Specification content (overview, requirements, etc.)
   * @implements FS-004.2.1 - Specification Structure
   */
  content: SpecificationContent;
  /** Timestamp when the specification was created */
  createdAt: Scalars['DateTime']['output'];
  /**
   * Formatted specification number as FS-XXX.
   * @implements FS-004.6.1 - Sequential Numbering
   */
  formattedNumber: Scalars['String']['output'];
  /** Unique identifier for the specification */
  id: Scalars['ID']['output'];
  /**
   * Interview content if any.
   * Contains interview progress and responses.
   * @implements FS-004.1.2 - Interview File Process
   */
  interviewContent: Maybe<InterviewContent>;
  /**
   * ID of the originating conversation.
   * Links back to the conversation that created this specification.
   */
  originatingConversationId: Maybe<Scalars['ID']['output']>;
  /**
   * Previous specification content before the last edit.
   * NULL if the specification has never been edited.
   * @implements FS-004.3.1 - Edit Specification
   */
  previousContent: Maybe<SpecificationContent>;
  /** ID of the project this specification belongs to */
  projectId: Scalars['ID']['output'];
  /**
   * Specification number (sequential within project).
   * First specification is 1, incrementing for each new spec.
   * @implements FS-004.6.1 - Sequential Numbering
   */
  specificationNumber: Scalars['Int']['output'];
  /**
   * Computed status based on project's control state.
   * DRAFT when project is in DRAFT or PENDING, FINAL when NORMAL.
   * @implements BS-004.4 - Specification Status Reflects Control State
   */
  status: SpecificationStatus;
  /**
   * Specification title. Required, max 256 characters.
   * @implements FS-004.2.1
   */
  title: Scalars['String']['output'];
  /** Timestamp when the specification was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

/**
 * Specification content structure.
 * Contains all the content sections of a specification.
 * @implements FS-004.2.1 - Specification Structure
 */
export type SpecificationContent = {
  __typename?: 'SpecificationContent';
  /** Array of business rule IDs referencing the business_rules table */
  businessRuleIds: Array<Scalars['ID']['output']>;
  /** Data structures and attributes needed (described functionally) */
  dataRequirements: Scalars['String']['output'];
  /** Related specifications and external dependencies */
  dependencies: Scalars['String']['output'];
  /** Error scenarios and exceptional situations */
  edgeCases: Scalars['String']['output'];
  /** Detailed requirements with FS-XXX.X identifiers and acceptance criteria */
  functionalRequirements: Array<FunctionalRequirement>;
  /** High-level description of what this specification covers */
  overview: Scalars['String']['output'];
  /** User flows describing how users interact with the feature */
  userInteractions: Scalars['String']['output'];
};

/**
 * Input for specification content in create/update operations.
 * @implements FS-004.2.1 - Specification Structure
 */
export type SpecificationContentInput = {
  /** Array of business rule IDs */
  businessRuleIds: Array<Scalars['ID']['input']>;
  /** Data structures and attributes needed */
  dataRequirements: Scalars['String']['input'];
  /** Related specifications and external dependencies */
  dependencies: Scalars['String']['input'];
  /** Error scenarios and exceptional situations */
  edgeCases: Scalars['String']['input'];
  /** Detailed requirements with FS-XXX.X identifiers and acceptance criteria */
  functionalRequirements: Array<FunctionalRequirementInput>;
  /** High-level description of what this specification covers */
  overview: Scalars['String']['input'];
  /** User flows describing how users interact with the feature */
  userInteractions: Scalars['String']['input'];
};

/**
 * Structured diff between two versions of SpecificationContent.
 * Section-aware: compares each field of SpecificationContent independently.
 * @implements FS-004.3.1 - Edit Specification
 */
export type SpecificationDiff = {
  __typename?: 'SpecificationDiff';
  /** Diff for business rule IDs */
  businessRuleIds: BusinessRuleIdsDiff;
  /** Diff for data requirements text */
  dataRequirements: TextDiff;
  /** Diff for dependencies text */
  dependencies: TextDiff;
  /** Diff for edge cases text */
  edgeCases: TextDiff;
  /** Diffs for functional requirements (keyed by ID) */
  functionalRequirements: Array<FunctionalRequirementDiff>;
  /** Whether any changes exist */
  hasChanges: Scalars['Boolean']['output'];
  /** Diff for the overview text */
  overview: TextDiff;
  /** Diff for user interactions text */
  userInteractions: TextDiff;
};

/**
 * Specification status enum.
 * Status is COMPUTED from project.controlState, not stored.
 * - DRAFT: When project is in DRAFT or PENDING control state
 * - FINAL: When project is in NORMAL control state
 * @implements BS-004.4 - Specification Status Reflects Control State
 */
export type SpecificationStatus =
  /** Specification is a draft, project not in NORMAL state */
  | 'DRAFT'
  /** Specification is final, project in NORMAL state */
  | 'FINAL';

/**
 * Test step category for test execution plan.
 * @implements FS-008.4.3.1 - StepKind enum
 */
export type StepKind =
  /** User interaction */
  | 'ACTION'
  /** Step requiring human judgment */
  | 'MANUAL'
  /** Browser navigation */
  | 'NAVIGATE'
  /** Precondition setup (API calls, seed data) */
  | 'SETUP'
  /** Expected outcome assertion */
  | 'VERIFY';

/**
 * Result of a submitValidationFeedback mutation.
 * Includes post-NAP kanban state for rich mutation responses (FS-003.2.2).
 * @implements TS-055.9 - Submit Validation Feedback Mutation
 * @implements FS-003.2.2 - Rich Mutation Responses (Mandatory)
 * @implements US-120 - Dispatch fields added
 * @implements FS-006.11.1 - Dispatch Response Format
 */
export type SubmitFeedbackResult = {
  __typename?: 'SubmitFeedbackResult';
  /** Agent spawn instructions for PM. Empty array if no agents to spawn. @implements FS-006.11.1 */
  dispatch: Array<DispatchInstruction>;
  /** Error classification for client recovery. Null on success. @implements BS-005.22 */
  errorType: Maybe<ErrorType>;
  /** Event identifier for special workflow events. @implements FS-006.11.1 */
  event: Maybe<Scalars['String']['output']>;
  /** Parent ticket's derived column change. Null if no parent derivation occurred. @implements BS-005.17 */
  parentTransition: Maybe<ParentTransition>;
  /** Rejection reason if the submission was rejected. Null on success. */
  rejection: Maybe<RejectionReason>;
  /** Full post-NAP kanban state. Null on rejection (state unchanged). */
  state: Maybe<KanbanRepresentation>;
  /** Whether the feedback submission was accepted. */
  success: Scalars['Boolean']['output'];
  /** The ticket's column transition. Null if no transition occurred. @implements FS-006.11.1 */
  transition: Maybe<Transition>;
};

/**
 * Root Subscription type for real-time updates
 * @implements FS-003.3.1 - Real-Time Updates
 */
export type Subscription = {
  __typename?: 'Subscription';
  /**
   * Placeholder subscription - will be replaced with actual subscriptions
   * Required to have at least one field for valid schema
   */
  _placeholder: Maybe<Scalars['Boolean']['output']>;
  /**
   * Subscribe to real-time kanban board state changes for a project.
   * Each event is a self-contained full state snapshot (not a delta).
   * @implements TS-056.2 - kanbanStateChanged subscription
   * @implements FS-005.8.8 - GraphQL Subscription Protocol
   */
  kanbanStateChanged: KanbanRepresentation;
  /**
   * Subscribe to new messages in a conversation.
   * Receives messages as they are added to the conversation.
   * Channel: project:{projectId}:messages
   * @implements FS-002.7.8 - Conversation Real-Time Updates
   */
  messageReceived: ConversationMessage;
  /**
   * Subscribe to PM typing indicator in a conversation.
   * Receives status updates when PM starts/stops generating a response.
   * Channel: conversation:{conversationId}:typing
   * @implements US-025c - Typing indicator support
   * @implements FS-002.7.11 - AI PM Response Delivery
   */
  pmTypingStatus: PmTypingIndicator;
  /**
   * Subscribe to real-time project patch events.
   * Receives JSON Patch operations whenever the project's control state changes.
   * Subscriptions are scoped to specific projects - clients only receive updates for subscribed projects.
   * Uses graphql-ws protocol for WebSocket communication.
   * @implements FS-002.8 - Real-Time Collaboration
   * @implements FS-002.8.1 - Real-Time Synchronization
   * @implements FS-002.8.2 - JSON Patch Protocol
   */
  projectPatch: ProjectPatchPayload;
};


/**
 * Root Subscription type for real-time updates
 * @implements FS-003.3.1 - Real-Time Updates
 */
export type SubscriptionKanbanStateChangedArgs = {
  projectId: Scalars['ID']['input'];
};


/**
 * Root Subscription type for real-time updates
 * @implements FS-003.3.1 - Real-Time Updates
 */
export type SubscriptionMessageReceivedArgs = {
  conversationId: Scalars['ID']['input'];
};


/**
 * Root Subscription type for real-time updates
 * @implements FS-003.3.1 - Real-Time Updates
 */
export type SubscriptionPmTypingStatusArgs = {
  conversationId: Scalars['ID']['input'];
};


/**
 * Root Subscription type for real-time updates
 * @implements FS-003.3.1 - Real-Time Updates
 */
export type SubscriptionProjectPatchArgs = {
  projectId: Scalars['ID']['input'];
};

/** Input for a batch of sync changes. */
export type SyncChangesInput = {
  /** File paths to delete. */
  deleted: Array<Scalars['String']['input']>;
  /** Files to upsert (create or update). */
  files: Array<SyncFileInput>;
};

/** Input for a single file to sync. */
export type SyncFileInput = {
  /** File content as JSON (spec or AST data). */
  content: Scalars['JSON']['input'];
  /** Content type: 'spec' or 'ast'. */
  contentType: Scalars['String']['input'];
  /** Content hash for change detection (SHA-256 hex). */
  hash: Scalars['String']['input'];
  /** File path relative to project root. */
  path: Scalars['String']['input'];
};

/** Result of a sync operation. */
export type SyncResult = {
  __typename?: 'SyncResult';
  /** Error message if the sync failed. */
  error: Maybe<Scalars['String']['output']>;
  /** Number of files deleted. */
  filesDeleted: Scalars['Int']['output'];
  /** Number of files created or updated. */
  filesUpdated: Scalars['Int']['output'];
  /** Whether the sync operation succeeded. */
  success: Scalars['Boolean']['output'];
};

/**
 * TechnicalStory representing the smallest unit of internal implementation work.
 * Technical Stories are always leaf nodes (they cannot have children).
 * They can be children of User Stories or orphans attached directly to Epics.
 * @implements FS-005.7 - Technical Story Management
 * @implements FS-005.7.1 - Technical Story Template
 * @implements FS-005.10.3 - Direct column field (no wrapper)
 */
export type TechnicalStory = {
  __typename?: 'TechnicalStory';
  /**
   * Acceptance tests as array of unit tests with BS-XXX references.
   * Minimum 1 entry required.
   * @implements FS-005.7.1 - Technical Story Template (Acceptance Tests)
   */
  acceptanceTests: Array<Scalars['String']['output']>;
  /** Reason for cancellation. Only set when lifecycle is canceled. */
  cancellationReason: Maybe<Scalars['String']['output']>;
  /**
   * Current kanban column. Direct field per FS-005.10.3.
   * @implements FS-005.10.3 - Direct column field (no wrapper)
   */
  column: KanbanColumn;
  /**
   * Context describing where this technical story fits in the parent.
   * Explains the technical necessity or motivation.
   * @implements FS-005.7.1 - Technical Story Template (Context)
   */
  context: Maybe<Scalars['String']['output']>;
  /** Timestamp when the technical story was created. */
  createdAt: Scalars['DateTime']['output'];
  /**
   * Parent epic reference (null if child of User Story).
   * Loaded via field resolver.
   * @implements FS-005.7.1 - dual parent support (orphans)
   */
  epic: Maybe<Epic>;
  /**
   * ID of the parent epic (null if child of User Story).
   * @implements FS-005.7.1 - dual parent support (orphans)
   */
  epicId: Maybe<Scalars['ID']['output']>;
  /**
   * Derived boolean: true if validationErrors is non-empty.
   * @implements BS-005.24 - hasValidationErrors derived attribute
   */
  hasValidationErrors: Scalars['Boolean']['output'];
  /** Unique identifier for the technical story. */
  id: Scalars['ID']['output'];
  /**
   * Impact as array of impact entries.
   * Format: "{action}({scope}): {BS-XXX} {description}".
   * Minimum 1 entry required.
   * @implements FS-005.7.1 - Technical Story Template (Impact)
   */
  impact: Array<Scalars['String']['output']>;
  /**
   * Computed property: true if this is an orphan technical story (parentType = EPIC).
   * @implements FS-005.7.1 - isOrphan derived attribute
   */
  isOrphan: Scalars['Boolean']['output'];
  /**
   * Alias for column field for backward compatibility.
   * @implements FS-005.7 - Technical Story Management
   */
  kanbanColumn: KanbanColumn;
  /**
   * Ticket lifecycle state (active, canceled, archived).
   * @implements FS-005 Data Requirements - Ticket Lifecycle States
   */
  lifecycleState: LifecycleState;
  /**
   * Parent type indicating USER_STORY or EPIC.
   * @implements FS-005.7.1 - Technical Story parentType enum
   */
  parentType: TechnicalStoryParentType;
  /**
   * Position for ordering within the parent (user story or epic).
   * @implements FS-005.7 - Technical Story Management
   */
  position: Scalars['Int']['output'];
  /**
   * ID of the project this technical story belongs to.
   * @implements FS-005.7 - Technical Story Management
   */
  projectId: Scalars['ID']['output'];
  /**
   * Regressions as array of affected user flows.
   * Required for orphan Technical Stories (parentType = EPIC).
   * Optional for child Technical Stories (parentType = USER_STORY).
   * @implements FS-005.7.1 - Technical Story Template (Regressions)
   */
  regressions: Array<Scalars['String']['output']>;
  /**
   * Review comments during review column.
   * @implements FS-005.10.3 - Workflow data hoisted to top-level fields
   */
  reviewComments: Array<ReviewComment>;
  /**
   * Review labels during review column.
   * @implements FS-005.10.3 - Workflow data hoisted to top-level fields
   */
  reviewLabels: Array<ReviewLabel>;
  /**
   * Test results during QA column.
   * @implements FS-005.10.3 - Workflow data hoisted to top-level fields
   */
  testResults: Array<TestResult>;
  /**
   * Technical Story title. Must follow "{action}({scope}): BS-{XXX} {description}" format.
   * Unique within the project.
   * @implements BS-005.10c - Technical Story Title Format
   */
  title: Scalars['String']['output'];
  /** Timestamp when the technical story was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /**
   * Parent user story reference (null if orphan).
   * Loaded via field resolver.
   * @implements FS-005.7.1 - dual parent support
   */
  userStory: Maybe<UserStory>;
  /**
   * ID of the parent user story (null if orphan).
   * @implements FS-005.7.1 - dual parent support
   */
  userStoryId: Maybe<Scalars['ID']['output']>;
  /**
   * Validation errors from template validation.
   * @implements BS-005.24 - Template Validation via JSON Schema
   */
  validationErrors: Array<TemplateValidationError>;
  /**
   * Validation feedback from agents during consolidation.
   * @implements FS-005.10.3 - Workflow data hoisted to top-level fields
   */
  validationFeedback: Array<ValidationFeedback>;
  /**
   * Derived validation status from validationFeedback[].
   * Only relevant during consolidation. NEVER stored directly.
   * @implements FS-005.8.3 - Representation (Derived Values)
   */
  validationStatus: Maybe<ValidationStatus>;
};

/**
 * Input for filtering technical stories.
 * @implements FS-005.7 - Technical Story Management
 */
export type TechnicalStoryFilterInput = {
  /** Filter by parent epic ID (for orphans). */
  epicId?: InputMaybe<Scalars['ID']['input']>;
  /** Include archived technical stories. Default: false. */
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by kanban column. */
  kanbanColumn?: InputMaybe<KanbanColumn>;
  /**
   * Filter by lifecycle state.
   * Default behavior excludes archived technical stories.
   */
  lifecycleState?: InputMaybe<LifecycleState>;
  /** Filter by parent type (USER_STORY or EPIC). */
  parentType?: InputMaybe<TechnicalStoryParentType>;
  /** Filter by parent user story ID. */
  userStoryId?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * Enum indicating the parent type of a Technical Story.
 * USER_STORY: The Technical Story is an implementation detail of a User Story.
 * EPIC: The Technical Story is an orphan attached directly to an Epic (for refactoring/optimization).
 * @implements FS-005.7.1 - Technical Story dual parent support
 */
export type TechnicalStoryParentType =
  | 'EPIC'
  | 'USER_STORY';

/**
 * Template validation error structure.
 * @implements BS-005.24 - Template Validation via JSON Schema
 */
export type TemplateValidationError = {
  __typename?: 'TemplateValidationError';
  /** Error code for programmatic handling. */
  code: Scalars['String']['output'];
  /** The field that failed validation. */
  field: Scalars['String']['output'];
  /** Human-readable error message. */
  message: Scalars['String']['output'];
};

/**
 * Tenant (organization) created during PO registration.
 * Each Product Owner has exactly one tenant.
 * @implements BS-001.2 - One Tenant Per Product Owner
 */
export type Tenant = {
  __typename?: 'Tenant';
  /** Unique identifier for the tenant */
  id: Scalars['ID']['output'];
};

/**
 * Test result from QA testing during qa column.
 * @implements FS-005.2.1 - Kanban Column Structure (QA column)
 * @implements FS-005.10.3 - Workflow data hoisted to top-level fields
 */
export type TestResult = {
  __typename?: 'TestResult';
  /** Optional details about the test result */
  details: Maybe<Scalars['String']['output']>;
  /** Whether the test passed or failed */
  status: TestResultStatus;
  /** The type of test that was run */
  testType: TestType;
  /** ISO 8601 timestamp of when the test was completed */
  timestamp: Scalars['DateTime']['output'];
};

/**
 * Test result status.
 * @implements FS-005.2.1 - QA Column Details
 */
export type TestResultStatus =
  /** Test failed */
  | 'FAILED'
  /** Test passed */
  | 'PASSED';

/**
 * A single test step in an acceptance criterion's test plan.
 * @implements FS-008.4.3.1 - TestStep type
 */
export type TestStep = {
  __typename?: 'TestStep';
  /** Human-readable instruction */
  instruction: Scalars['String']['output'];
  /** Category of step */
  kind: StepKind;
};

/**
 * Input for a test step in an acceptance criterion's test plan.
 * @implements FS-008.4.3.1 - TestStep input type
 * @implements US-132 - TS-242 Add enhancedACs to UpdateTicketInput
 */
export type TestStepInput = {
  /** Human-readable instruction */
  instruction: Scalars['String']['input'];
  /** Category of step */
  kind: StepKind;
};

/**
 * Test type for QA column test results.
 * @implements FS-005.2.1 - QA Column Details
 */
export type TestType =
  /** Business/acceptance test */
  | 'BUSINESS'
  /** End-to-end test */
  | 'E2E'
  /** Integration test */
  | 'INTEGRATION'
  /** Unit test */
  | 'UNIT';

/**
 * A text-level diff for a single string field.
 * @implements FS-004.3.1 - Edit Specification
 */
export type TextDiff = {
  __typename?: 'TextDiff';
  /** The type of change */
  changeType: DiffChangeType;
  /** Current value (null if removed) */
  currentValue: Maybe<Scalars['String']['output']>;
  /** Previous value (null if added) */
  previousValue: Maybe<Scalars['String']['output']>;
};

/**
 * Input for controlling which optional fields to include in ticket response.
 * @implements FS-008.4.3.3 - jared_ticket Extension
 * @implements AC-4.3.3.1 - When include omitted or include.enhancedACs false, response excludes enhancedACs
 * @implements AC-4.3.3.2 - When include.enhancedACs true and ticket has enhanced ACs, response includes full array
 */
export type TicketIncludeInput = {
  /**
   * Include enhanced acceptance criteria with test planning data and execution results.
   * When false or omitted, enhancedACs field is excluded from response.
   * When true and ticket has enhanced ACs, full array is included.
   * When true and ticket has no enhanced ACs, enhancedACs is null.
   * Default: false (no eager loading per AC-4.3.3.4)
   */
  enhancedACs?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Ticket type enum.
 * @implements FS-005 - Roadmap Management
 */
export type TicketType =
  | 'EPIC'
  | 'MILESTONE'
  | 'TECHNICAL_STORY'
  | 'USER_STORY';

/**
 * Records a ticket's column transition.
 * @implements US-120 - Transition type
 * @implements FS-006.11.1 - Transition field in dispatch response
 */
export type Transition = {
  __typename?: 'Transition';
  /** The column before the transition. Null for initial placement. */
  from: Maybe<KanbanColumn>;
  /** The ticket that transitioned. */
  ticketId: Scalars['ID']['output'];
  /** The column after the transition. Null for removal. */
  to: Maybe<KanbanColumn>;
};

/**
 * Input for updating an existing business rule.
 * @implements FS-004.2.1 - Business Rule Structure
 */
export type UpdateBusinessRuleInput = {
  /** Optional updated examples */
  examples?: InputMaybe<Scalars['String']['input']>;
  /** Optional updated rationale */
  rationale?: InputMaybe<Scalars['String']['input']>;
  /** Optional updated statement */
  statement?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Input for updating an existing epic.
 * All fields are optional - only provided fields will be updated.
 * @implements FS-005.5.3 - Edit Epic
 */
export type UpdateEpicInput = {
  /** Acceptance criteria. */
  acceptanceCriteria?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Reason for cancellation. Only relevant when lifecycleState is canceled. */
  cancellationReason?: InputMaybe<Scalars['String']['input']>;
  /** Context describing motivation. */
  context?: InputMaybe<Scalars['String']['input']>;
  /** Description. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Lifecycle state. */
  lifecycleState?: InputMaybe<LifecycleState>;
  /** Spec references. At least one required if provided. */
  specReferences?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * Epic title. Must follow "EPIC - {description}" format if provided.
   * @implements BS-005.10 - Epic Title Format
   */
  title?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Input for updating interview answers.
 * @implements US-026 - Interview File Creation
 */
export type UpdateInterviewInput = {
  /** Map of question IDs to answers (as JSON object) */
  answers: Scalars['JSON']['input'];
  /** Section ID to update */
  sectionId: Scalars['String']['input'];
};

/**
 * Input for updating an existing milestone.
 * All fields are optional - only provided fields will be updated.
 * @implements FS-005.4.3 - Edit Milestone
 */
export type UpdateMilestoneInput = {
  /** Acceptance criteria. */
  acceptanceCriteria?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Reason for cancellation. Only relevant when lifecycleState is canceled. */
  cancellationReason?: InputMaybe<Scalars['String']['input']>;
  /** Description in business/marketing language. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Lifecycle state. */
  lifecycleState?: InputMaybe<LifecycleState>;
  /**
   * Spec references. At least one required if provided.
   * @implements BS-005.5 - Milestones Must Reference Specifications
   */
  specReferences?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * Milestone title. Must follow "MILESTONE - {description}" format if provided.
   * @implements BS-005.9 - Milestone Title Format
   */
  title?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Input for updating an existing project.
 * All fields are optional - only provided fields will be updated.
 * @implements FS-002.2.1
 */
export type UpdateProjectInput = {
  /**
   * Project description. Limited to 256 characters.
   * @implements FS-002.2.1
   * @implements BS-002.4
   */
  description?: InputMaybe<Scalars['String']['input']>;
  /**
   * Project title. If provided, must be unique within tenant.
   * @implements FS-002.2.1
   * @implements BS-002.3
   */
  title?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Input for updating an existing specification.
 * @implements FS-004.3.1 - Edit Specification via PM + spec-writer
 */
export type UpdateSpecificationInput = {
  /** Optional updated content */
  content?: InputMaybe<SpecificationContentInput>;
  /** Optional updated interview content */
  interviewContent?: InputMaybe<InterviewContentInput>;
  /** Optional updated title */
  title?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Input for updating an existing technical story.
 * All fields are optional - only provided fields will be updated.
 * @implements FS-005.7.3 - Edit Technical Story
 */
export type UpdateTechnicalStoryInput = {
  /** Acceptance tests array. */
  acceptanceTests?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Reason for cancellation. Only relevant when lifecycleState is canceled. */
  cancellationReason?: InputMaybe<Scalars['String']['input']>;
  /** Context describing motivation. */
  context?: InputMaybe<Scalars['String']['input']>;
  /** Impact array. */
  impact?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Lifecycle state. */
  lifecycleState?: InputMaybe<LifecycleState>;
  /** Regressions array. Required validation enforced if parentType is EPIC. */
  regressions?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * Technical Story title. Must follow "{action}({scope}): BS-{XXX} {description}" format if provided.
   * @implements BS-005.10c - Technical Story Title Format
   */
  title?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Input for updating a ticket with enhanced acceptance criteria.
 * @implements US-132 - TS-242 Add enhancedACs to UpdateTicketInput
 * @implements FS-008.4.3.4 - jared_update_ticket Extension
 * @implements AC-4.3.4.1 - enhancedACs replaces entire array (full replacement semantics)
 */
export type UpdateTicketEnhancedACsInput = {
  /**
   * Enhanced acceptance criteria array. Full replacement of existing array.
   * Length must match ticket's acceptanceCriteria array length.
   * Each enhancedAC.index must match its position in this array.
   * User Stories must have at least one AC with type: BROWSER.
   * @implements AC-4.3.4.1 - Full replacement semantics
   * @implements AC-4.3.4.2 - Length must match acceptanceCriteria
   * @implements AC-4.3.4.3 - Index must match position
   * @implements AC-4.3.4.4 - User Stories require BROWSER AC
   */
  enhancedACs: Array<EnhancedAcInput>;
};

/**
 * Result of updateTicketEnhancedACs mutation.
 * @implements US-132 - jared_update_ticket Enhanced AC Extension
 * @implements FS-008.4.3.4 AC-4.3.4.5 - Validation failures return INVALID_INPUT
 */
export type UpdateTicketResult = {
  __typename?: 'UpdateTicketResult';
  /** Error classification for client recovery. Null on success. */
  errorType: Maybe<ErrorType>;
  /** Rejection reason if validation failed. Null on success. */
  rejection: Maybe<RejectionReason>;
  /** Whether the update was successful. */
  success: Scalars['Boolean']['output'];
  /** The updated ticket. Null on failure. */
  ticket: Maybe<KanbanTicket>;
};

/**
 * Input for updating an existing user story.
 * All fields are optional - only provided fields will be updated.
 * @implements FS-005.6.3 - Edit User Story
 */
export type UpdateUserStoryInput = {
  /** Acceptance criteria. */
  acceptanceCriteria?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Business rules array. */
  businessRules?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Reason for cancellation. Only relevant when lifecycleState is canceled. */
  cancellationReason?: InputMaybe<Scalars['String']['input']>;
  /** Children references. */
  children?: InputMaybe<Array<ChildInput>>;
  /** Context describing motivation. */
  context?: InputMaybe<Scalars['String']['input']>;
  /** Description. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Impact array. */
  impact?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Lifecycle state. */
  lifecycleState?: InputMaybe<LifecycleState>;
  /** Regressions text. */
  regressions?: InputMaybe<Scalars['String']['input']>;
  /** Spec references. */
  specReferences?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * User Story title. Must follow "{Epic name}-{scope} - {description}" format if provided.
   * @implements BS-005.10b - User Story Title Format
   */
  title?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Authenticated user information.
 * Returns the core user data for authenticated users.
 * @implements FS-001.4.1 - Role-Based Routing
 * @implements FS-001.4.2 - Multiple Role Support
 */
export type User = {
  __typename?: 'User';
  /** Optional avatar URL from OAuth provider */
  avatarUrl: Maybe<Scalars['String']['output']>;
  /** Timestamp when the user account was created */
  createdAt: Scalars['DateTime']['output'];
  /** User's display name shown in the UI */
  displayName: Scalars['String']['output'];
  /**
   * User's email address (verified, unique across system)
   * @implements FS-001.1.3 - Email Uniqueness
   */
  email: Scalars['String']['output'];
  /**
   * Whether the user has set a backup password.
   * True if user can authenticate with email+password.
   * @implements FS-001.2.2 - Password Authentication (Backup)
   */
  hasPassword: Scalars['Boolean']['output'];
  /** Unique identifier for the user */
  id: Scalars['ID']['output'];
  /**
   * Primary dashboard path for the user based on their role
   * @implements FS-001.4.1 - Role-Based Routing
   */
  primaryDashboard: Scalars['String']['output'];
  /**
   * User's assigned roles (e.g., product_owner, operative)
   * @implements FS-001.4.2 - Multiple Role Support
   */
  roles: Array<Scalars['String']['output']>;
};

/**
 * UserStory representing the smallest functional unit from user perspective.
 * User Stories belong to a parent Epic and may have Technical Story children.
 * @implements FS-005.6 - User Story Management
 * @implements FS-005.6.1 - User Story Template
 * @implements FS-005.10.3 - Direct column field (no wrapper)
 */
export type UserStory = {
  __typename?: 'UserStory';
  /**
   * Acceptance criteria as array of strings.
   * @implements FS-005.6.1 - User Story Template (Acceptance Criteria)
   */
  acceptanceCriteria: Array<Scalars['String']['output']>;
  /**
   * Business rules as array of BS-XXX identifiers with descriptions.
   * @implements FS-005.6.1 - User Story Template (Business Rules)
   */
  businessRules: Array<Scalars['String']['output']>;
  /** Reason for cancellation. Only set when lifecycle is canceled. */
  cancellationReason: Maybe<Scalars['String']['output']>;
  /**
   * Children as array of Technical Story references (optional).
   * @implements FS-005.6.1 - User Story Template (Children)
   */
  children: Array<Child>;
  /**
   * Current kanban column. Direct field per FS-005.10.3.
   * @implements FS-005.10.3 - Direct column field (no wrapper)
   */
  column: KanbanColumn;
  /**
   * Context describing the parent epic link and motivation.
   * Helps put the ticket back into context when reopened.
   * @implements FS-005.6.1 - User Story Template (Context)
   */
  context: Maybe<Scalars['String']['output']>;
  /** Timestamp when the user story was created. */
  createdAt: Scalars['DateTime']['output'];
  /**
   * Description from user perspective.
   * Format: "As a [user type], I can [action] so that [benefit]" or "I can [action]".
   * @implements FS-005.6.1 - User Story Template (Description)
   */
  description: Maybe<Scalars['String']['output']>;
  /**
   * Parent epic reference.
   * Loaded via field resolver.
   * @implements FS-005.6 - User Stories belong to parent Epic
   */
  epic: Maybe<Epic>;
  /**
   * ID of the parent epic.
   * @implements FS-005.6 - User Stories belong to parent Epic
   */
  epicId: Scalars['ID']['output'];
  /**
   * Derived boolean: true if validationErrors is non-empty.
   * @implements BS-005.24 - hasValidationErrors derived attribute
   */
  hasValidationErrors: Scalars['Boolean']['output'];
  /** Unique identifier for the user story. */
  id: Scalars['ID']['output'];
  /**
   * Impact as array of ecosystem parts impacted.
   * Examples: frontend, backend, database, third-party systems.
   * @implements FS-005.6.1 - User Story Template (Impact)
   */
  impact: Array<Scalars['String']['output']>;
  /**
   * Alias for column field for backward compatibility.
   * @implements FS-005.6 - User Story Management
   */
  kanbanColumn: KanbanColumn;
  /**
   * Ticket lifecycle state (active, canceled, archived).
   * @implements FS-005 Data Requirements - Ticket Lifecycle States
   */
  lifecycleState: LifecycleState;
  /**
   * Position for ordering within the parent epic.
   * @implements FS-005.6 - User Story Management
   */
  position: Scalars['Int']['output'];
  /**
   * ID of the project this user story belongs to.
   * @implements FS-005.6 - User Story Management
   */
  projectId: Scalars['ID']['output'];
  /**
   * Regressions describing anticipated functional impacts.
   * @implements FS-005.6.1 - User Story Template (Regressions)
   */
  regressions: Maybe<Scalars['String']['output']>;
  /**
   * Review comments during review column.
   * @implements FS-005.10.3 - Workflow data hoisted to top-level fields
   */
  reviewComments: Array<ReviewComment>;
  /**
   * Review labels during review column.
   * @implements FS-005.10.3 - Workflow data hoisted to top-level fields
   */
  reviewLabels: Array<ReviewLabel>;
  /**
   * Spec references as array of FS-XXX and BS-XXX identifiers.
   * User Stories must reference at least one FS-XXX and one BS-XXX.
   * @implements FS-005.6.1 - User Story Template (Spec References)
   */
  specReferences: Array<Scalars['String']['output']>;
  /**
   * Child technical stories for this user story.
   * Returns technical stories in position order (ASC).
   * @implements FS-005.7 - Technical Story Management
   */
  technicalStories: Array<TechnicalStory>;
  /**
   * Test results during QA column.
   * @implements FS-005.10.3 - Workflow data hoisted to top-level fields
   */
  testResults: Array<TestResult>;
  /**
   * User Story title. Must follow "{Epic name}-{scope} - {description}" format.
   * Unique within the project.
   * @implements BS-005.10b - User Story Title Format
   */
  title: Scalars['String']['output'];
  /** Timestamp when the user story was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /**
   * Validation errors from template validation.
   * @implements BS-005.24 - Template Validation via JSON Schema
   */
  validationErrors: Array<TemplateValidationError>;
  /**
   * Validation feedback from agents during consolidation.
   * @implements FS-005.10.3 - Workflow data hoisted to top-level fields
   */
  validationFeedback: Array<ValidationFeedback>;
  /**
   * Derived validation status from validationFeedback[].
   * Only relevant during consolidation. NEVER stored directly.
   * @implements FS-005.8.3 - Representation (Derived Values)
   */
  validationStatus: Maybe<ValidationStatus>;
};

/**
 * Input for filtering user stories.
 * @implements FS-005.6 - User Story Management
 */
export type UserStoryFilterInput = {
  /** Filter by parent epic ID. */
  epicId?: InputMaybe<Scalars['ID']['input']>;
  /** Include archived user stories. Default: false. */
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by kanban column. */
  kanbanColumn?: InputMaybe<KanbanColumn>;
  /**
   * Filter by lifecycle state.
   * Default behavior excludes archived user stories.
   */
  lifecycleState?: InputMaybe<LifecycleState>;
};

/**
 * Agent type for validation feedback during consolidation.
 * @implements FS-005.2.2 - Consolidation Validation Phase
 */
export type ValidationAgentType =
  /** Developer agent */
  | 'DEV'
  /** QA agent */
  | 'QA';

/**
 * Validation feedback from agents during consolidation column.
 * @implements FS-005.2.2 - Consolidation Validation Phase
 * @implements FS-005.10.3 - Workflow data hoisted to top-level fields
 */
export type ValidationFeedback = {
  __typename?: 'ValidationFeedback';
  /** The type of agent providing feedback */
  agentType: ValidationAgentType;
  /** Optional detailed feedback text */
  feedback: Maybe<Scalars['String']['output']>;
  /** Whether the agent approved or found issues */
  status: ValidationFeedbackStatus;
  /** ISO 8601 timestamp of when feedback was provided */
  timestamp: Scalars['DateTime']['output'];
};

/**
 * A single validation feedback entry from a developer or QA agent.
 * @implements TS-056.1 - ValidationFeedbackEntry SDL type
 */
export type ValidationFeedbackEntry = {
  __typename?: 'ValidationFeedbackEntry';
  /** The type of agent providing feedback (BACKEND_DEV, FRONTEND_DEV, QA). */
  agentType: Scalars['String']['output'];
  /** Optional detailed feedback text. */
  feedback: Maybe<Scalars['String']['output']>;
  /** Whether the agent approved or found issues (APPROVED, ISSUES). */
  status: Scalars['String']['output'];
  /** ISO 8601 timestamp of when feedback was provided. */
  timestamp: Scalars['String']['output'];
};

/**
 * Input for submitting validation feedback from developer/QA agents.
 * @implements FS-005.2.2 - Consolidation Validation Phase
 */
export type ValidationFeedbackInput = {
  /** The type of agent providing feedback (BACKEND_DEV, FRONTEND_DEV, QA). */
  agentType: Scalars['String']['input'];
  /** Optional detailed feedback text. */
  feedback?: InputMaybe<Scalars['String']['input']>;
  /** Whether the agent approved or found issues (APPROVED, ISSUES). */
  status: Scalars['String']['input'];
  /** ISO 8601 timestamp of when feedback was provided. */
  timestamp: Scalars['String']['input'];
};

/**
 * Validation feedback status.
 * @implements FS-005.2.2 - Consolidation Validation Phase
 */
export type ValidationFeedbackStatus =
  /** Agent approved the ticket */
  | 'APPROVED'
  /** Agent found issues */
  | 'ISSUES';

/**
 * Summary of validation feedback for a dashboard item.
 * @implements US-098 - ValidationFeedbackSummary type
 */
export type ValidationFeedbackSummary = {
  __typename?: 'ValidationFeedbackSummary';
  /** Number of APPROVED feedback entries. */
  approved: Scalars['Int']['output'];
  /** Number of ISSUES feedback entries. */
  issues: Scalars['Int']['output'];
  /** Number of validators that have not yet submitted feedback. */
  pending: Scalars['Int']['output'];
  /** Total number of feedback entries received. */
  total: Scalars['Int']['output'];
};

/**
 * Derived validation status computed from validationFeedback array.
 * Never stored directly - always computed at query time.
 * Values match the string values used by resolvers.
 * @implements FS-005.8.3 - Representation (Derived Values)
 */
export type ValidationStatus =
  /** At least one feedback has ISSUES status */
  | 'issues'
  /** No feedback received yet (empty feedback array) */
  | 'pending'
  /** All feedback has APPROVED status */
  | 'validated';

/**
 * Maps a ticket ID to its derived validation status.
 * @implements TS-056.1 - ValidationStatusEntry SDL type
 * @implements FS-005.8.3 - Representation (Derived Values)
 */
export type ValidationStatusEntry = {
  __typename?: 'ValidationStatusEntry';
  /** The derived validation status. */
  status: ValidationStatus;
  /** The ticket ID. */
  ticketId: Scalars['ID']['output'];
};

/**
 * Input for verifying password for re-authentication.
 * Used before sensitive operations like project deletion.
 * @implements FS-001.6.1 - Re-authentication for Sensitive Actions
 */
export type VerifyPasswordInput = {
  /** The user's password to verify */
  password: Scalars['String']['input'];
};

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, email: string, displayName: string, roles: Array<string>, primaryDashboard: string, avatarUrl: string | null | undefined, hasPassword: boolean, createdAt: string } | null | undefined };

export type LoginMutationVariables = Exact<{
  input: LoginInput;
}>;


export type LoginMutation = { __typename?: 'Mutation', login: { __typename?: 'AuthPayload', expiresAt: string, sessionToken: string, user: { __typename?: 'User', id: string, email: string, displayName: string, roles: Array<string>, primaryDashboard: string, createdAt: string } } };

export type RegisterProductOwnerMutationVariables = Exact<{
  input: RegisterPoInput;
}>;


export type RegisterProductOwnerMutation = { __typename?: 'Mutation', registerProductOwner: { __typename?: 'PORegistrationPayload', redirectTo: string, sessionToken: string, user: { __typename?: 'User', id: string, email: string, displayName: string, roles: Array<string>, primaryDashboard: string, createdAt: string }, tenant: { __typename?: 'Tenant', id: string } } };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { __typename?: 'Mutation', logout: boolean };

export type SetPasswordMutationVariables = Exact<{
  input: SetPasswordInput;
}>;


export type SetPasswordMutation = { __typename?: 'Mutation', setPassword: boolean };

export type ChangePasswordMutationVariables = Exact<{
  input: ChangePasswordInput;
}>;


export type ChangePasswordMutation = { __typename?: 'Mutation', changePassword: boolean };

export type VerifyPasswordMutationVariables = Exact<{
  input: VerifyPasswordInput;
}>;


export type VerifyPasswordMutation = { __typename?: 'Mutation', verifyPassword: boolean };

export type ConversationMessageFieldsFragment = { __typename?: 'ConversationMessage', id: string, conversationId: string, senderType: MessageSenderType, content: string, createdAt: string, referencedArtifacts: Array<{ __typename?: 'ReferencedArtifact', type: ArtifactType, id: string }> | null | undefined, agentInvocations: Array<{ __typename?: 'AgentInvocation', agentType: AgentType, launchedAt: string, completedAt: string | null | undefined, status: AgentInvocationStatus }> | null | undefined };

export type ConversationFieldsFragment = { __typename?: 'Conversation', id: string, projectId: string, status: ConversationStatus, createdAt: string, lastActivityAt: string };

export type GetProjectConversationsQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type GetProjectConversationsQuery = { __typename?: 'Query', conversations: Array<{ __typename?: 'Conversation', id: string, projectId: string, status: ConversationStatus, createdAt: string, lastActivityAt: string }> };

export type GetConversationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetConversationQuery = { __typename?: 'Query', conversation: { __typename?: 'Conversation', id: string, projectId: string, status: ConversationStatus, createdAt: string, lastActivityAt: string, messages: Array<{ __typename?: 'ConversationMessage', id: string, conversationId: string, senderType: MessageSenderType, content: string, createdAt: string, referencedArtifacts: Array<{ __typename?: 'ReferencedArtifact', type: ArtifactType, id: string }> | null | undefined, agentInvocations: Array<{ __typename?: 'AgentInvocation', agentType: AgentType, launchedAt: string, completedAt: string | null | undefined, status: AgentInvocationStatus }> | null | undefined }> } | null | undefined };

export type SendMessageMutationVariables = Exact<{
  conversationId: Scalars['ID']['input'];
  input: SendMessageInput;
}>;


export type SendMessageMutation = { __typename?: 'Mutation', sendMessage: { __typename?: 'ConversationMessage', id: string, conversationId: string, senderType: MessageSenderType, content: string, createdAt: string, referencedArtifacts: Array<{ __typename?: 'ReferencedArtifact', type: ArtifactType, id: string }> | null | undefined, agentInvocations: Array<{ __typename?: 'AgentInvocation', agentType: AgentType, launchedAt: string, completedAt: string | null | undefined, status: AgentInvocationStatus }> | null | undefined } };

export type MessageReceivedSubscriptionVariables = Exact<{
  conversationId: Scalars['ID']['input'];
}>;


export type MessageReceivedSubscription = { __typename?: 'Subscription', messageReceived: { __typename?: 'ConversationMessage', id: string, conversationId: string, senderType: MessageSenderType, content: string, createdAt: string, referencedArtifacts: Array<{ __typename?: 'ReferencedArtifact', type: ArtifactType, id: string }> | null | undefined, agentInvocations: Array<{ __typename?: 'AgentInvocation', agentType: AgentType, launchedAt: string, completedAt: string | null | undefined, status: AgentInvocationStatus }> | null | undefined } };

export type KanbanTicketFieldsFragment = { __typename?: 'KanbanTicket', id: string, type: string, title: string, column: KanbanColumn, lifecycleState: LifecycleState, parentId: string | null | undefined, specReferences: Array<string>, acceptanceCriteria: Array<string>, description: string | null | undefined, context: string | null | undefined, children: Array<{ __typename?: 'ChildRef', id: string | null | undefined, text: string }>, validationFeedback: Array<{ __typename?: 'ValidationFeedbackEntry', agentType: string, status: string, feedback: string | null | undefined, timestamp: string }> };

export type KanbanStateQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type KanbanStateQuery = { __typename?: 'Query', kanbanState: { __typename?: 'KanbanRepresentation', tickets: Array<{ __typename?: 'KanbanTicket', id: string, type: string, title: string, column: KanbanColumn, lifecycleState: LifecycleState, parentId: string | null | undefined, specReferences: Array<string>, acceptanceCriteria: Array<string>, description: string | null | undefined, context: string | null | undefined, children: Array<{ __typename?: 'ChildRef', id: string | null | undefined, text: string }>, validationFeedback: Array<{ __typename?: 'ValidationFeedbackEntry', agentType: string, status: string, feedback: string | null | undefined, timestamp: string }> }>, parentColumns: Array<{ __typename?: 'ParentColumnEntry', ticketId: string, column: KanbanColumn }>, validationStatuses: Array<{ __typename?: 'ValidationStatusEntry', ticketId: string, status: ValidationStatus }>, ticketsByColumn: Array<{ __typename?: 'ColumnTickets', column: KanbanColumn, tickets: Array<{ __typename?: 'KanbanTicket', id: string, type: string, title: string, column: KanbanColumn, lifecycleState: LifecycleState, parentId: string | null | undefined, specReferences: Array<string>, acceptanceCriteria: Array<string>, description: string | null | undefined, context: string | null | undefined, children: Array<{ __typename?: 'ChildRef', id: string | null | undefined, text: string }>, validationFeedback: Array<{ __typename?: 'ValidationFeedbackEntry', agentType: string, status: string, feedback: string | null | undefined, timestamp: string }> }> }> } | null | undefined };

export type KanbanStateChangedSubscriptionVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type KanbanStateChangedSubscription = { __typename?: 'Subscription', kanbanStateChanged: { __typename?: 'KanbanRepresentation', tickets: Array<{ __typename?: 'KanbanTicket', id: string, type: string, title: string, column: KanbanColumn, lifecycleState: LifecycleState, parentId: string | null | undefined, specReferences: Array<string>, acceptanceCriteria: Array<string>, description: string | null | undefined, context: string | null | undefined, children: Array<{ __typename?: 'ChildRef', id: string | null | undefined, text: string }>, validationFeedback: Array<{ __typename?: 'ValidationFeedbackEntry', agentType: string, status: string, feedback: string | null | undefined, timestamp: string }> }>, parentColumns: Array<{ __typename?: 'ParentColumnEntry', ticketId: string, column: KanbanColumn }>, validationStatuses: Array<{ __typename?: 'ValidationStatusEntry', ticketId: string, status: ValidationStatus }>, ticketsByColumn: Array<{ __typename?: 'ColumnTickets', column: KanbanColumn, tickets: Array<{ __typename?: 'KanbanTicket', id: string, type: string, title: string, column: KanbanColumn, lifecycleState: LifecycleState, parentId: string | null | undefined, specReferences: Array<string>, acceptanceCriteria: Array<string>, description: string | null | undefined, context: string | null | undefined, children: Array<{ __typename?: 'ChildRef', id: string | null | undefined, text: string }>, validationFeedback: Array<{ __typename?: 'ValidationFeedbackEntry', agentType: string, status: string, feedback: string | null | undefined, timestamp: string }> }> }> } };

export type MoveTicketMutationVariables = Exact<{
  projectId: Scalars['String']['input'];
  ticketId: Scalars['String']['input'];
  toColumn: KanbanColumn;
}>;


export type MoveTicketMutation = { __typename?: 'Mutation', moveTicket: { __typename?: 'MoveTicketResult', success: boolean, errorType: ErrorType | null | undefined, rejection: { __typename?: 'RejectionReason', reason: string, details: any | null | undefined } | null | undefined, state: { __typename?: 'KanbanRepresentation', tickets: Array<{ __typename?: 'KanbanTicket', id: string, type: string, title: string, column: KanbanColumn, lifecycleState: LifecycleState, parentId: string | null | undefined, specReferences: Array<string>, acceptanceCriteria: Array<string>, description: string | null | undefined, context: string | null | undefined, children: Array<{ __typename?: 'ChildRef', id: string | null | undefined, text: string }>, validationFeedback: Array<{ __typename?: 'ValidationFeedbackEntry', agentType: string, status: string, feedback: string | null | undefined, timestamp: string }> }>, parentColumns: Array<{ __typename?: 'ParentColumnEntry', ticketId: string, column: KanbanColumn }>, validationStatuses: Array<{ __typename?: 'ValidationStatusEntry', ticketId: string, status: ValidationStatus }>, ticketsByColumn: Array<{ __typename?: 'ColumnTickets', column: KanbanColumn, tickets: Array<{ __typename?: 'KanbanTicket', id: string, type: string, title: string, column: KanbanColumn, lifecycleState: LifecycleState, parentId: string | null | undefined, specReferences: Array<string>, acceptanceCriteria: Array<string>, description: string | null | undefined, context: string | null | undefined, children: Array<{ __typename?: 'ChildRef', id: string | null | undefined, text: string }>, validationFeedback: Array<{ __typename?: 'ValidationFeedbackEntry', agentType: string, status: string, feedback: string | null | undefined, timestamp: string }> }> }> } | null | undefined } };

export type SubmitValidationFeedbackMutationVariables = Exact<{
  projectId: Scalars['String']['input'];
  ticketId: Scalars['String']['input'];
  feedback: ValidationFeedbackInput;
}>;


export type SubmitValidationFeedbackMutation = { __typename?: 'Mutation', submitValidationFeedback: { __typename?: 'SubmitFeedbackResult', success: boolean, errorType: ErrorType | null | undefined, rejection: { __typename?: 'RejectionReason', reason: string, details: any | null | undefined } | null | undefined, state: { __typename?: 'KanbanRepresentation', tickets: Array<{ __typename?: 'KanbanTicket', id: string, type: string, title: string, column: KanbanColumn, lifecycleState: LifecycleState, parentId: string | null | undefined, specReferences: Array<string>, acceptanceCriteria: Array<string>, description: string | null | undefined, context: string | null | undefined, children: Array<{ __typename?: 'ChildRef', id: string | null | undefined, text: string }>, validationFeedback: Array<{ __typename?: 'ValidationFeedbackEntry', agentType: string, status: string, feedback: string | null | undefined, timestamp: string }> }>, parentColumns: Array<{ __typename?: 'ParentColumnEntry', ticketId: string, column: KanbanColumn }>, validationStatuses: Array<{ __typename?: 'ValidationStatusEntry', ticketId: string, status: ValidationStatus }>, ticketsByColumn: Array<{ __typename?: 'ColumnTickets', column: KanbanColumn, tickets: Array<{ __typename?: 'KanbanTicket', id: string, type: string, title: string, column: KanbanColumn, lifecycleState: LifecycleState, parentId: string | null | undefined, specReferences: Array<string>, acceptanceCriteria: Array<string>, description: string | null | undefined, context: string | null | undefined, children: Array<{ __typename?: 'ChildRef', id: string | null | undefined, text: string }>, validationFeedback: Array<{ __typename?: 'ValidationFeedbackEntry', agentType: string, status: string, feedback: string | null | undefined, timestamp: string }> }> }> } | null | undefined } };

export type CreateProjectMutationVariables = Exact<{
  input: CreateProjectInput;
}>;


export type CreateProjectMutation = { __typename?: 'Mutation', createProject: { __typename?: 'Project', id: string, title: string, description: string | null | undefined, lifecycleState: string, controlState: string, createdAt: string } };

export type MyProjectsQueryVariables = Exact<{ [key: string]: never; }>;


export type MyProjectsQuery = { __typename?: 'Query', myProjects: Array<{ __typename?: 'Project', id: string, title: string, description: string | null | undefined, tier: ProjectTier, lifecycleState: string, controlState: string, createdAt: string }> };

export type GetProjectQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetProjectQuery = { __typename?: 'Query', project: { __typename?: 'Project', id: string, title: string, description: string | null | undefined, tier: ProjectTier, lifecycleState: string, controlState: string, createdAt: string, updatedAt: string } | null | undefined };

export type UpdateProjectMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateProjectInput;
}>;


export type UpdateProjectMutation = { __typename?: 'Mutation', updateProject: { __typename?: 'Project', id: string, title: string, description: string | null | undefined, lifecycleState: string, controlState: string, updatedAt: string } };

export type ProjectControlStateFieldsFragment = { __typename?: 'Project', id: string, pmValidated: boolean, poValidated: boolean, controlState: string };

export type JsonPatchFieldsFragment = { __typename?: 'JSONPatchOperation', op: string, path: string, value: any | null | undefined };

export type EnterDraftModeMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type EnterDraftModeMutation = { __typename?: 'Mutation', enterDraftMode: { __typename?: 'ProjectPatchPayload', project: { __typename?: 'Project', id: string, pmValidated: boolean, poValidated: boolean, controlState: string }, patch: Array<{ __typename?: 'JSONPatchOperation', op: string, path: string, value: any | null | undefined }> } };

export type ValidateAsPmMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type ValidateAsPmMutation = { __typename?: 'Mutation', validateAsPm: { __typename?: 'ProjectPatchPayload', project: { __typename?: 'Project', id: string, pmValidated: boolean, poValidated: boolean, controlState: string }, patch: Array<{ __typename?: 'JSONPatchOperation', op: string, path: string, value: any | null | undefined }> } };

export type ValidateAsPoMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type ValidateAsPoMutation = { __typename?: 'Mutation', validateAsPo: { __typename?: 'ProjectPatchPayload', project: { __typename?: 'Project', id: string, pmValidated: boolean, poValidated: boolean, controlState: string }, patch: Array<{ __typename?: 'JSONPatchOperation', op: string, path: string, value: any | null | undefined }> } };

export type RejectChangesMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type RejectChangesMutation = { __typename?: 'Mutation', rejectChanges: { __typename?: 'ProjectPatchPayload', project: { __typename?: 'Project', id: string, pmValidated: boolean, poValidated: boolean, controlState: string }, patch: Array<{ __typename?: 'JSONPatchOperation', op: string, path: string, value: any | null | undefined }> } };

export type DiscardDraftChangesMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type DiscardDraftChangesMutation = { __typename?: 'Mutation', discardDraftChanges: { __typename?: 'ProjectPatchPayload', project: { __typename?: 'Project', id: string, pmValidated: boolean, poValidated: boolean, controlState: string }, patch: Array<{ __typename?: 'JSONPatchOperation', op: string, path: string, value: any | null | undefined }> } };

export type ProjectPatchSubscriptionSubscriptionVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type ProjectPatchSubscriptionSubscription = { __typename?: 'Subscription', projectPatch: { __typename?: 'ProjectPatchPayload', project: { __typename?: 'Project', id: string, pmValidated: boolean, poValidated: boolean, controlState: string }, patch: Array<{ __typename?: 'JSONPatchOperation', op: string, path: string, value: any | null | undefined }> } };

export type ProjectLifecycleFieldsFragment = { __typename?: 'Project', id: string, lifecycleState: string, controlState: string };

export type ArchiveProjectMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type ArchiveProjectMutation = { __typename?: 'Mutation', archiveProject: { __typename?: 'ProjectPatchPayload', project: { __typename?: 'Project', id: string, lifecycleState: string, controlState: string }, patch: Array<{ __typename?: 'JSONPatchOperation', op: string, path: string, value: any | null | undefined }> } };

export type UnarchiveProjectMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type UnarchiveProjectMutation = { __typename?: 'Mutation', unarchiveProject: { __typename?: 'ProjectPatchPayload', project: { __typename?: 'Project', id: string, lifecycleState: string, controlState: string }, patch: Array<{ __typename?: 'JSONPatchOperation', op: string, path: string, value: any | null | undefined }> } };

export type ProjectDeletionFieldsFragment = { __typename?: 'Project', id: string, lifecycleState: string, deletionRequestedAt: string | null | undefined, scheduledDestructionDate: string | null | undefined };

export type DeleteProjectMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type DeleteProjectMutation = { __typename?: 'Mutation', deleteProject: { __typename?: 'ProjectPatchPayload', project: { __typename?: 'Project', id: string, lifecycleState: string, deletionRequestedAt: string | null | undefined, scheduledDestructionDate: string | null | undefined }, patch: Array<{ __typename?: 'JSONPatchOperation', op: string, path: string, value: any | null | undefined }> } };

export type BusinessRuleFieldsFragment = { __typename?: 'BusinessRule', id: string, specificationId: string, ruleNumber: number, formattedNumber: string, fullIdentifier: string, statement: string, rationale: string, examples: string | null | undefined, createdAt: string, updatedAt: string };

export type FunctionalRequirementFieldsFragment = { __typename?: 'FunctionalRequirement', id: string, title: string, description: string, acceptanceCriteria: Array<string> };

export type SpecificationContentFieldsFragment = { __typename?: 'SpecificationContent', overview: string, businessRuleIds: Array<string>, dataRequirements: string, userInteractions: string, edgeCases: string, dependencies: string, functionalRequirements: Array<{ __typename?: 'FunctionalRequirement', id: string, title: string, description: string, acceptanceCriteria: Array<string> }> };

export type SpecificationListItemFieldsFragment = { __typename?: 'Specification', id: string, projectId: string, specificationNumber: number, formattedNumber: string, title: string, status: SpecificationStatus, createdAt: string, updatedAt: string };

export type SpecificationDetailFieldsFragment = { __typename?: 'Specification', id: string, projectId: string, specificationNumber: number, formattedNumber: string, title: string, status: SpecificationStatus, originatingConversationId: string | null | undefined, createdAt: string, updatedAt: string, content: { __typename?: 'SpecificationContent', overview: string, businessRuleIds: Array<string>, dataRequirements: string, userInteractions: string, edgeCases: string, dependencies: string, functionalRequirements: Array<{ __typename?: 'FunctionalRequirement', id: string, title: string, description: string, acceptanceCriteria: Array<string> }> }, previousContent: { __typename?: 'SpecificationContent', overview: string, businessRuleIds: Array<string>, dataRequirements: string, userInteractions: string, edgeCases: string, dependencies: string, functionalRequirements: Array<{ __typename?: 'FunctionalRequirement', id: string, title: string, description: string, acceptanceCriteria: Array<string> }> } | null | undefined, businessRules: Array<{ __typename?: 'BusinessRule', id: string, specificationId: string, ruleNumber: number, formattedNumber: string, fullIdentifier: string, statement: string, rationale: string, examples: string | null | undefined, createdAt: string, updatedAt: string }> };

export type GetSpecificationsQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type GetSpecificationsQuery = { __typename?: 'Query', specifications: Array<{ __typename?: 'Specification', id: string, projectId: string, specificationNumber: number, formattedNumber: string, title: string, status: SpecificationStatus, createdAt: string, updatedAt: string }> };

export type GetSpecificationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetSpecificationQuery = { __typename?: 'Query', specification: { __typename?: 'Specification', id: string, projectId: string, specificationNumber: number, formattedNumber: string, title: string, status: SpecificationStatus, originatingConversationId: string | null | undefined, createdAt: string, updatedAt: string, content: { __typename?: 'SpecificationContent', overview: string, businessRuleIds: Array<string>, dataRequirements: string, userInteractions: string, edgeCases: string, dependencies: string, functionalRequirements: Array<{ __typename?: 'FunctionalRequirement', id: string, title: string, description: string, acceptanceCriteria: Array<string> }> }, previousContent: { __typename?: 'SpecificationContent', overview: string, businessRuleIds: Array<string>, dataRequirements: string, userInteractions: string, edgeCases: string, dependencies: string, functionalRequirements: Array<{ __typename?: 'FunctionalRequirement', id: string, title: string, description: string, acceptanceCriteria: Array<string> }> } | null | undefined, businessRules: Array<{ __typename?: 'BusinessRule', id: string, specificationId: string, ruleNumber: number, formattedNumber: string, fullIdentifier: string, statement: string, rationale: string, examples: string | null | undefined, createdAt: string, updatedAt: string }> } | null | undefined };

export type GetSpecificationByNumberQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  specificationNumber: Scalars['Int']['input'];
}>;


export type GetSpecificationByNumberQuery = { __typename?: 'Query', specificationByNumber: { __typename?: 'Specification', id: string, projectId: string, specificationNumber: number, formattedNumber: string, title: string, status: SpecificationStatus, originatingConversationId: string | null | undefined, createdAt: string, updatedAt: string, content: { __typename?: 'SpecificationContent', overview: string, businessRuleIds: Array<string>, dataRequirements: string, userInteractions: string, edgeCases: string, dependencies: string, functionalRequirements: Array<{ __typename?: 'FunctionalRequirement', id: string, title: string, description: string, acceptanceCriteria: Array<string> }> }, previousContent: { __typename?: 'SpecificationContent', overview: string, businessRuleIds: Array<string>, dataRequirements: string, userInteractions: string, edgeCases: string, dependencies: string, functionalRequirements: Array<{ __typename?: 'FunctionalRequirement', id: string, title: string, description: string, acceptanceCriteria: Array<string> }> } | null | undefined, businessRules: Array<{ __typename?: 'BusinessRule', id: string, specificationId: string, ruleNumber: number, formattedNumber: string, fullIdentifier: string, statement: string, rationale: string, examples: string | null | undefined, createdAt: string, updatedAt: string }> } | null | undefined };

export type GetBusinessRulesQueryVariables = Exact<{
  specificationId: Scalars['ID']['input'];
}>;


export type GetBusinessRulesQuery = { __typename?: 'Query', businessRules: Array<{ __typename?: 'BusinessRule', id: string, specificationId: string, ruleNumber: number, formattedNumber: string, fullIdentifier: string, statement: string, rationale: string, examples: string | null | undefined, createdAt: string, updatedAt: string }> };

export type GetSpecificationDiffQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetSpecificationDiffQuery = { __typename?: 'Query', specificationDiff: { __typename?: 'SpecificationDiff', hasChanges: boolean, overview: { __typename?: 'TextDiff', changeType: DiffChangeType, previousValue: string | null | undefined, currentValue: string | null | undefined }, functionalRequirements: Array<{ __typename?: 'FunctionalRequirementDiff', id: string, changeType: DiffChangeType, previous: { __typename?: 'FunctionalRequirement', id: string, title: string, description: string, acceptanceCriteria: Array<string> } | null | undefined, current: { __typename?: 'FunctionalRequirement', id: string, title: string, description: string, acceptanceCriteria: Array<string> } | null | undefined }>, businessRuleIds: { __typename?: 'BusinessRuleIdsDiff', added: Array<string>, removed: Array<string> }, dataRequirements: { __typename?: 'TextDiff', changeType: DiffChangeType, previousValue: string | null | undefined, currentValue: string | null | undefined }, userInteractions: { __typename?: 'TextDiff', changeType: DiffChangeType, previousValue: string | null | undefined, currentValue: string | null | undefined }, edgeCases: { __typename?: 'TextDiff', changeType: DiffChangeType, previousValue: string | null | undefined, currentValue: string | null | undefined }, dependencies: { __typename?: 'TextDiff', changeType: DiffChangeType, previousValue: string | null | undefined, currentValue: string | null | undefined } } };

export const ConversationMessageFieldsFragmentDoc = gql`
    fragment ConversationMessageFields on ConversationMessage {
  id
  conversationId
  senderType
  content
  createdAt
  referencedArtifacts {
    type
    id
  }
  agentInvocations {
    agentType
    launchedAt
    completedAt
    status
  }
}
    `;
export const ConversationFieldsFragmentDoc = gql`
    fragment ConversationFields on Conversation {
  id
  projectId
  status
  createdAt
  lastActivityAt
}
    `;
export const KanbanTicketFieldsFragmentDoc = gql`
    fragment KanbanTicketFields on KanbanTicket {
  id
  type
  title
  column
  lifecycleState
  parentId
  children {
    id
    text
  }
  specReferences
  acceptanceCriteria
  description
  context
  validationFeedback {
    agentType
    status
    feedback
    timestamp
  }
}
    `;
export const ProjectControlStateFieldsFragmentDoc = gql`
    fragment ProjectControlStateFields on Project {
  id
  pmValidated
  poValidated
  controlState
}
    `;
export const JsonPatchFieldsFragmentDoc = gql`
    fragment JSONPatchFields on JSONPatchOperation {
  op
  path
  value
}
    `;
export const ProjectLifecycleFieldsFragmentDoc = gql`
    fragment ProjectLifecycleFields on Project {
  id
  lifecycleState
  controlState
}
    `;
export const ProjectDeletionFieldsFragmentDoc = gql`
    fragment ProjectDeletionFields on Project {
  id
  lifecycleState
  deletionRequestedAt
  scheduledDestructionDate
}
    `;
export const SpecificationListItemFieldsFragmentDoc = gql`
    fragment SpecificationListItemFields on Specification {
  id
  projectId
  specificationNumber
  formattedNumber
  title
  status
  createdAt
  updatedAt
}
    `;
export const FunctionalRequirementFieldsFragmentDoc = gql`
    fragment FunctionalRequirementFields on FunctionalRequirement {
  id
  title
  description
  acceptanceCriteria
}
    `;
export const SpecificationContentFieldsFragmentDoc = gql`
    fragment SpecificationContentFields on SpecificationContent {
  overview
  functionalRequirements {
    ...FunctionalRequirementFields
  }
  businessRuleIds
  dataRequirements
  userInteractions
  edgeCases
  dependencies
}
    ${FunctionalRequirementFieldsFragmentDoc}`;
export const BusinessRuleFieldsFragmentDoc = gql`
    fragment BusinessRuleFields on BusinessRule {
  id
  specificationId
  ruleNumber
  formattedNumber
  fullIdentifier
  statement
  rationale
  examples
  createdAt
  updatedAt
}
    `;
export const SpecificationDetailFieldsFragmentDoc = gql`
    fragment SpecificationDetailFields on Specification {
  id
  projectId
  specificationNumber
  formattedNumber
  title
  status
  content {
    ...SpecificationContentFields
  }
  previousContent {
    ...SpecificationContentFields
  }
  businessRules {
    ...BusinessRuleFields
  }
  originatingConversationId
  createdAt
  updatedAt
}
    ${SpecificationContentFieldsFragmentDoc}
${BusinessRuleFieldsFragmentDoc}`;
export const MeDocument = gql`
    query Me {
  me {
    id
    email
    displayName
    roles
    primaryDashboard
    avatarUrl
    hasPassword
    createdAt
  }
}
    `;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, options);
      }
export function useMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
// @ts-ignore
export function useMeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MeQuery, MeQueryVariables>): Apollo.UseSuspenseQueryResult<MeQuery, MeQueryVariables>;
export function useMeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MeQuery, MeQueryVariables>): Apollo.UseSuspenseQueryResult<MeQuery | undefined, MeQueryVariables>;
export function useMeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeSuspenseQueryHookResult = ReturnType<typeof useMeSuspenseQuery>;
export const LoginDocument = gql`
    mutation Login($input: LoginInput!) {
  login(input: $input) {
    user {
      id
      email
      displayName
      roles
      primaryDashboard
      createdAt
    }
    expiresAt
    sessionToken
  }
}
    `;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const RegisterProductOwnerDocument = gql`
    mutation RegisterProductOwner($input: RegisterPOInput!) {
  registerProductOwner(input: $input) {
    user {
      id
      email
      displayName
      roles
      primaryDashboard
      createdAt
    }
    tenant {
      id
    }
    redirectTo
    sessionToken
  }
}
    `;
export type RegisterProductOwnerMutationFn = Apollo.MutationFunction<RegisterProductOwnerMutation, RegisterProductOwnerMutationVariables>;

/**
 * __useRegisterProductOwnerMutation__
 *
 * To run a mutation, you first call `useRegisterProductOwnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterProductOwnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerProductOwnerMutation, { data, loading, error }] = useRegisterProductOwnerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterProductOwnerMutation(baseOptions?: Apollo.MutationHookOptions<RegisterProductOwnerMutation, RegisterProductOwnerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterProductOwnerMutation, RegisterProductOwnerMutationVariables>(RegisterProductOwnerDocument, options);
      }
export type RegisterProductOwnerMutationHookResult = ReturnType<typeof useRegisterProductOwnerMutation>;
export type RegisterProductOwnerMutationOptions = Apollo.BaseMutationOptions<RegisterProductOwnerMutation, RegisterProductOwnerMutationVariables>;
export const LogoutDocument = gql`
    mutation Logout {
  logout
}
    `;
export type LogoutMutationFn = Apollo.MutationFunction<LogoutMutation, LogoutMutationVariables>;

/**
 * __useLogoutMutation__
 *
 * To run a mutation, you first call `useLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutMutation, { data, loading, error }] = useLogoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useLogoutMutation(baseOptions?: Apollo.MutationHookOptions<LogoutMutation, LogoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogoutMutation, LogoutMutationVariables>(LogoutDocument, options);
      }
export type LogoutMutationHookResult = ReturnType<typeof useLogoutMutation>;
export type LogoutMutationOptions = Apollo.BaseMutationOptions<LogoutMutation, LogoutMutationVariables>;
export const SetPasswordDocument = gql`
    mutation SetPassword($input: SetPasswordInput!) {
  setPassword(input: $input)
}
    `;
export type SetPasswordMutationFn = Apollo.MutationFunction<SetPasswordMutation, SetPasswordMutationVariables>;

/**
 * __useSetPasswordMutation__
 *
 * To run a mutation, you first call `useSetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPasswordMutation, { data, loading, error }] = useSetPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<SetPasswordMutation, SetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetPasswordMutation, SetPasswordMutationVariables>(SetPasswordDocument, options);
      }
export type SetPasswordMutationHookResult = ReturnType<typeof useSetPasswordMutation>;
export type SetPasswordMutationOptions = Apollo.BaseMutationOptions<SetPasswordMutation, SetPasswordMutationVariables>;
export const ChangePasswordDocument = gql`
    mutation ChangePassword($input: ChangePasswordInput!) {
  changePassword(input: $input)
}
    `;
export type ChangePasswordMutationFn = Apollo.MutationFunction<ChangePasswordMutation, ChangePasswordMutationVariables>;

/**
 * __useChangePasswordMutation__
 *
 * To run a mutation, you first call `useChangePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changePasswordMutation, { data, loading, error }] = useChangePasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangePasswordMutation(baseOptions?: Apollo.MutationHookOptions<ChangePasswordMutation, ChangePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangePasswordMutation, ChangePasswordMutationVariables>(ChangePasswordDocument, options);
      }
export type ChangePasswordMutationHookResult = ReturnType<typeof useChangePasswordMutation>;
export type ChangePasswordMutationOptions = Apollo.BaseMutationOptions<ChangePasswordMutation, ChangePasswordMutationVariables>;
export const VerifyPasswordDocument = gql`
    mutation VerifyPassword($input: VerifyPasswordInput!) {
  verifyPassword(input: $input)
}
    `;
export type VerifyPasswordMutationFn = Apollo.MutationFunction<VerifyPasswordMutation, VerifyPasswordMutationVariables>;

/**
 * __useVerifyPasswordMutation__
 *
 * To run a mutation, you first call `useVerifyPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyPasswordMutation, { data, loading, error }] = useVerifyPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVerifyPasswordMutation(baseOptions?: Apollo.MutationHookOptions<VerifyPasswordMutation, VerifyPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyPasswordMutation, VerifyPasswordMutationVariables>(VerifyPasswordDocument, options);
      }
export type VerifyPasswordMutationHookResult = ReturnType<typeof useVerifyPasswordMutation>;
export type VerifyPasswordMutationOptions = Apollo.BaseMutationOptions<VerifyPasswordMutation, VerifyPasswordMutationVariables>;
export const GetProjectConversationsDocument = gql`
    query GetProjectConversations($projectId: ID!) {
  conversations(projectId: $projectId) {
    ...ConversationFields
  }
}
    ${ConversationFieldsFragmentDoc}`;

/**
 * __useGetProjectConversationsQuery__
 *
 * To run a query within a React component, call `useGetProjectConversationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectConversationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectConversationsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetProjectConversationsQuery(baseOptions: Apollo.QueryHookOptions<GetProjectConversationsQuery, GetProjectConversationsQueryVariables> & ({ variables: GetProjectConversationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectConversationsQuery, GetProjectConversationsQueryVariables>(GetProjectConversationsDocument, options);
      }
export function useGetProjectConversationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectConversationsQuery, GetProjectConversationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectConversationsQuery, GetProjectConversationsQueryVariables>(GetProjectConversationsDocument, options);
        }
// @ts-ignore
export function useGetProjectConversationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProjectConversationsQuery, GetProjectConversationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetProjectConversationsQuery, GetProjectConversationsQueryVariables>;
export function useGetProjectConversationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProjectConversationsQuery, GetProjectConversationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetProjectConversationsQuery | undefined, GetProjectConversationsQueryVariables>;
export function useGetProjectConversationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProjectConversationsQuery, GetProjectConversationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProjectConversationsQuery, GetProjectConversationsQueryVariables>(GetProjectConversationsDocument, options);
        }
export type GetProjectConversationsQueryHookResult = ReturnType<typeof useGetProjectConversationsQuery>;
export type GetProjectConversationsLazyQueryHookResult = ReturnType<typeof useGetProjectConversationsLazyQuery>;
export type GetProjectConversationsSuspenseQueryHookResult = ReturnType<typeof useGetProjectConversationsSuspenseQuery>;
export const GetConversationDocument = gql`
    query GetConversation($id: ID!, $limit: Int, $after: ID) {
  conversation(id: $id) {
    ...ConversationFields
    messages(limit: $limit, after: $after) {
      ...ConversationMessageFields
    }
  }
}
    ${ConversationFieldsFragmentDoc}
${ConversationMessageFieldsFragmentDoc}`;

/**
 * __useGetConversationQuery__
 *
 * To run a query within a React component, call `useGetConversationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConversationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConversationQuery({
 *   variables: {
 *      id: // value for 'id'
 *      limit: // value for 'limit'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetConversationQuery(baseOptions: Apollo.QueryHookOptions<GetConversationQuery, GetConversationQueryVariables> & ({ variables: GetConversationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConversationQuery, GetConversationQueryVariables>(GetConversationDocument, options);
      }
export function useGetConversationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConversationQuery, GetConversationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConversationQuery, GetConversationQueryVariables>(GetConversationDocument, options);
        }
// @ts-ignore
export function useGetConversationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetConversationQuery, GetConversationQueryVariables>): Apollo.UseSuspenseQueryResult<GetConversationQuery, GetConversationQueryVariables>;
export function useGetConversationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetConversationQuery, GetConversationQueryVariables>): Apollo.UseSuspenseQueryResult<GetConversationQuery | undefined, GetConversationQueryVariables>;
export function useGetConversationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetConversationQuery, GetConversationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetConversationQuery, GetConversationQueryVariables>(GetConversationDocument, options);
        }
export type GetConversationQueryHookResult = ReturnType<typeof useGetConversationQuery>;
export type GetConversationLazyQueryHookResult = ReturnType<typeof useGetConversationLazyQuery>;
export type GetConversationSuspenseQueryHookResult = ReturnType<typeof useGetConversationSuspenseQuery>;
export const SendMessageDocument = gql`
    mutation SendMessage($conversationId: ID!, $input: SendMessageInput!) {
  sendMessage(conversationId: $conversationId, input: $input) {
    ...ConversationMessageFields
  }
}
    ${ConversationMessageFieldsFragmentDoc}`;
export type SendMessageMutationFn = Apollo.MutationFunction<SendMessageMutation, SendMessageMutationVariables>;

/**
 * __useSendMessageMutation__
 *
 * To run a mutation, you first call `useSendMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendMessageMutation, { data, loading, error }] = useSendMessageMutation({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendMessageMutation(baseOptions?: Apollo.MutationHookOptions<SendMessageMutation, SendMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendMessageMutation, SendMessageMutationVariables>(SendMessageDocument, options);
      }
export type SendMessageMutationHookResult = ReturnType<typeof useSendMessageMutation>;
export type SendMessageMutationOptions = Apollo.BaseMutationOptions<SendMessageMutation, SendMessageMutationVariables>;
export const MessageReceivedDocument = gql`
    subscription MessageReceived($conversationId: ID!) {
  messageReceived(conversationId: $conversationId) {
    ...ConversationMessageFields
  }
}
    ${ConversationMessageFieldsFragmentDoc}`;

/**
 * __useMessageReceivedSubscription__
 *
 * To run a query within a React component, call `useMessageReceivedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useMessageReceivedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageReceivedSubscription({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *   },
 * });
 */
export function useMessageReceivedSubscription(baseOptions: Apollo.SubscriptionHookOptions<MessageReceivedSubscription, MessageReceivedSubscriptionVariables> & ({ variables: MessageReceivedSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<MessageReceivedSubscription, MessageReceivedSubscriptionVariables>(MessageReceivedDocument, options);
      }
export type MessageReceivedSubscriptionHookResult = ReturnType<typeof useMessageReceivedSubscription>;
export const KanbanStateDocument = gql`
    query KanbanState($projectId: ID!) {
  kanbanState(projectId: $projectId) {
    tickets {
      ...KanbanTicketFields
    }
    parentColumns {
      ticketId
      column
    }
    validationStatuses {
      ticketId
      status
    }
    ticketsByColumn {
      column
      tickets {
        ...KanbanTicketFields
      }
    }
  }
}
    ${KanbanTicketFieldsFragmentDoc}`;

/**
 * __useKanbanStateQuery__
 *
 * To run a query within a React component, call `useKanbanStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useKanbanStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKanbanStateQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useKanbanStateQuery(baseOptions: Apollo.QueryHookOptions<KanbanStateQuery, KanbanStateQueryVariables> & ({ variables: KanbanStateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KanbanStateQuery, KanbanStateQueryVariables>(KanbanStateDocument, options);
      }
export function useKanbanStateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KanbanStateQuery, KanbanStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KanbanStateQuery, KanbanStateQueryVariables>(KanbanStateDocument, options);
        }
// @ts-ignore
export function useKanbanStateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<KanbanStateQuery, KanbanStateQueryVariables>): Apollo.UseSuspenseQueryResult<KanbanStateQuery, KanbanStateQueryVariables>;
export function useKanbanStateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<KanbanStateQuery, KanbanStateQueryVariables>): Apollo.UseSuspenseQueryResult<KanbanStateQuery | undefined, KanbanStateQueryVariables>;
export function useKanbanStateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<KanbanStateQuery, KanbanStateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<KanbanStateQuery, KanbanStateQueryVariables>(KanbanStateDocument, options);
        }
export type KanbanStateQueryHookResult = ReturnType<typeof useKanbanStateQuery>;
export type KanbanStateLazyQueryHookResult = ReturnType<typeof useKanbanStateLazyQuery>;
export type KanbanStateSuspenseQueryHookResult = ReturnType<typeof useKanbanStateSuspenseQuery>;
export const KanbanStateChangedDocument = gql`
    subscription KanbanStateChanged($projectId: ID!) {
  kanbanStateChanged(projectId: $projectId) {
    tickets {
      ...KanbanTicketFields
    }
    parentColumns {
      ticketId
      column
    }
    validationStatuses {
      ticketId
      status
    }
    ticketsByColumn {
      column
      tickets {
        ...KanbanTicketFields
      }
    }
  }
}
    ${KanbanTicketFieldsFragmentDoc}`;

/**
 * __useKanbanStateChangedSubscription__
 *
 * To run a query within a React component, call `useKanbanStateChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useKanbanStateChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKanbanStateChangedSubscription({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useKanbanStateChangedSubscription(baseOptions: Apollo.SubscriptionHookOptions<KanbanStateChangedSubscription, KanbanStateChangedSubscriptionVariables> & ({ variables: KanbanStateChangedSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<KanbanStateChangedSubscription, KanbanStateChangedSubscriptionVariables>(KanbanStateChangedDocument, options);
      }
export type KanbanStateChangedSubscriptionHookResult = ReturnType<typeof useKanbanStateChangedSubscription>;
export const MoveTicketDocument = gql`
    mutation MoveTicket($projectId: String!, $ticketId: String!, $toColumn: KanbanColumn!) {
  moveTicket(projectId: $projectId, ticketId: $ticketId, toColumn: $toColumn) {
    success
    rejection {
      reason
      details
    }
    errorType
    state {
      tickets {
        ...KanbanTicketFields
      }
      parentColumns {
        ticketId
        column
      }
      validationStatuses {
        ticketId
        status
      }
      ticketsByColumn {
        column
        tickets {
          ...KanbanTicketFields
        }
      }
    }
  }
}
    ${KanbanTicketFieldsFragmentDoc}`;
export type MoveTicketMutationFn = Apollo.MutationFunction<MoveTicketMutation, MoveTicketMutationVariables>;

/**
 * __useMoveTicketMutation__
 *
 * To run a mutation, you first call `useMoveTicketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveTicketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveTicketMutation, { data, loading, error }] = useMoveTicketMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      ticketId: // value for 'ticketId'
 *      toColumn: // value for 'toColumn'
 *   },
 * });
 */
export function useMoveTicketMutation(baseOptions?: Apollo.MutationHookOptions<MoveTicketMutation, MoveTicketMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MoveTicketMutation, MoveTicketMutationVariables>(MoveTicketDocument, options);
      }
export type MoveTicketMutationHookResult = ReturnType<typeof useMoveTicketMutation>;
export type MoveTicketMutationOptions = Apollo.BaseMutationOptions<MoveTicketMutation, MoveTicketMutationVariables>;
export const SubmitValidationFeedbackDocument = gql`
    mutation SubmitValidationFeedback($projectId: String!, $ticketId: String!, $feedback: ValidationFeedbackInput!) {
  submitValidationFeedback(
    projectId: $projectId
    ticketId: $ticketId
    feedback: $feedback
  ) {
    success
    rejection {
      reason
      details
    }
    errorType
    state {
      tickets {
        ...KanbanTicketFields
      }
      parentColumns {
        ticketId
        column
      }
      validationStatuses {
        ticketId
        status
      }
      ticketsByColumn {
        column
        tickets {
          ...KanbanTicketFields
        }
      }
    }
  }
}
    ${KanbanTicketFieldsFragmentDoc}`;
export type SubmitValidationFeedbackMutationFn = Apollo.MutationFunction<SubmitValidationFeedbackMutation, SubmitValidationFeedbackMutationVariables>;

/**
 * __useSubmitValidationFeedbackMutation__
 *
 * To run a mutation, you first call `useSubmitValidationFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitValidationFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitValidationFeedbackMutation, { data, loading, error }] = useSubmitValidationFeedbackMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      ticketId: // value for 'ticketId'
 *      feedback: // value for 'feedback'
 *   },
 * });
 */
export function useSubmitValidationFeedbackMutation(baseOptions?: Apollo.MutationHookOptions<SubmitValidationFeedbackMutation, SubmitValidationFeedbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitValidationFeedbackMutation, SubmitValidationFeedbackMutationVariables>(SubmitValidationFeedbackDocument, options);
      }
export type SubmitValidationFeedbackMutationHookResult = ReturnType<typeof useSubmitValidationFeedbackMutation>;
export type SubmitValidationFeedbackMutationOptions = Apollo.BaseMutationOptions<SubmitValidationFeedbackMutation, SubmitValidationFeedbackMutationVariables>;
export const CreateProjectDocument = gql`
    mutation CreateProject($input: CreateProjectInput!) {
  createProject(input: $input) {
    id
    title
    description
    lifecycleState
    controlState
    createdAt
  }
}
    `;
export type CreateProjectMutationFn = Apollo.MutationFunction<CreateProjectMutation, CreateProjectMutationVariables>;

/**
 * __useCreateProjectMutation__
 *
 * To run a mutation, you first call `useCreateProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectMutation, { data, loading, error }] = useCreateProjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProjectMutation(baseOptions?: Apollo.MutationHookOptions<CreateProjectMutation, CreateProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProjectMutation, CreateProjectMutationVariables>(CreateProjectDocument, options);
      }
export type CreateProjectMutationHookResult = ReturnType<typeof useCreateProjectMutation>;
export type CreateProjectMutationOptions = Apollo.BaseMutationOptions<CreateProjectMutation, CreateProjectMutationVariables>;
export const MyProjectsDocument = gql`
    query MyProjects {
  myProjects {
    id
    title
    description
    tier
    lifecycleState
    controlState
    createdAt
  }
}
    `;

/**
 * __useMyProjectsQuery__
 *
 * To run a query within a React component, call `useMyProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyProjectsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyProjectsQuery(baseOptions?: Apollo.QueryHookOptions<MyProjectsQuery, MyProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyProjectsQuery, MyProjectsQueryVariables>(MyProjectsDocument, options);
      }
export function useMyProjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyProjectsQuery, MyProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyProjectsQuery, MyProjectsQueryVariables>(MyProjectsDocument, options);
        }
// @ts-ignore
export function useMyProjectsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MyProjectsQuery, MyProjectsQueryVariables>): Apollo.UseSuspenseQueryResult<MyProjectsQuery, MyProjectsQueryVariables>;
export function useMyProjectsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyProjectsQuery, MyProjectsQueryVariables>): Apollo.UseSuspenseQueryResult<MyProjectsQuery | undefined, MyProjectsQueryVariables>;
export function useMyProjectsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyProjectsQuery, MyProjectsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyProjectsQuery, MyProjectsQueryVariables>(MyProjectsDocument, options);
        }
export type MyProjectsQueryHookResult = ReturnType<typeof useMyProjectsQuery>;
export type MyProjectsLazyQueryHookResult = ReturnType<typeof useMyProjectsLazyQuery>;
export type MyProjectsSuspenseQueryHookResult = ReturnType<typeof useMyProjectsSuspenseQuery>;
export const GetProjectDocument = gql`
    query GetProject($id: ID!) {
  project(id: $id) {
    id
    title
    description
    tier
    lifecycleState
    controlState
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetProjectQuery__
 *
 * To run a query within a React component, call `useGetProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProjectQuery(baseOptions: Apollo.QueryHookOptions<GetProjectQuery, GetProjectQueryVariables> & ({ variables: GetProjectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectQuery, GetProjectQueryVariables>(GetProjectDocument, options);
      }
export function useGetProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectQuery, GetProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectQuery, GetProjectQueryVariables>(GetProjectDocument, options);
        }
// @ts-ignore
export function useGetProjectSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProjectQuery, GetProjectQueryVariables>): Apollo.UseSuspenseQueryResult<GetProjectQuery, GetProjectQueryVariables>;
export function useGetProjectSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProjectQuery, GetProjectQueryVariables>): Apollo.UseSuspenseQueryResult<GetProjectQuery | undefined, GetProjectQueryVariables>;
export function useGetProjectSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProjectQuery, GetProjectQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProjectQuery, GetProjectQueryVariables>(GetProjectDocument, options);
        }
export type GetProjectQueryHookResult = ReturnType<typeof useGetProjectQuery>;
export type GetProjectLazyQueryHookResult = ReturnType<typeof useGetProjectLazyQuery>;
export type GetProjectSuspenseQueryHookResult = ReturnType<typeof useGetProjectSuspenseQuery>;
export const UpdateProjectDocument = gql`
    mutation UpdateProject($id: ID!, $input: UpdateProjectInput!) {
  updateProject(id: $id, input: $input) {
    id
    title
    description
    lifecycleState
    controlState
    updatedAt
  }
}
    `;
export type UpdateProjectMutationFn = Apollo.MutationFunction<UpdateProjectMutation, UpdateProjectMutationVariables>;

/**
 * __useUpdateProjectMutation__
 *
 * To run a mutation, you first call `useUpdateProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectMutation, { data, loading, error }] = useUpdateProjectMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProjectMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProjectMutation, UpdateProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProjectMutation, UpdateProjectMutationVariables>(UpdateProjectDocument, options);
      }
export type UpdateProjectMutationHookResult = ReturnType<typeof useUpdateProjectMutation>;
export type UpdateProjectMutationOptions = Apollo.BaseMutationOptions<UpdateProjectMutation, UpdateProjectMutationVariables>;
export const EnterDraftModeDocument = gql`
    mutation EnterDraftMode($projectId: ID!) {
  enterDraftMode(projectId: $projectId) {
    project {
      ...ProjectControlStateFields
    }
    patch {
      ...JSONPatchFields
    }
  }
}
    ${ProjectControlStateFieldsFragmentDoc}
${JsonPatchFieldsFragmentDoc}`;
export type EnterDraftModeMutationFn = Apollo.MutationFunction<EnterDraftModeMutation, EnterDraftModeMutationVariables>;

/**
 * __useEnterDraftModeMutation__
 *
 * To run a mutation, you first call `useEnterDraftModeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnterDraftModeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enterDraftModeMutation, { data, loading, error }] = useEnterDraftModeMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useEnterDraftModeMutation(baseOptions?: Apollo.MutationHookOptions<EnterDraftModeMutation, EnterDraftModeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnterDraftModeMutation, EnterDraftModeMutationVariables>(EnterDraftModeDocument, options);
      }
export type EnterDraftModeMutationHookResult = ReturnType<typeof useEnterDraftModeMutation>;
export type EnterDraftModeMutationOptions = Apollo.BaseMutationOptions<EnterDraftModeMutation, EnterDraftModeMutationVariables>;
export const ValidateAsPmDocument = gql`
    mutation ValidateAsPm($projectId: ID!) {
  validateAsPm(projectId: $projectId) {
    project {
      ...ProjectControlStateFields
    }
    patch {
      ...JSONPatchFields
    }
  }
}
    ${ProjectControlStateFieldsFragmentDoc}
${JsonPatchFieldsFragmentDoc}`;
export type ValidateAsPmMutationFn = Apollo.MutationFunction<ValidateAsPmMutation, ValidateAsPmMutationVariables>;

/**
 * __useValidateAsPmMutation__
 *
 * To run a mutation, you first call `useValidateAsPmMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateAsPmMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateAsPmMutation, { data, loading, error }] = useValidateAsPmMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useValidateAsPmMutation(baseOptions?: Apollo.MutationHookOptions<ValidateAsPmMutation, ValidateAsPmMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ValidateAsPmMutation, ValidateAsPmMutationVariables>(ValidateAsPmDocument, options);
      }
export type ValidateAsPmMutationHookResult = ReturnType<typeof useValidateAsPmMutation>;
export type ValidateAsPmMutationOptions = Apollo.BaseMutationOptions<ValidateAsPmMutation, ValidateAsPmMutationVariables>;
export const ValidateAsPoDocument = gql`
    mutation ValidateAsPo($projectId: ID!) {
  validateAsPo(projectId: $projectId) {
    project {
      ...ProjectControlStateFields
    }
    patch {
      ...JSONPatchFields
    }
  }
}
    ${ProjectControlStateFieldsFragmentDoc}
${JsonPatchFieldsFragmentDoc}`;
export type ValidateAsPoMutationFn = Apollo.MutationFunction<ValidateAsPoMutation, ValidateAsPoMutationVariables>;

/**
 * __useValidateAsPoMutation__
 *
 * To run a mutation, you first call `useValidateAsPoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateAsPoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateAsPoMutation, { data, loading, error }] = useValidateAsPoMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useValidateAsPoMutation(baseOptions?: Apollo.MutationHookOptions<ValidateAsPoMutation, ValidateAsPoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ValidateAsPoMutation, ValidateAsPoMutationVariables>(ValidateAsPoDocument, options);
      }
export type ValidateAsPoMutationHookResult = ReturnType<typeof useValidateAsPoMutation>;
export type ValidateAsPoMutationOptions = Apollo.BaseMutationOptions<ValidateAsPoMutation, ValidateAsPoMutationVariables>;
export const RejectChangesDocument = gql`
    mutation RejectChanges($projectId: ID!) {
  rejectChanges(projectId: $projectId) {
    project {
      ...ProjectControlStateFields
    }
    patch {
      ...JSONPatchFields
    }
  }
}
    ${ProjectControlStateFieldsFragmentDoc}
${JsonPatchFieldsFragmentDoc}`;
export type RejectChangesMutationFn = Apollo.MutationFunction<RejectChangesMutation, RejectChangesMutationVariables>;

/**
 * __useRejectChangesMutation__
 *
 * To run a mutation, you first call `useRejectChangesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectChangesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectChangesMutation, { data, loading, error }] = useRejectChangesMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useRejectChangesMutation(baseOptions?: Apollo.MutationHookOptions<RejectChangesMutation, RejectChangesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RejectChangesMutation, RejectChangesMutationVariables>(RejectChangesDocument, options);
      }
export type RejectChangesMutationHookResult = ReturnType<typeof useRejectChangesMutation>;
export type RejectChangesMutationOptions = Apollo.BaseMutationOptions<RejectChangesMutation, RejectChangesMutationVariables>;
export const DiscardDraftChangesDocument = gql`
    mutation DiscardDraftChanges($projectId: ID!) {
  discardDraftChanges(projectId: $projectId) {
    project {
      ...ProjectControlStateFields
    }
    patch {
      ...JSONPatchFields
    }
  }
}
    ${ProjectControlStateFieldsFragmentDoc}
${JsonPatchFieldsFragmentDoc}`;
export type DiscardDraftChangesMutationFn = Apollo.MutationFunction<DiscardDraftChangesMutation, DiscardDraftChangesMutationVariables>;

/**
 * __useDiscardDraftChangesMutation__
 *
 * To run a mutation, you first call `useDiscardDraftChangesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDiscardDraftChangesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [discardDraftChangesMutation, { data, loading, error }] = useDiscardDraftChangesMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useDiscardDraftChangesMutation(baseOptions?: Apollo.MutationHookOptions<DiscardDraftChangesMutation, DiscardDraftChangesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DiscardDraftChangesMutation, DiscardDraftChangesMutationVariables>(DiscardDraftChangesDocument, options);
      }
export type DiscardDraftChangesMutationHookResult = ReturnType<typeof useDiscardDraftChangesMutation>;
export type DiscardDraftChangesMutationOptions = Apollo.BaseMutationOptions<DiscardDraftChangesMutation, DiscardDraftChangesMutationVariables>;
export const ProjectPatchSubscriptionDocument = gql`
    subscription ProjectPatchSubscription($projectId: ID!) {
  projectPatch(projectId: $projectId) {
    project {
      ...ProjectControlStateFields
    }
    patch {
      ...JSONPatchFields
    }
  }
}
    ${ProjectControlStateFieldsFragmentDoc}
${JsonPatchFieldsFragmentDoc}`;

/**
 * __useProjectPatchSubscriptionSubscription__
 *
 * To run a query within a React component, call `useProjectPatchSubscriptionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useProjectPatchSubscriptionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectPatchSubscriptionSubscription({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useProjectPatchSubscriptionSubscription(baseOptions: Apollo.SubscriptionHookOptions<ProjectPatchSubscriptionSubscription, ProjectPatchSubscriptionSubscriptionVariables> & ({ variables: ProjectPatchSubscriptionSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ProjectPatchSubscriptionSubscription, ProjectPatchSubscriptionSubscriptionVariables>(ProjectPatchSubscriptionDocument, options);
      }
export type ProjectPatchSubscriptionSubscriptionHookResult = ReturnType<typeof useProjectPatchSubscriptionSubscription>;
export const ArchiveProjectDocument = gql`
    mutation ArchiveProject($projectId: ID!) {
  archiveProject(projectId: $projectId) {
    project {
      ...ProjectLifecycleFields
    }
    patch {
      ...JSONPatchFields
    }
  }
}
    ${ProjectLifecycleFieldsFragmentDoc}
${JsonPatchFieldsFragmentDoc}`;
export type ArchiveProjectMutationFn = Apollo.MutationFunction<ArchiveProjectMutation, ArchiveProjectMutationVariables>;

/**
 * __useArchiveProjectMutation__
 *
 * To run a mutation, you first call `useArchiveProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveProjectMutation, { data, loading, error }] = useArchiveProjectMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useArchiveProjectMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveProjectMutation, ArchiveProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveProjectMutation, ArchiveProjectMutationVariables>(ArchiveProjectDocument, options);
      }
export type ArchiveProjectMutationHookResult = ReturnType<typeof useArchiveProjectMutation>;
export type ArchiveProjectMutationOptions = Apollo.BaseMutationOptions<ArchiveProjectMutation, ArchiveProjectMutationVariables>;
export const UnarchiveProjectDocument = gql`
    mutation UnarchiveProject($projectId: ID!) {
  unarchiveProject(projectId: $projectId) {
    project {
      ...ProjectLifecycleFields
    }
    patch {
      ...JSONPatchFields
    }
  }
}
    ${ProjectLifecycleFieldsFragmentDoc}
${JsonPatchFieldsFragmentDoc}`;
export type UnarchiveProjectMutationFn = Apollo.MutationFunction<UnarchiveProjectMutation, UnarchiveProjectMutationVariables>;

/**
 * __useUnarchiveProjectMutation__
 *
 * To run a mutation, you first call `useUnarchiveProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnarchiveProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unarchiveProjectMutation, { data, loading, error }] = useUnarchiveProjectMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useUnarchiveProjectMutation(baseOptions?: Apollo.MutationHookOptions<UnarchiveProjectMutation, UnarchiveProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnarchiveProjectMutation, UnarchiveProjectMutationVariables>(UnarchiveProjectDocument, options);
      }
export type UnarchiveProjectMutationHookResult = ReturnType<typeof useUnarchiveProjectMutation>;
export type UnarchiveProjectMutationOptions = Apollo.BaseMutationOptions<UnarchiveProjectMutation, UnarchiveProjectMutationVariables>;
export const DeleteProjectDocument = gql`
    mutation DeleteProject($projectId: ID!) {
  deleteProject(projectId: $projectId) {
    project {
      ...ProjectDeletionFields
    }
    patch {
      ...JSONPatchFields
    }
  }
}
    ${ProjectDeletionFieldsFragmentDoc}
${JsonPatchFieldsFragmentDoc}`;
export type DeleteProjectMutationFn = Apollo.MutationFunction<DeleteProjectMutation, DeleteProjectMutationVariables>;

/**
 * __useDeleteProjectMutation__
 *
 * To run a mutation, you first call `useDeleteProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProjectMutation, { data, loading, error }] = useDeleteProjectMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useDeleteProjectMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProjectMutation, DeleteProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProjectMutation, DeleteProjectMutationVariables>(DeleteProjectDocument, options);
      }
export type DeleteProjectMutationHookResult = ReturnType<typeof useDeleteProjectMutation>;
export type DeleteProjectMutationOptions = Apollo.BaseMutationOptions<DeleteProjectMutation, DeleteProjectMutationVariables>;
export const GetSpecificationsDocument = gql`
    query GetSpecifications($projectId: ID!) {
  specifications(projectId: $projectId) {
    ...SpecificationListItemFields
  }
}
    ${SpecificationListItemFieldsFragmentDoc}`;

/**
 * __useGetSpecificationsQuery__
 *
 * To run a query within a React component, call `useGetSpecificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSpecificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSpecificationsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetSpecificationsQuery(baseOptions: Apollo.QueryHookOptions<GetSpecificationsQuery, GetSpecificationsQueryVariables> & ({ variables: GetSpecificationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSpecificationsQuery, GetSpecificationsQueryVariables>(GetSpecificationsDocument, options);
      }
export function useGetSpecificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSpecificationsQuery, GetSpecificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSpecificationsQuery, GetSpecificationsQueryVariables>(GetSpecificationsDocument, options);
        }
// @ts-ignore
export function useGetSpecificationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSpecificationsQuery, GetSpecificationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetSpecificationsQuery, GetSpecificationsQueryVariables>;
export function useGetSpecificationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSpecificationsQuery, GetSpecificationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetSpecificationsQuery | undefined, GetSpecificationsQueryVariables>;
export function useGetSpecificationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSpecificationsQuery, GetSpecificationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSpecificationsQuery, GetSpecificationsQueryVariables>(GetSpecificationsDocument, options);
        }
export type GetSpecificationsQueryHookResult = ReturnType<typeof useGetSpecificationsQuery>;
export type GetSpecificationsLazyQueryHookResult = ReturnType<typeof useGetSpecificationsLazyQuery>;
export type GetSpecificationsSuspenseQueryHookResult = ReturnType<typeof useGetSpecificationsSuspenseQuery>;
export const GetSpecificationDocument = gql`
    query GetSpecification($id: ID!) {
  specification(id: $id) {
    ...SpecificationDetailFields
  }
}
    ${SpecificationDetailFieldsFragmentDoc}`;

/**
 * __useGetSpecificationQuery__
 *
 * To run a query within a React component, call `useGetSpecificationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSpecificationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSpecificationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSpecificationQuery(baseOptions: Apollo.QueryHookOptions<GetSpecificationQuery, GetSpecificationQueryVariables> & ({ variables: GetSpecificationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSpecificationQuery, GetSpecificationQueryVariables>(GetSpecificationDocument, options);
      }
export function useGetSpecificationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSpecificationQuery, GetSpecificationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSpecificationQuery, GetSpecificationQueryVariables>(GetSpecificationDocument, options);
        }
// @ts-ignore
export function useGetSpecificationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSpecificationQuery, GetSpecificationQueryVariables>): Apollo.UseSuspenseQueryResult<GetSpecificationQuery, GetSpecificationQueryVariables>;
export function useGetSpecificationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSpecificationQuery, GetSpecificationQueryVariables>): Apollo.UseSuspenseQueryResult<GetSpecificationQuery | undefined, GetSpecificationQueryVariables>;
export function useGetSpecificationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSpecificationQuery, GetSpecificationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSpecificationQuery, GetSpecificationQueryVariables>(GetSpecificationDocument, options);
        }
export type GetSpecificationQueryHookResult = ReturnType<typeof useGetSpecificationQuery>;
export type GetSpecificationLazyQueryHookResult = ReturnType<typeof useGetSpecificationLazyQuery>;
export type GetSpecificationSuspenseQueryHookResult = ReturnType<typeof useGetSpecificationSuspenseQuery>;
export const GetSpecificationByNumberDocument = gql`
    query GetSpecificationByNumber($projectId: ID!, $specificationNumber: Int!) {
  specificationByNumber(
    projectId: $projectId
    specificationNumber: $specificationNumber
  ) {
    ...SpecificationDetailFields
  }
}
    ${SpecificationDetailFieldsFragmentDoc}`;

/**
 * __useGetSpecificationByNumberQuery__
 *
 * To run a query within a React component, call `useGetSpecificationByNumberQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSpecificationByNumberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSpecificationByNumberQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      specificationNumber: // value for 'specificationNumber'
 *   },
 * });
 */
export function useGetSpecificationByNumberQuery(baseOptions: Apollo.QueryHookOptions<GetSpecificationByNumberQuery, GetSpecificationByNumberQueryVariables> & ({ variables: GetSpecificationByNumberQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSpecificationByNumberQuery, GetSpecificationByNumberQueryVariables>(GetSpecificationByNumberDocument, options);
      }
export function useGetSpecificationByNumberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSpecificationByNumberQuery, GetSpecificationByNumberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSpecificationByNumberQuery, GetSpecificationByNumberQueryVariables>(GetSpecificationByNumberDocument, options);
        }
// @ts-ignore
export function useGetSpecificationByNumberSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSpecificationByNumberQuery, GetSpecificationByNumberQueryVariables>): Apollo.UseSuspenseQueryResult<GetSpecificationByNumberQuery, GetSpecificationByNumberQueryVariables>;
export function useGetSpecificationByNumberSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSpecificationByNumberQuery, GetSpecificationByNumberQueryVariables>): Apollo.UseSuspenseQueryResult<GetSpecificationByNumberQuery | undefined, GetSpecificationByNumberQueryVariables>;
export function useGetSpecificationByNumberSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSpecificationByNumberQuery, GetSpecificationByNumberQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSpecificationByNumberQuery, GetSpecificationByNumberQueryVariables>(GetSpecificationByNumberDocument, options);
        }
export type GetSpecificationByNumberQueryHookResult = ReturnType<typeof useGetSpecificationByNumberQuery>;
export type GetSpecificationByNumberLazyQueryHookResult = ReturnType<typeof useGetSpecificationByNumberLazyQuery>;
export type GetSpecificationByNumberSuspenseQueryHookResult = ReturnType<typeof useGetSpecificationByNumberSuspenseQuery>;
export const GetBusinessRulesDocument = gql`
    query GetBusinessRules($specificationId: ID!) {
  businessRules(specificationId: $specificationId) {
    ...BusinessRuleFields
  }
}
    ${BusinessRuleFieldsFragmentDoc}`;

/**
 * __useGetBusinessRulesQuery__
 *
 * To run a query within a React component, call `useGetBusinessRulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBusinessRulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBusinessRulesQuery({
 *   variables: {
 *      specificationId: // value for 'specificationId'
 *   },
 * });
 */
export function useGetBusinessRulesQuery(baseOptions: Apollo.QueryHookOptions<GetBusinessRulesQuery, GetBusinessRulesQueryVariables> & ({ variables: GetBusinessRulesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBusinessRulesQuery, GetBusinessRulesQueryVariables>(GetBusinessRulesDocument, options);
      }
export function useGetBusinessRulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBusinessRulesQuery, GetBusinessRulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBusinessRulesQuery, GetBusinessRulesQueryVariables>(GetBusinessRulesDocument, options);
        }
// @ts-ignore
export function useGetBusinessRulesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBusinessRulesQuery, GetBusinessRulesQueryVariables>): Apollo.UseSuspenseQueryResult<GetBusinessRulesQuery, GetBusinessRulesQueryVariables>;
export function useGetBusinessRulesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBusinessRulesQuery, GetBusinessRulesQueryVariables>): Apollo.UseSuspenseQueryResult<GetBusinessRulesQuery | undefined, GetBusinessRulesQueryVariables>;
export function useGetBusinessRulesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBusinessRulesQuery, GetBusinessRulesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBusinessRulesQuery, GetBusinessRulesQueryVariables>(GetBusinessRulesDocument, options);
        }
export type GetBusinessRulesQueryHookResult = ReturnType<typeof useGetBusinessRulesQuery>;
export type GetBusinessRulesLazyQueryHookResult = ReturnType<typeof useGetBusinessRulesLazyQuery>;
export type GetBusinessRulesSuspenseQueryHookResult = ReturnType<typeof useGetBusinessRulesSuspenseQuery>;
export const GetSpecificationDiffDocument = gql`
    query GetSpecificationDiff($id: ID!) {
  specificationDiff(id: $id) {
    hasChanges
    overview {
      changeType
      previousValue
      currentValue
    }
    functionalRequirements {
      id
      changeType
      previous {
        ...FunctionalRequirementFields
      }
      current {
        ...FunctionalRequirementFields
      }
    }
    businessRuleIds {
      added
      removed
    }
    dataRequirements {
      changeType
      previousValue
      currentValue
    }
    userInteractions {
      changeType
      previousValue
      currentValue
    }
    edgeCases {
      changeType
      previousValue
      currentValue
    }
    dependencies {
      changeType
      previousValue
      currentValue
    }
  }
}
    ${FunctionalRequirementFieldsFragmentDoc}`;

/**
 * __useGetSpecificationDiffQuery__
 *
 * To run a query within a React component, call `useGetSpecificationDiffQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSpecificationDiffQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSpecificationDiffQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSpecificationDiffQuery(baseOptions: Apollo.QueryHookOptions<GetSpecificationDiffQuery, GetSpecificationDiffQueryVariables> & ({ variables: GetSpecificationDiffQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSpecificationDiffQuery, GetSpecificationDiffQueryVariables>(GetSpecificationDiffDocument, options);
      }
export function useGetSpecificationDiffLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSpecificationDiffQuery, GetSpecificationDiffQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSpecificationDiffQuery, GetSpecificationDiffQueryVariables>(GetSpecificationDiffDocument, options);
        }
// @ts-ignore
export function useGetSpecificationDiffSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSpecificationDiffQuery, GetSpecificationDiffQueryVariables>): Apollo.UseSuspenseQueryResult<GetSpecificationDiffQuery, GetSpecificationDiffQueryVariables>;
export function useGetSpecificationDiffSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSpecificationDiffQuery, GetSpecificationDiffQueryVariables>): Apollo.UseSuspenseQueryResult<GetSpecificationDiffQuery | undefined, GetSpecificationDiffQueryVariables>;
export function useGetSpecificationDiffSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSpecificationDiffQuery, GetSpecificationDiffQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSpecificationDiffQuery, GetSpecificationDiffQueryVariables>(GetSpecificationDiffDocument, options);
        }
export type GetSpecificationDiffQueryHookResult = ReturnType<typeof useGetSpecificationDiffQuery>;
export type GetSpecificationDiffLazyQueryHookResult = ReturnType<typeof useGetSpecificationDiffLazyQuery>;
export type GetSpecificationDiffSuspenseQueryHookResult = ReturnType<typeof useGetSpecificationDiffSuspenseQuery>;